(function () {
  const e = document.createElement("link").relList;
  if (e && e.supports && e.supports("modulepreload")) return;
  for (const i of document.querySelectorAll('link[rel="modulepreload"]')) r(i);
  new MutationObserver((i) => {
    for (const s of i)
      if (s.type === "childList")
        for (const o of s.addedNodes)
          o.tagName === "LINK" && o.rel === "modulepreload" && r(o);
  }).observe(document, { childList: !0, subtree: !0 });
  function n(i) {
    const s = {};
    return (
      i.integrity && (s.integrity = i.integrity),
      i.referrerPolicy && (s.referrerPolicy = i.referrerPolicy),
      i.crossOrigin === "use-credentials"
        ? (s.credentials = "include")
        : i.crossOrigin === "anonymous"
        ? (s.credentials = "omit")
        : (s.credentials = "same-origin"),
      s
    );
  }
  function r(i) {
    if (i.ep) return;
    i.ep = !0;
    const s = n(i);
    fetch(i.href, s);
  }
})();
var bn = !1,
  Sn = !1,
  St = [],
  _n = -1;
function Ba(t) {
  ja(t);
}
function ja(t) {
  St.includes(t) || St.push(t), Ua();
}
function Ha(t) {
  let e = St.indexOf(t);
  e !== -1 && e > _n && St.splice(e, 1);
}
function Ua() {
  !Sn && !bn && ((bn = !0), queueMicrotask(Wa));
}
function Wa() {
  (bn = !1), (Sn = !0);
  for (let t = 0; t < St.length; t++) St[t](), (_n = t);
  (St.length = 0), (_n = -1), (Sn = !1);
}
var Ft,
  Mt,
  It,
  ss,
  xn = !0;
function Ka(t) {
  (xn = !1), t(), (xn = !0);
}
function qa(t) {
  (Ft = t.reactive),
    (It = t.release),
    (Mt = (e) =>
      t.effect(e, {
        scheduler: (n) => {
          xn ? Ba(n) : n();
        },
      })),
    (ss = t.raw);
}
function Jr(t) {
  Mt = t;
}
function za(t) {
  let e = () => {};
  return [
    (r) => {
      let i = Mt(r);
      return (
        t._x_effects ||
          ((t._x_effects = new Set()),
          (t._x_runEffects = () => {
            t._x_effects.forEach((s) => s());
          })),
        t._x_effects.add(i),
        (e = () => {
          i !== void 0 && (t._x_effects.delete(i), It(i));
        }),
        i
      );
    },
    () => {
      e();
    },
  ];
}
function os(t, e) {
  let n = !0,
    r,
    i = Mt(() => {
      let s = t();
      JSON.stringify(s),
        n
          ? (r = s)
          : queueMicrotask(() => {
              e(s, r), (r = s);
            }),
        (n = !1);
    });
  return () => It(i);
}
var as = [],
  ls = [],
  cs = [];
function Ga(t) {
  cs.push(t);
}
function sr(t, e) {
  typeof e == "function"
    ? (t._x_cleanups || (t._x_cleanups = []), t._x_cleanups.push(e))
    : ((e = t), ls.push(e));
}
function us(t) {
  as.push(t);
}
function fs(t, e, n) {
  t._x_attributeCleanups || (t._x_attributeCleanups = {}),
    t._x_attributeCleanups[e] || (t._x_attributeCleanups[e] = []),
    t._x_attributeCleanups[e].push(n);
}
function hs(t, e) {
  t._x_attributeCleanups &&
    Object.entries(t._x_attributeCleanups).forEach(([n, r]) => {
      (e === void 0 || e.includes(n)) &&
        (r.forEach((i) => i()), delete t._x_attributeCleanups[n]);
    });
}
function Ya(t) {
  for (t._x_effects?.forEach(Ha); t._x_cleanups?.length; )
    t._x_cleanups.pop()();
}
var or = new MutationObserver(ur),
  ar = !1;
function lr() {
  or.observe(document, {
    subtree: !0,
    childList: !0,
    attributes: !0,
    attributeOldValue: !0,
  }),
    (ar = !0);
}
function ds() {
  Xa(), or.disconnect(), (ar = !1);
}
var Kt = [];
function Xa() {
  let t = or.takeRecords();
  Kt.push(() => t.length > 0 && ur(t));
  let e = Kt.length;
  queueMicrotask(() => {
    if (Kt.length === e) for (; Kt.length > 0; ) Kt.shift()();
  });
}
function k(t) {
  if (!ar) return t();
  ds();
  let e = t();
  return lr(), e;
}
var cr = !1,
  je = [];
function Za() {
  cr = !0;
}
function Ja() {
  (cr = !1), ur(je), (je = []);
}
function ur(t) {
  if (cr) {
    je = je.concat(t);
    return;
  }
  let e = [],
    n = new Set(),
    r = new Map(),
    i = new Map();
  for (let s = 0; s < t.length; s++)
    if (
      !t[s].target._x_ignoreMutationObserver &&
      (t[s].type === "childList" &&
        (t[s].removedNodes.forEach((o) => {
          o.nodeType === 1 && o._x_marker && n.add(o);
        }),
        t[s].addedNodes.forEach((o) => {
          if (o.nodeType === 1) {
            if (n.has(o)) {
              n.delete(o);
              return;
            }
            o._x_marker || e.push(o);
          }
        })),
      t[s].type === "attributes")
    ) {
      let o = t[s].target,
        a = t[s].attributeName,
        l = t[s].oldValue,
        u = () => {
          r.has(o) || r.set(o, []),
            r.get(o).push({ name: a, value: o.getAttribute(a) });
        },
        c = () => {
          i.has(o) || i.set(o, []), i.get(o).push(a);
        };
      o.hasAttribute(a) && l === null
        ? u()
        : o.hasAttribute(a)
        ? (c(), u())
        : c();
    }
  i.forEach((s, o) => {
    hs(o, s);
  }),
    r.forEach((s, o) => {
      as.forEach((a) => a(o, s));
    });
  for (let s of n) e.some((o) => o.contains(s)) || ls.forEach((o) => o(s));
  for (let s of e) s.isConnected && cs.forEach((o) => o(s));
  (e = null), (n = null), (r = null), (i = null);
}
function ps(t) {
  return de($t(t));
}
function he(t, e, n) {
  return (
    (t._x_dataStack = [e, ...$t(n || t)]),
    () => {
      t._x_dataStack = t._x_dataStack.filter((r) => r !== e);
    }
  );
}
function $t(t) {
  return t._x_dataStack
    ? t._x_dataStack
    : typeof ShadowRoot == "function" && t instanceof ShadowRoot
    ? $t(t.host)
    : t.parentNode
    ? $t(t.parentNode)
    : [];
}
function de(t) {
  return new Proxy({ objects: t }, Qa);
}
var Qa = {
  ownKeys({ objects: t }) {
    return Array.from(new Set(t.flatMap((e) => Object.keys(e))));
  },
  has({ objects: t }, e) {
    return e == Symbol.unscopables
      ? !1
      : t.some(
          (n) => Object.prototype.hasOwnProperty.call(n, e) || Reflect.has(n, e)
        );
  },
  get({ objects: t }, e, n) {
    return e == "toJSON"
      ? tl
      : Reflect.get(t.find((r) => Reflect.has(r, e)) || {}, e, n);
  },
  set({ objects: t }, e, n, r) {
    const i =
        t.find((o) => Object.prototype.hasOwnProperty.call(o, e)) ||
        t[t.length - 1],
      s = Object.getOwnPropertyDescriptor(i, e);
    return s?.set && s?.get ? s.set.call(r, n) || !0 : Reflect.set(i, e, n);
  },
};
function tl() {
  return Reflect.ownKeys(this).reduce(
    (e, n) => ((e[n] = Reflect.get(this, n)), e),
    {}
  );
}
function ms(t) {
  let e = (r) => typeof r == "object" && !Array.isArray(r) && r !== null,
    n = (r, i = "") => {
      Object.entries(Object.getOwnPropertyDescriptors(r)).forEach(
        ([s, { value: o, enumerable: a }]) => {
          if (
            a === !1 ||
            o === void 0 ||
            (typeof o == "object" && o !== null && o.__v_skip)
          )
            return;
          let l = i === "" ? s : `${i}.${s}`;
          typeof o == "object" && o !== null && o._x_interceptor
            ? (r[s] = o.initialize(t, l, s))
            : e(o) && o !== r && !(o instanceof Element) && n(o, l);
        }
      );
    };
  return n(t);
}
function gs(t, e = () => {}) {
  let n = {
    initialValue: void 0,
    _x_interceptor: !0,
    initialize(r, i, s) {
      return t(
        this.initialValue,
        () => el(r, i),
        (o) => Tn(r, i, o),
        i,
        s
      );
    },
  };
  return (
    e(n),
    (r) => {
      if (typeof r == "object" && r !== null && r._x_interceptor) {
        let i = n.initialize.bind(n);
        n.initialize = (s, o, a) => {
          let l = r.initialize(s, o, a);
          return (n.initialValue = l), i(s, o, a);
        };
      } else n.initialValue = r;
      return n;
    }
  );
}
function el(t, e) {
  return e.split(".").reduce((n, r) => n[r], t);
}
function Tn(t, e, n) {
  if ((typeof e == "string" && (e = e.split(".")), e.length === 1)) t[e[0]] = n;
  else {
    if (e.length === 0) throw error;
    return t[e[0]] || (t[e[0]] = {}), Tn(t[e[0]], e.slice(1), n);
  }
}
var ys = {};
function Y(t, e) {
  ys[t] = e;
}
function An(t, e) {
  let n = nl(e);
  return (
    Object.entries(ys).forEach(([r, i]) => {
      Object.defineProperty(t, `$${r}`, {
        get() {
          return i(e, n);
        },
        enumerable: !1,
      });
    }),
    t
  );
}
function nl(t) {
  let [e, n] = xs(t),
    r = { interceptor: gs, ...e };
  return sr(t, n), r;
}
function rl(t, e, n, ...r) {
  try {
    return n(...r);
  } catch (i) {
    ie(i, t, e);
  }
}
function ie(t, e, n = void 0) {
  (t = Object.assign(t ?? { message: "No error message given." }, {
    el: e,
    expression: n,
  })),
    console.warn(
      `Alpine Expression Error: ${t.message}

${
  n
    ? 'Expression: "' +
      n +
      `"

`
    : ""
}`,
      e
    ),
    setTimeout(() => {
      throw t;
    }, 0);
}
var Re = !0;
function vs(t) {
  let e = Re;
  Re = !1;
  let n = t();
  return (Re = e), n;
}
function _t(t, e, n = {}) {
  let r;
  return N(t, e)((i) => (r = i), n), r;
}
function N(...t) {
  return ws(...t);
}
var ws = bs;
function il(t) {
  ws = t;
}
function bs(t, e) {
  let n = {};
  An(n, t);
  let r = [n, ...$t(t)],
    i = typeof e == "function" ? sl(r, e) : al(r, e, t);
  return rl.bind(null, t, e, i);
}
function sl(t, e) {
  return (n = () => {}, { scope: r = {}, params: i = [], context: s } = {}) => {
    let o = e.apply(de([r, ...t]), i);
    He(n, o);
  };
}
var sn = {};
function ol(t, e) {
  if (sn[t]) return sn[t];
  let n = Object.getPrototypeOf(async function () {}).constructor,
    r =
      /^[\n\s]*if.*\(.*\)/.test(t.trim()) || /^(let|const)\s/.test(t.trim())
        ? `(async()=>{ ${t} })()`
        : t,
    s = (() => {
      try {
        let o = new n(
          ["__self", "scope"],
          `with (scope) { __self.result = ${r} }; __self.finished = true; return __self.result;`
        );
        return Object.defineProperty(o, "name", { value: `[Alpine] ${t}` }), o;
      } catch (o) {
        return ie(o, e, t), Promise.resolve();
      }
    })();
  return (sn[t] = s), s;
}
function al(t, e, n) {
  let r = ol(e, n);
  return (i = () => {}, { scope: s = {}, params: o = [], context: a } = {}) => {
    (r.result = void 0), (r.finished = !1);
    let l = de([s, ...t]);
    if (typeof r == "function") {
      let u = r.call(a, r, l).catch((c) => ie(c, n, e));
      r.finished
        ? (He(i, r.result, l, o, n), (r.result = void 0))
        : u
            .then((c) => {
              He(i, c, l, o, n);
            })
            .catch((c) => ie(c, n, e))
            .finally(() => (r.result = void 0));
    }
  };
}
function He(t, e, n, r, i) {
  if (Re && typeof e == "function") {
    let s = e.apply(n, r);
    s instanceof Promise
      ? s.then((o) => He(t, o, n, r)).catch((o) => ie(o, i, e))
      : t(s);
  } else
    typeof e == "object" && e instanceof Promise ? e.then((s) => t(s)) : t(e);
}
var fr = "x-";
function Lt(t = "") {
  return fr + t;
}
function ll(t) {
  fr = t;
}
var Ue = {};
function F(t, e) {
  return (
    (Ue[t] = e),
    {
      before(n) {
        if (!Ue[n]) {
          console.warn(
            String.raw`Cannot find directive \`${n}\`. \`${t}\` will use the default order of execution`
          );
          return;
        }
        const r = vt.indexOf(n);
        vt.splice(r >= 0 ? r : vt.indexOf("DEFAULT"), 0, t);
      },
    }
  );
}
function cl(t) {
  return Object.keys(Ue).includes(t);
}
function hr(t, e, n) {
  if (((e = Array.from(e)), t._x_virtualDirectives)) {
    let s = Object.entries(t._x_virtualDirectives).map(([a, l]) => ({
        name: a,
        value: l,
      })),
      o = Ss(s);
    (s = s.map((a) =>
      o.find((l) => l.name === a.name)
        ? { name: `x-bind:${a.name}`, value: `"${a.value}"` }
        : a
    )),
      (e = e.concat(s));
  }
  let r = {};
  return e
    .map(Es((s, o) => (r[s] = o)))
    .filter(Ps)
    .map(hl(r, n))
    .sort(dl)
    .map((s) => fl(t, s));
}
function Ss(t) {
  return Array.from(t)
    .map(Es())
    .filter((e) => !Ps(e));
}
var En = !1,
  Yt = new Map(),
  _s = Symbol();
function ul(t) {
  En = !0;
  let e = Symbol();
  (_s = e), Yt.set(e, []);
  let n = () => {
      for (; Yt.get(e).length; ) Yt.get(e).shift()();
      Yt.delete(e);
    },
    r = () => {
      (En = !1), n();
    };
  t(n), r();
}
function xs(t) {
  let e = [],
    n = (a) => e.push(a),
    [r, i] = za(t);
  return (
    e.push(i),
    [
      {
        Alpine: pe,
        effect: r,
        cleanup: n,
        evaluateLater: N.bind(N, t),
        evaluate: _t.bind(_t, t),
      },
      () => e.forEach((a) => a()),
    ]
  );
}
function fl(t, e) {
  let n = () => {},
    r = Ue[e.type] || n,
    [i, s] = xs(t);
  fs(t, e.original, s);
  let o = () => {
    t._x_ignore ||
      t._x_ignoreSelf ||
      (r.inline && r.inline(t, e, i),
      (r = r.bind(r, t, e, i)),
      En ? Yt.get(_s).push(r) : r());
  };
  return (o.runCleanups = s), o;
}
var Ts =
    (t, e) =>
    ({ name: n, value: r }) => (
      n.startsWith(t) && (n = n.replace(t, e)), { name: n, value: r }
    ),
  As = (t) => t;
function Es(t = () => {}) {
  return ({ name: e, value: n }) => {
    let { name: r, value: i } = Cs.reduce((s, o) => o(s), {
      name: e,
      value: n,
    });
    return r !== e && t(r, e), { name: r, value: i };
  };
}
var Cs = [];
function dr(t) {
  Cs.push(t);
}
function Ps({ name: t }) {
  return Ms().test(t);
}
var Ms = () => new RegExp(`^${fr}([^:^.]+)\\b`);
function hl(t, e) {
  return ({ name: n, value: r }) => {
    let i = n.match(Ms()),
      s = n.match(/:([a-zA-Z0-9\-_:]+)/),
      o = n.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
      a = e || t[n] || n;
    return {
      type: i ? i[1] : null,
      value: s ? s[1] : null,
      modifiers: o.map((l) => l.replace(".", "")),
      expression: r,
      original: a,
    };
  };
}
var Cn = "DEFAULT",
  vt = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    Cn,
    "teleport",
  ];
function dl(t, e) {
  let n = vt.indexOf(t.type) === -1 ? Cn : t.type,
    r = vt.indexOf(e.type) === -1 ? Cn : e.type;
  return vt.indexOf(n) - vt.indexOf(r);
}
function Zt(t, e, n = {}) {
  t.dispatchEvent(
    new CustomEvent(e, { detail: n, bubbles: !0, composed: !0, cancelable: !0 })
  );
}
function Ct(t, e) {
  if (typeof ShadowRoot == "function" && t instanceof ShadowRoot) {
    Array.from(t.children).forEach((i) => Ct(i, e));
    return;
  }
  let n = !1;
  if ((e(t, () => (n = !0)), n)) return;
  let r = t.firstElementChild;
  for (; r; ) Ct(r, e), (r = r.nextElementSibling);
}
function U(t, ...e) {
  console.warn(`Alpine Warning: ${t}`, ...e);
}
var Qr = !1;
function pl() {
  Qr &&
    U(
      "Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."
    ),
    (Qr = !0),
    document.body ||
      U(
        "Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"
      ),
    Zt(document, "alpine:init"),
    Zt(document, "alpine:initializing"),
    lr(),
    Ga((e) => Q(e, Ct)),
    sr((e) => Nt(e)),
    us((e, n) => {
      hr(e, n).forEach((r) => r());
    });
  let t = (e) => !Ye(e.parentElement, !0);
  Array.from(document.querySelectorAll(ks().join(",")))
    .filter(t)
    .forEach((e) => {
      Q(e);
    }),
    Zt(document, "alpine:initialized"),
    setTimeout(() => {
      vl();
    });
}
var pr = [],
  Os = [];
function Vs() {
  return pr.map((t) => t());
}
function ks() {
  return pr.concat(Os).map((t) => t());
}
function $s(t) {
  pr.push(t);
}
function Rs(t) {
  Os.push(t);
}
function Ye(t, e = !1) {
  return Dt(t, (n) => {
    if ((e ? ks() : Vs()).some((i) => n.matches(i))) return !0;
  });
}
function Dt(t, e) {
  if (t) {
    if (e(t)) return t;
    if ((t._x_teleportBack && (t = t._x_teleportBack), !!t.parentElement))
      return Dt(t.parentElement, e);
  }
}
function ml(t) {
  return Vs().some((e) => t.matches(e));
}
var Fs = [];
function gl(t) {
  Fs.push(t);
}
var yl = 1;
function Q(t, e = Ct, n = () => {}) {
  Dt(t, (r) => r._x_ignore) ||
    ul(() => {
      e(t, (r, i) => {
        r._x_marker ||
          (n(r, i),
          Fs.forEach((s) => s(r, i)),
          hr(r, r.attributes).forEach((s) => s()),
          r._x_ignore || (r._x_marker = yl++),
          r._x_ignore && i());
      });
    });
}
function Nt(t, e = Ct) {
  e(t, (n) => {
    Ya(n), hs(n), delete n._x_marker;
  });
}
function vl() {
  [
    ["ui", "dialog", ["[x-dialog], [x-popover]"]],
    ["anchor", "anchor", ["[x-anchor]"]],
    ["sort", "sort", ["[x-sort]"]],
  ].forEach(([e, n, r]) => {
    cl(n) ||
      r.some((i) => {
        if (document.querySelector(i))
          return U(`found "${i}", but missing ${e} plugin`), !0;
      });
  });
}
var Pn = [],
  mr = !1;
function gr(t = () => {}) {
  return (
    queueMicrotask(() => {
      mr ||
        setTimeout(() => {
          Mn();
        });
    }),
    new Promise((e) => {
      Pn.push(() => {
        t(), e();
      });
    })
  );
}
function Mn() {
  for (mr = !1; Pn.length; ) Pn.shift()();
}
function wl() {
  mr = !0;
}
function yr(t, e) {
  return Array.isArray(e)
    ? ti(t, e.join(" "))
    : typeof e == "object" && e !== null
    ? bl(t, e)
    : typeof e == "function"
    ? yr(t, e())
    : ti(t, e);
}
function ti(t, e) {
  let n = (i) =>
      i
        .split(" ")
        .filter((s) => !t.classList.contains(s))
        .filter(Boolean),
    r = (i) => (
      t.classList.add(...i),
      () => {
        t.classList.remove(...i);
      }
    );
  return (e = e === !0 ? (e = "") : e || ""), r(n(e));
}
function bl(t, e) {
  let n = (a) => a.split(" ").filter(Boolean),
    r = Object.entries(e)
      .flatMap(([a, l]) => (l ? n(a) : !1))
      .filter(Boolean),
    i = Object.entries(e)
      .flatMap(([a, l]) => (l ? !1 : n(a)))
      .filter(Boolean),
    s = [],
    o = [];
  return (
    i.forEach((a) => {
      t.classList.contains(a) && (t.classList.remove(a), o.push(a));
    }),
    r.forEach((a) => {
      t.classList.contains(a) || (t.classList.add(a), s.push(a));
    }),
    () => {
      o.forEach((a) => t.classList.add(a)),
        s.forEach((a) => t.classList.remove(a));
    }
  );
}
function Xe(t, e) {
  return typeof e == "object" && e !== null ? Sl(t, e) : _l(t, e);
}
function Sl(t, e) {
  let n = {};
  return (
    Object.entries(e).forEach(([r, i]) => {
      (n[r] = t.style[r]),
        r.startsWith("--") || (r = xl(r)),
        t.style.setProperty(r, i);
    }),
    setTimeout(() => {
      t.style.length === 0 && t.removeAttribute("style");
    }),
    () => {
      Xe(t, n);
    }
  );
}
function _l(t, e) {
  let n = t.getAttribute("style", e);
  return (
    t.setAttribute("style", e),
    () => {
      t.setAttribute("style", n || "");
    }
  );
}
function xl(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function On(t, e = () => {}) {
  let n = !1;
  return function () {
    n ? e.apply(this, arguments) : ((n = !0), t.apply(this, arguments));
  };
}
F(
  "transition",
  (t, { value: e, modifiers: n, expression: r }, { evaluate: i }) => {
    typeof r == "function" && (r = i(r)),
      r !== !1 && (!r || typeof r == "boolean" ? Al(t, n, e) : Tl(t, r, e));
  }
);
function Tl(t, e, n) {
  Is(t, yr, ""),
    {
      enter: (i) => {
        t._x_transition.enter.during = i;
      },
      "enter-start": (i) => {
        t._x_transition.enter.start = i;
      },
      "enter-end": (i) => {
        t._x_transition.enter.end = i;
      },
      leave: (i) => {
        t._x_transition.leave.during = i;
      },
      "leave-start": (i) => {
        t._x_transition.leave.start = i;
      },
      "leave-end": (i) => {
        t._x_transition.leave.end = i;
      },
    }[n](e);
}
function Al(t, e, n) {
  Is(t, Xe);
  let r = !e.includes("in") && !e.includes("out") && !n,
    i = r || e.includes("in") || ["enter"].includes(n),
    s = r || e.includes("out") || ["leave"].includes(n);
  e.includes("in") && !r && (e = e.filter((g, v) => v < e.indexOf("out"))),
    e.includes("out") && !r && (e = e.filter((g, v) => v > e.indexOf("out")));
  let o = !e.includes("opacity") && !e.includes("scale"),
    a = o || e.includes("opacity"),
    l = o || e.includes("scale"),
    u = a ? 0 : 1,
    c = l ? qt(e, "scale", 95) / 100 : 1,
    f = qt(e, "delay", 0) / 1e3,
    h = qt(e, "origin", "center"),
    d = "opacity, transform",
    m = qt(e, "duration", 150) / 1e3,
    y = qt(e, "duration", 75) / 1e3,
    p = "cubic-bezier(0.4, 0.0, 0.2, 1)";
  i &&
    ((t._x_transition.enter.during = {
      transformOrigin: h,
      transitionDelay: `${f}s`,
      transitionProperty: d,
      transitionDuration: `${m}s`,
      transitionTimingFunction: p,
    }),
    (t._x_transition.enter.start = { opacity: u, transform: `scale(${c})` }),
    (t._x_transition.enter.end = { opacity: 1, transform: "scale(1)" })),
    s &&
      ((t._x_transition.leave.during = {
        transformOrigin: h,
        transitionDelay: `${f}s`,
        transitionProperty: d,
        transitionDuration: `${y}s`,
        transitionTimingFunction: p,
      }),
      (t._x_transition.leave.start = { opacity: 1, transform: "scale(1)" }),
      (t._x_transition.leave.end = { opacity: u, transform: `scale(${c})` }));
}
function Is(t, e, n = {}) {
  t._x_transition ||
    (t._x_transition = {
      enter: { during: n, start: n, end: n },
      leave: { during: n, start: n, end: n },
      in(r = () => {}, i = () => {}) {
        Vn(
          t,
          e,
          {
            during: this.enter.during,
            start: this.enter.start,
            end: this.enter.end,
          },
          r,
          i
        );
      },
      out(r = () => {}, i = () => {}) {
        Vn(
          t,
          e,
          {
            during: this.leave.during,
            start: this.leave.start,
            end: this.leave.end,
          },
          r,
          i
        );
      },
    });
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function (
  t,
  e,
  n,
  r
) {
  const i =
    document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
  let s = () => i(n);
  if (e) {
    t._x_transition && (t._x_transition.enter || t._x_transition.leave)
      ? t._x_transition.enter &&
        (Object.entries(t._x_transition.enter.during).length ||
          Object.entries(t._x_transition.enter.start).length ||
          Object.entries(t._x_transition.enter.end).length)
        ? t._x_transition.in(n)
        : s()
      : t._x_transition
      ? t._x_transition.in(n)
      : s();
    return;
  }
  (t._x_hidePromise = t._x_transition
    ? new Promise((o, a) => {
        t._x_transition.out(
          () => {},
          () => o(r)
        ),
          t._x_transitioning &&
            t._x_transitioning.beforeCancel(() =>
              a({ isFromCancelledTransition: !0 })
            );
      })
    : Promise.resolve(r)),
    queueMicrotask(() => {
      let o = Ls(t);
      o
        ? (o._x_hideChildren || (o._x_hideChildren = []),
          o._x_hideChildren.push(t))
        : i(() => {
            let a = (l) => {
              let u = Promise.all([
                l._x_hidePromise,
                ...(l._x_hideChildren || []).map(a),
              ]).then(([c]) => c?.());
              return delete l._x_hidePromise, delete l._x_hideChildren, u;
            };
            a(t).catch((l) => {
              if (!l.isFromCancelledTransition) throw l;
            });
          });
    });
};
function Ls(t) {
  let e = t.parentNode;
  if (e) return e._x_hidePromise ? e : Ls(e);
}
function Vn(
  t,
  e,
  { during: n, start: r, end: i } = {},
  s = () => {},
  o = () => {}
) {
  if (
    (t._x_transitioning && t._x_transitioning.cancel(),
    Object.keys(n).length === 0 &&
      Object.keys(r).length === 0 &&
      Object.keys(i).length === 0)
  ) {
    s(), o();
    return;
  }
  let a, l, u;
  El(t, {
    start() {
      a = e(t, r);
    },
    during() {
      l = e(t, n);
    },
    before: s,
    end() {
      a(), (u = e(t, i));
    },
    after: o,
    cleanup() {
      l(), u();
    },
  });
}
function El(t, e) {
  let n,
    r,
    i,
    s = On(() => {
      k(() => {
        (n = !0),
          r || e.before(),
          i || (e.end(), Mn()),
          e.after(),
          t.isConnected && e.cleanup(),
          delete t._x_transitioning;
      });
    });
  (t._x_transitioning = {
    beforeCancels: [],
    beforeCancel(o) {
      this.beforeCancels.push(o);
    },
    cancel: On(function () {
      for (; this.beforeCancels.length; ) this.beforeCancels.shift()();
      s();
    }),
    finish: s,
  }),
    k(() => {
      e.start(), e.during();
    }),
    wl(),
    requestAnimationFrame(() => {
      if (n) return;
      let o =
          Number(
            getComputedStyle(t)
              .transitionDuration.replace(/,.*/, "")
              .replace("s", "")
          ) * 1e3,
        a =
          Number(
            getComputedStyle(t)
              .transitionDelay.replace(/,.*/, "")
              .replace("s", "")
          ) * 1e3;
      o === 0 &&
        (o =
          Number(getComputedStyle(t).animationDuration.replace("s", "")) * 1e3),
        k(() => {
          e.before();
        }),
        (r = !0),
        requestAnimationFrame(() => {
          n ||
            (k(() => {
              e.end();
            }),
            Mn(),
            setTimeout(t._x_transitioning.finish, o + a),
            (i = !0));
        });
    });
}
function qt(t, e, n) {
  if (t.indexOf(e) === -1) return n;
  const r = t[t.indexOf(e) + 1];
  if (!r || (e === "scale" && isNaN(r))) return n;
  if (e === "duration" || e === "delay") {
    let i = r.match(/([0-9]+)ms/);
    if (i) return i[1];
  }
  return e === "origin" &&
    ["top", "right", "left", "center", "bottom"].includes(t[t.indexOf(e) + 2])
    ? [r, t[t.indexOf(e) + 2]].join(" ")
    : r;
}
var ut = !1;
function pt(t, e = () => {}) {
  return (...n) => (ut ? e(...n) : t(...n));
}
function Cl(t) {
  return (...e) => ut && t(...e);
}
var Ds = [];
function Ze(t) {
  Ds.push(t);
}
function Pl(t, e) {
  Ds.forEach((n) => n(t, e)),
    (ut = !0),
    Ns(() => {
      Q(e, (n, r) => {
        r(n, () => {});
      });
    }),
    (ut = !1);
}
var kn = !1;
function Ml(t, e) {
  e._x_dataStack || (e._x_dataStack = t._x_dataStack),
    (ut = !0),
    (kn = !0),
    Ns(() => {
      Ol(e);
    }),
    (ut = !1),
    (kn = !1);
}
function Ol(t) {
  let e = !1;
  Q(t, (r, i) => {
    Ct(r, (s, o) => {
      if (e && ml(s)) return o();
      (e = !0), i(s, o);
    });
  });
}
function Ns(t) {
  let e = Mt;
  Jr((n, r) => {
    let i = e(n);
    return It(i), () => {};
  }),
    t(),
    Jr(e);
}
function Bs(t, e, n, r = []) {
  switch (
    (t._x_bindings || (t._x_bindings = Ft({})),
    (t._x_bindings[e] = n),
    (e = r.includes("camel") ? Dl(e) : e),
    e)
  ) {
    case "value":
      Vl(t, n);
      break;
    case "style":
      $l(t, n);
      break;
    case "class":
      kl(t, n);
      break;
    case "selected":
    case "checked":
      Rl(t, e, n);
      break;
    default:
      js(t, e, n);
      break;
  }
}
function Vl(t, e) {
  if (Ws(t))
    t.attributes.value === void 0 && (t.value = e),
      window.fromModel &&
        (typeof e == "boolean"
          ? (t.checked = Fe(t.value) === e)
          : (t.checked = ei(t.value, e)));
  else if (vr(t))
    Number.isInteger(e)
      ? (t.value = e)
      : !Array.isArray(e) &&
        typeof e != "boolean" &&
        ![null, void 0].includes(e)
      ? (t.value = String(e))
      : Array.isArray(e)
      ? (t.checked = e.some((n) => ei(n, t.value)))
      : (t.checked = !!e);
  else if (t.tagName === "SELECT") Ll(t, e);
  else {
    if (t.value === e) return;
    t.value = e === void 0 ? "" : e;
  }
}
function kl(t, e) {
  t._x_undoAddedClasses && t._x_undoAddedClasses(),
    (t._x_undoAddedClasses = yr(t, e));
}
function $l(t, e) {
  t._x_undoAddedStyles && t._x_undoAddedStyles(),
    (t._x_undoAddedStyles = Xe(t, e));
}
function Rl(t, e, n) {
  js(t, e, n), Il(t, e, n);
}
function js(t, e, n) {
  [null, void 0, !1].includes(n) && Bl(e)
    ? t.removeAttribute(e)
    : (Hs(e) && (n = e), Fl(t, e, n));
}
function Fl(t, e, n) {
  t.getAttribute(e) != n && t.setAttribute(e, n);
}
function Il(t, e, n) {
  t[e] !== n && (t[e] = n);
}
function Ll(t, e) {
  const n = [].concat(e).map((r) => r + "");
  Array.from(t.options).forEach((r) => {
    r.selected = n.includes(r.value);
  });
}
function Dl(t) {
  return t.toLowerCase().replace(/-(\w)/g, (e, n) => n.toUpperCase());
}
function ei(t, e) {
  return t == e;
}
function Fe(t) {
  return [1, "1", "true", "on", "yes", !0].includes(t)
    ? !0
    : [0, "0", "false", "off", "no", !1].includes(t)
    ? !1
    : t
    ? !!t
    : null;
}
var Nl = new Set([
  "allowfullscreen",
  "async",
  "autofocus",
  "autoplay",
  "checked",
  "controls",
  "default",
  "defer",
  "disabled",
  "formnovalidate",
  "inert",
  "ismap",
  "itemscope",
  "loop",
  "multiple",
  "muted",
  "nomodule",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "selected",
  "shadowrootclonable",
  "shadowrootdelegatesfocus",
  "shadowrootserializable",
]);
function Hs(t) {
  return Nl.has(t);
}
function Bl(t) {
  return ![
    "aria-pressed",
    "aria-checked",
    "aria-expanded",
    "aria-selected",
  ].includes(t);
}
function jl(t, e, n) {
  return t._x_bindings && t._x_bindings[e] !== void 0
    ? t._x_bindings[e]
    : Us(t, e, n);
}
function Hl(t, e, n, r = !0) {
  if (t._x_bindings && t._x_bindings[e] !== void 0) return t._x_bindings[e];
  if (t._x_inlineBindings && t._x_inlineBindings[e] !== void 0) {
    let i = t._x_inlineBindings[e];
    return (i.extract = r), vs(() => _t(t, i.expression));
  }
  return Us(t, e, n);
}
function Us(t, e, n) {
  let r = t.getAttribute(e);
  return r === null
    ? typeof n == "function"
      ? n()
      : n
    : r === ""
    ? !0
    : Hs(e)
    ? !![e, "true"].includes(r)
    : r;
}
function vr(t) {
  return (
    t.type === "checkbox" ||
    t.localName === "ui-checkbox" ||
    t.localName === "ui-switch"
  );
}
function Ws(t) {
  return t.type === "radio" || t.localName === "ui-radio";
}
function Ks(t, e) {
  let n;
  return function () {
    const r = this,
      i = arguments,
      s = function () {
        (n = null), t.apply(r, i);
      };
    clearTimeout(n), (n = setTimeout(s, e));
  };
}
function qs(t, e) {
  let n;
  return function () {
    let r = this,
      i = arguments;
    n || (t.apply(r, i), (n = !0), setTimeout(() => (n = !1), e));
  };
}
function zs({ get: t, set: e }, { get: n, set: r }) {
  let i = !0,
    s,
    o = Mt(() => {
      let a = t(),
        l = n();
      if (i) r(on(a)), (i = !1);
      else {
        let u = JSON.stringify(a),
          c = JSON.stringify(l);
        u !== s ? r(on(a)) : u !== c && e(on(l));
      }
      (s = JSON.stringify(t())), JSON.stringify(n());
    });
  return () => {
    It(o);
  };
}
function on(t) {
  return typeof t == "object" ? JSON.parse(JSON.stringify(t)) : t;
}
function Ul(t) {
  (Array.isArray(t) ? t : [t]).forEach((n) => n(pe));
}
var yt = {},
  ni = !1;
function Wl(t, e) {
  if ((ni || ((yt = Ft(yt)), (ni = !0)), e === void 0)) return yt[t];
  (yt[t] = e),
    ms(yt[t]),
    typeof e == "object" &&
      e !== null &&
      e.hasOwnProperty("init") &&
      typeof e.init == "function" &&
      yt[t].init();
}
function Kl() {
  return yt;
}
var Gs = {};
function ql(t, e) {
  let n = typeof e != "function" ? () => e : e;
  return t instanceof Element ? Ys(t, n()) : ((Gs[t] = n), () => {});
}
function zl(t) {
  return (
    Object.entries(Gs).forEach(([e, n]) => {
      Object.defineProperty(t, e, {
        get() {
          return (...r) => n(...r);
        },
      });
    }),
    t
  );
}
function Ys(t, e, n) {
  let r = [];
  for (; r.length; ) r.pop()();
  let i = Object.entries(e).map(([o, a]) => ({ name: o, value: a })),
    s = Ss(i);
  return (
    (i = i.map((o) =>
      s.find((a) => a.name === o.name)
        ? { name: `x-bind:${o.name}`, value: `"${o.value}"` }
        : o
    )),
    hr(t, i, n).map((o) => {
      r.push(o.runCleanups), o();
    }),
    () => {
      for (; r.length; ) r.pop()();
    }
  );
}
var Xs = {};
function Gl(t, e) {
  Xs[t] = e;
}
function Yl(t, e) {
  return (
    Object.entries(Xs).forEach(([n, r]) => {
      Object.defineProperty(t, n, {
        get() {
          return (...i) => r.bind(e)(...i);
        },
        enumerable: !1,
      });
    }),
    t
  );
}
var Xl = {
    get reactive() {
      return Ft;
    },
    get release() {
      return It;
    },
    get effect() {
      return Mt;
    },
    get raw() {
      return ss;
    },
    version: "3.15.0",
    flushAndStopDeferringMutations: Ja,
    dontAutoEvaluateFunctions: vs,
    disableEffectScheduling: Ka,
    startObservingMutations: lr,
    stopObservingMutations: ds,
    setReactivityEngine: qa,
    onAttributeRemoved: fs,
    onAttributesAdded: us,
    closestDataStack: $t,
    skipDuringClone: pt,
    onlyDuringClone: Cl,
    addRootSelector: $s,
    addInitSelector: Rs,
    interceptClone: Ze,
    addScopeToNode: he,
    deferMutations: Za,
    mapAttributes: dr,
    evaluateLater: N,
    interceptInit: gl,
    setEvaluator: il,
    mergeProxies: de,
    extractProp: Hl,
    findClosest: Dt,
    onElRemoved: sr,
    closestRoot: Ye,
    destroyTree: Nt,
    interceptor: gs,
    transition: Vn,
    setStyles: Xe,
    mutateDom: k,
    directive: F,
    entangle: zs,
    throttle: qs,
    debounce: Ks,
    evaluate: _t,
    initTree: Q,
    nextTick: gr,
    prefixed: Lt,
    prefix: ll,
    plugin: Ul,
    magic: Y,
    store: Wl,
    start: pl,
    clone: Ml,
    cloneNode: Pl,
    bound: jl,
    $data: ps,
    watch: os,
    walk: Ct,
    data: Gl,
    bind: ql,
  },
  pe = Xl;
function Zl(t, e) {
  const n = Object.create(null),
    r = t.split(",");
  for (let i = 0; i < r.length; i++) n[r[i]] = !0;
  return (i) => !!n[i];
}
var Jl = Object.freeze({}),
  Ql = Object.prototype.hasOwnProperty,
  Je = (t, e) => Ql.call(t, e),
  xt = Array.isArray,
  Jt = (t) => Zs(t) === "[object Map]",
  tc = (t) => typeof t == "string",
  wr = (t) => typeof t == "symbol",
  Qe = (t) => t !== null && typeof t == "object",
  ec = Object.prototype.toString,
  Zs = (t) => ec.call(t),
  Js = (t) => Zs(t).slice(8, -1),
  br = (t) =>
    tc(t) && t !== "NaN" && t[0] !== "-" && "" + parseInt(t, 10) === t,
  nc = (t) => {
    const e = Object.create(null);
    return (n) => e[n] || (e[n] = t(n));
  },
  rc = nc((t) => t.charAt(0).toUpperCase() + t.slice(1)),
  Qs = (t, e) => t !== e && (t === t || e === e),
  $n = new WeakMap(),
  zt = [],
  Z,
  Tt = Symbol("iterate"),
  Rn = Symbol("Map key iterate");
function ic(t) {
  return t && t._isEffect === !0;
}
function sc(t, e = Jl) {
  ic(t) && (t = t.raw);
  const n = lc(t, e);
  return e.lazy || n(), n;
}
function oc(t) {
  t.active && (to(t), t.options.onStop && t.options.onStop(), (t.active = !1));
}
var ac = 0;
function lc(t, e) {
  const n = function () {
    if (!n.active) return t();
    if (!zt.includes(n)) {
      to(n);
      try {
        return uc(), zt.push(n), (Z = n), t();
      } finally {
        zt.pop(), eo(), (Z = zt[zt.length - 1]);
      }
    }
  };
  return (
    (n.id = ac++),
    (n.allowRecurse = !!e.allowRecurse),
    (n._isEffect = !0),
    (n.active = !0),
    (n.raw = t),
    (n.deps = []),
    (n.options = e),
    n
  );
}
function to(t) {
  const { deps: e } = t;
  if (e.length) {
    for (let n = 0; n < e.length; n++) e[n].delete(t);
    e.length = 0;
  }
}
var Rt = !0,
  Sr = [];
function cc() {
  Sr.push(Rt), (Rt = !1);
}
function uc() {
  Sr.push(Rt), (Rt = !0);
}
function eo() {
  const t = Sr.pop();
  Rt = t === void 0 ? !0 : t;
}
function G(t, e, n) {
  if (!Rt || Z === void 0) return;
  let r = $n.get(t);
  r || $n.set(t, (r = new Map()));
  let i = r.get(n);
  i || r.set(n, (i = new Set())),
    i.has(Z) ||
      (i.add(Z),
      Z.deps.push(i),
      Z.options.onTrack &&
        Z.options.onTrack({ effect: Z, target: t, type: e, key: n }));
}
function ft(t, e, n, r, i, s) {
  const o = $n.get(t);
  if (!o) return;
  const a = new Set(),
    l = (c) => {
      c &&
        c.forEach((f) => {
          (f !== Z || f.allowRecurse) && a.add(f);
        });
    };
  if (e === "clear") o.forEach(l);
  else if (n === "length" && xt(t))
    o.forEach((c, f) => {
      (f === "length" || f >= r) && l(c);
    });
  else
    switch ((n !== void 0 && l(o.get(n)), e)) {
      case "add":
        xt(t)
          ? br(n) && l(o.get("length"))
          : (l(o.get(Tt)), Jt(t) && l(o.get(Rn)));
        break;
      case "delete":
        xt(t) || (l(o.get(Tt)), Jt(t) && l(o.get(Rn)));
        break;
      case "set":
        Jt(t) && l(o.get(Tt));
        break;
    }
  const u = (c) => {
    c.options.onTrigger &&
      c.options.onTrigger({
        effect: c,
        target: t,
        key: n,
        type: e,
        newValue: r,
        oldValue: i,
        oldTarget: s,
      }),
      c.options.scheduler ? c.options.scheduler(c) : c();
  };
  a.forEach(u);
}
var fc = Zl("__proto__,__v_isRef,__isVue"),
  no = new Set(
    Object.getOwnPropertyNames(Symbol)
      .map((t) => Symbol[t])
      .filter(wr)
  ),
  hc = ro(),
  dc = ro(!0),
  ri = pc();
function pc() {
  const t = {};
  return (
    ["includes", "indexOf", "lastIndexOf"].forEach((e) => {
      t[e] = function (...n) {
        const r = O(this);
        for (let s = 0, o = this.length; s < o; s++) G(r, "get", s + "");
        const i = r[e](...n);
        return i === -1 || i === !1 ? r[e](...n.map(O)) : i;
      };
    }),
    ["push", "pop", "shift", "unshift", "splice"].forEach((e) => {
      t[e] = function (...n) {
        cc();
        const r = O(this)[e].apply(this, n);
        return eo(), r;
      };
    }),
    t
  );
}
function ro(t = !1, e = !1) {
  return function (r, i, s) {
    if (i === "__v_isReactive") return !t;
    if (i === "__v_isReadonly") return t;
    if (i === "__v_raw" && s === (t ? (e ? Pc : ao) : e ? Cc : oo).get(r))
      return r;
    const o = xt(r);
    if (!t && o && Je(ri, i)) return Reflect.get(ri, i, s);
    const a = Reflect.get(r, i, s);
    return (wr(i) ? no.has(i) : fc(i)) || (t || G(r, "get", i), e)
      ? a
      : Fn(a)
      ? !o || !br(i)
        ? a.value
        : a
      : Qe(a)
      ? t
        ? lo(a)
        : Ar(a)
      : a;
  };
}
var mc = gc();
function gc(t = !1) {
  return function (n, r, i, s) {
    let o = n[r];
    if (!t && ((i = O(i)), (o = O(o)), !xt(n) && Fn(o) && !Fn(i)))
      return (o.value = i), !0;
    const a = xt(n) && br(r) ? Number(r) < n.length : Je(n, r),
      l = Reflect.set(n, r, i, s);
    return (
      n === O(s) &&
        (a ? Qs(i, o) && ft(n, "set", r, i, o) : ft(n, "add", r, i)),
      l
    );
  };
}
function yc(t, e) {
  const n = Je(t, e),
    r = t[e],
    i = Reflect.deleteProperty(t, e);
  return i && n && ft(t, "delete", e, void 0, r), i;
}
function vc(t, e) {
  const n = Reflect.has(t, e);
  return (!wr(e) || !no.has(e)) && G(t, "has", e), n;
}
function wc(t) {
  return G(t, "iterate", xt(t) ? "length" : Tt), Reflect.ownKeys(t);
}
var bc = { get: hc, set: mc, deleteProperty: yc, has: vc, ownKeys: wc },
  Sc = {
    get: dc,
    set(t, e) {
      return (
        console.warn(
          `Set operation on key "${String(e)}" failed: target is readonly.`,
          t
        ),
        !0
      );
    },
    deleteProperty(t, e) {
      return (
        console.warn(
          `Delete operation on key "${String(e)}" failed: target is readonly.`,
          t
        ),
        !0
      );
    },
  },
  _r = (t) => (Qe(t) ? Ar(t) : t),
  xr = (t) => (Qe(t) ? lo(t) : t),
  Tr = (t) => t,
  tn = (t) => Reflect.getPrototypeOf(t);
function _e(t, e, n = !1, r = !1) {
  t = t.__v_raw;
  const i = O(t),
    s = O(e);
  e !== s && !n && G(i, "get", e), !n && G(i, "get", s);
  const { has: o } = tn(i),
    a = r ? Tr : n ? xr : _r;
  if (o.call(i, e)) return a(t.get(e));
  if (o.call(i, s)) return a(t.get(s));
  t !== i && t.get(e);
}
function xe(t, e = !1) {
  const n = this.__v_raw,
    r = O(n),
    i = O(t);
  return (
    t !== i && !e && G(r, "has", t),
    !e && G(r, "has", i),
    t === i ? n.has(t) : n.has(t) || n.has(i)
  );
}
function Te(t, e = !1) {
  return (
    (t = t.__v_raw), !e && G(O(t), "iterate", Tt), Reflect.get(t, "size", t)
  );
}
function ii(t) {
  t = O(t);
  const e = O(this);
  return tn(e).has.call(e, t) || (e.add(t), ft(e, "add", t, t)), this;
}
function si(t, e) {
  e = O(e);
  const n = O(this),
    { has: r, get: i } = tn(n);
  let s = r.call(n, t);
  s ? so(n, r, t) : ((t = O(t)), (s = r.call(n, t)));
  const o = i.call(n, t);
  return (
    n.set(t, e),
    s ? Qs(e, o) && ft(n, "set", t, e, o) : ft(n, "add", t, e),
    this
  );
}
function oi(t) {
  const e = O(this),
    { has: n, get: r } = tn(e);
  let i = n.call(e, t);
  i ? so(e, n, t) : ((t = O(t)), (i = n.call(e, t)));
  const s = r ? r.call(e, t) : void 0,
    o = e.delete(t);
  return i && ft(e, "delete", t, void 0, s), o;
}
function ai() {
  const t = O(this),
    e = t.size !== 0,
    n = Jt(t) ? new Map(t) : new Set(t),
    r = t.clear();
  return e && ft(t, "clear", void 0, void 0, n), r;
}
function Ae(t, e) {
  return function (r, i) {
    const s = this,
      o = s.__v_raw,
      a = O(o),
      l = e ? Tr : t ? xr : _r;
    return (
      !t && G(a, "iterate", Tt), o.forEach((u, c) => r.call(i, l(u), l(c), s))
    );
  };
}
function Ee(t, e, n) {
  return function (...r) {
    const i = this.__v_raw,
      s = O(i),
      o = Jt(s),
      a = t === "entries" || (t === Symbol.iterator && o),
      l = t === "keys" && o,
      u = i[t](...r),
      c = n ? Tr : e ? xr : _r;
    return (
      !e && G(s, "iterate", l ? Rn : Tt),
      {
        next() {
          const { value: f, done: h } = u.next();
          return h
            ? { value: f, done: h }
            : { value: a ? [c(f[0]), c(f[1])] : c(f), done: h };
        },
        [Symbol.iterator]() {
          return this;
        },
      }
    );
  };
}
function at(t) {
  return function (...e) {
    {
      const n = e[0] ? `on key "${e[0]}" ` : "";
      console.warn(
        `${rc(t)} operation ${n}failed: target is readonly.`,
        O(this)
      );
    }
    return t === "delete" ? !1 : this;
  };
}
function _c() {
  const t = {
      get(s) {
        return _e(this, s);
      },
      get size() {
        return Te(this);
      },
      has: xe,
      add: ii,
      set: si,
      delete: oi,
      clear: ai,
      forEach: Ae(!1, !1),
    },
    e = {
      get(s) {
        return _e(this, s, !1, !0);
      },
      get size() {
        return Te(this);
      },
      has: xe,
      add: ii,
      set: si,
      delete: oi,
      clear: ai,
      forEach: Ae(!1, !0),
    },
    n = {
      get(s) {
        return _e(this, s, !0);
      },
      get size() {
        return Te(this, !0);
      },
      has(s) {
        return xe.call(this, s, !0);
      },
      add: at("add"),
      set: at("set"),
      delete: at("delete"),
      clear: at("clear"),
      forEach: Ae(!0, !1),
    },
    r = {
      get(s) {
        return _e(this, s, !0, !0);
      },
      get size() {
        return Te(this, !0);
      },
      has(s) {
        return xe.call(this, s, !0);
      },
      add: at("add"),
      set: at("set"),
      delete: at("delete"),
      clear: at("clear"),
      forEach: Ae(!0, !0),
    };
  return (
    ["keys", "values", "entries", Symbol.iterator].forEach((s) => {
      (t[s] = Ee(s, !1, !1)),
        (n[s] = Ee(s, !0, !1)),
        (e[s] = Ee(s, !1, !0)),
        (r[s] = Ee(s, !0, !0));
    }),
    [t, n, e, r]
  );
}
var [xc, Tc] = _c();
function io(t, e) {
  const n = t ? Tc : xc;
  return (r, i, s) =>
    i === "__v_isReactive"
      ? !t
      : i === "__v_isReadonly"
      ? t
      : i === "__v_raw"
      ? r
      : Reflect.get(Je(n, i) && i in r ? n : r, i, s);
}
var Ac = { get: io(!1) },
  Ec = { get: io(!0) };
function so(t, e, n) {
  const r = O(n);
  if (r !== n && e.call(t, r)) {
    const i = Js(t);
    console.warn(
      `Reactive ${i} contains both the raw and reactive versions of the same object${
        i === "Map" ? " as keys" : ""
      }, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
var oo = new WeakMap(),
  Cc = new WeakMap(),
  ao = new WeakMap(),
  Pc = new WeakMap();
function Mc(t) {
  switch (t) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Oc(t) {
  return t.__v_skip || !Object.isExtensible(t) ? 0 : Mc(Js(t));
}
function Ar(t) {
  return t && t.__v_isReadonly ? t : co(t, !1, bc, Ac, oo);
}
function lo(t) {
  return co(t, !0, Sc, Ec, ao);
}
function co(t, e, n, r, i) {
  if (!Qe(t))
    return console.warn(`value cannot be made reactive: ${String(t)}`), t;
  if (t.__v_raw && !(e && t.__v_isReactive)) return t;
  const s = i.get(t);
  if (s) return s;
  const o = Oc(t);
  if (o === 0) return t;
  const a = new Proxy(t, o === 2 ? r : n);
  return i.set(t, a), a;
}
function O(t) {
  return (t && O(t.__v_raw)) || t;
}
function Fn(t) {
  return !!(t && t.__v_isRef === !0);
}
Y("nextTick", () => gr);
Y("dispatch", (t) => Zt.bind(Zt, t));
Y("watch", (t, { evaluateLater: e, cleanup: n }) => (r, i) => {
  let s = e(r),
    a = os(() => {
      let l;
      return s((u) => (l = u)), l;
    }, i);
  n(a);
});
Y("store", Kl);
Y("data", (t) => ps(t));
Y("root", (t) => Ye(t));
Y(
  "refs",
  (t) => (t._x_refs_proxy || (t._x_refs_proxy = de(Vc(t))), t._x_refs_proxy)
);
function Vc(t) {
  let e = [];
  return (
    Dt(t, (n) => {
      n._x_refs && e.push(n._x_refs);
    }),
    e
  );
}
var an = {};
function uo(t) {
  return an[t] || (an[t] = 0), ++an[t];
}
function kc(t, e) {
  return Dt(t, (n) => {
    if (n._x_ids && n._x_ids[e]) return !0;
  });
}
function $c(t, e) {
  t._x_ids || (t._x_ids = {}), t._x_ids[e] || (t._x_ids[e] = uo(e));
}
Y("id", (t, { cleanup: e }) => (n, r = null) => {
  let i = `${n}${r ? `-${r}` : ""}`;
  return Rc(t, i, e, () => {
    let s = kc(t, n),
      o = s ? s._x_ids[n] : uo(n);
    return r ? `${n}-${o}-${r}` : `${n}-${o}`;
  });
});
Ze((t, e) => {
  t._x_id && (e._x_id = t._x_id);
});
function Rc(t, e, n, r) {
  if ((t._x_id || (t._x_id = {}), t._x_id[e])) return t._x_id[e];
  let i = r();
  return (
    (t._x_id[e] = i),
    n(() => {
      delete t._x_id[e];
    }),
    i
  );
}
Y("el", (t) => t);
fo("Focus", "focus", "focus");
fo("Persist", "persist", "persist");
function fo(t, e, n) {
  Y(e, (r) =>
    U(
      `You can't use [$${e}] without first installing the "${t}" plugin here: https://alpinejs.dev/plugins/${n}`,
      r
    )
  );
}
F(
  "modelable",
  (t, { expression: e }, { effect: n, evaluateLater: r, cleanup: i }) => {
    let s = r(e),
      o = () => {
        let c;
        return s((f) => (c = f)), c;
      },
      a = r(`${e} = __placeholder`),
      l = (c) => a(() => {}, { scope: { __placeholder: c } }),
      u = o();
    l(u),
      queueMicrotask(() => {
        if (!t._x_model) return;
        t._x_removeModelListeners.default();
        let c = t._x_model.get,
          f = t._x_model.set,
          h = zs(
            {
              get() {
                return c();
              },
              set(d) {
                f(d);
              },
            },
            {
              get() {
                return o();
              },
              set(d) {
                l(d);
              },
            }
          );
        i(h);
      });
  }
);
F("teleport", (t, { modifiers: e, expression: n }, { cleanup: r }) => {
  t.tagName.toLowerCase() !== "template" &&
    U("x-teleport can only be used on a <template> tag", t);
  let i = li(n),
    s = t.content.cloneNode(!0).firstElementChild;
  (t._x_teleport = s),
    (s._x_teleportBack = t),
    t.setAttribute("data-teleport-template", !0),
    s.setAttribute("data-teleport-target", !0),
    t._x_forwardEvents &&
      t._x_forwardEvents.forEach((a) => {
        s.addEventListener(a, (l) => {
          l.stopPropagation(), t.dispatchEvent(new l.constructor(l.type, l));
        });
      }),
    he(s, {}, t);
  let o = (a, l, u) => {
    u.includes("prepend")
      ? l.parentNode.insertBefore(a, l)
      : u.includes("append")
      ? l.parentNode.insertBefore(a, l.nextSibling)
      : l.appendChild(a);
  };
  k(() => {
    o(s, i, e),
      pt(() => {
        Q(s);
      })();
  }),
    (t._x_teleportPutBack = () => {
      let a = li(n);
      k(() => {
        o(t._x_teleport, a, e);
      });
    }),
    r(() =>
      k(() => {
        s.remove(), Nt(s);
      })
    );
});
var Fc = document.createElement("div");
function li(t) {
  let e = pt(
    () => document.querySelector(t),
    () => Fc
  )();
  return e || U(`Cannot find x-teleport element for selector: "${t}"`), e;
}
var ho = () => {};
ho.inline = (t, { modifiers: e }, { cleanup: n }) => {
  e.includes("self") ? (t._x_ignoreSelf = !0) : (t._x_ignore = !0),
    n(() => {
      e.includes("self") ? delete t._x_ignoreSelf : delete t._x_ignore;
    });
};
F("ignore", ho);
F(
  "effect",
  pt((t, { expression: e }, { effect: n }) => {
    n(N(t, e));
  })
);
function In(t, e, n, r) {
  let i = t,
    s = (l) => r(l),
    o = {},
    a = (l, u) => (c) => u(l, c);
  if (
    (n.includes("dot") && (e = Ic(e)),
    n.includes("camel") && (e = Lc(e)),
    n.includes("passive") && (o.passive = !0),
    n.includes("capture") && (o.capture = !0),
    n.includes("window") && (i = window),
    n.includes("document") && (i = document),
    n.includes("debounce"))
  ) {
    let l = n[n.indexOf("debounce") + 1] || "invalid-wait",
      u = We(l.split("ms")[0]) ? Number(l.split("ms")[0]) : 250;
    s = Ks(s, u);
  }
  if (n.includes("throttle")) {
    let l = n[n.indexOf("throttle") + 1] || "invalid-wait",
      u = We(l.split("ms")[0]) ? Number(l.split("ms")[0]) : 250;
    s = qs(s, u);
  }
  return (
    n.includes("prevent") &&
      (s = a(s, (l, u) => {
        u.preventDefault(), l(u);
      })),
    n.includes("stop") &&
      (s = a(s, (l, u) => {
        u.stopPropagation(), l(u);
      })),
    n.includes("once") &&
      (s = a(s, (l, u) => {
        l(u), i.removeEventListener(e, s, o);
      })),
    (n.includes("away") || n.includes("outside")) &&
      ((i = document),
      (s = a(s, (l, u) => {
        t.contains(u.target) ||
          (u.target.isConnected !== !1 &&
            ((t.offsetWidth < 1 && t.offsetHeight < 1) ||
              (t._x_isShown !== !1 && l(u))));
      }))),
    n.includes("self") &&
      (s = a(s, (l, u) => {
        u.target === t && l(u);
      })),
    (Nc(e) || po(e)) &&
      (s = a(s, (l, u) => {
        Bc(u, n) || l(u);
      })),
    i.addEventListener(e, s, o),
    () => {
      i.removeEventListener(e, s, o);
    }
  );
}
function Ic(t) {
  return t.replace(/-/g, ".");
}
function Lc(t) {
  return t.toLowerCase().replace(/-(\w)/g, (e, n) => n.toUpperCase());
}
function We(t) {
  return !Array.isArray(t) && !isNaN(t);
}
function Dc(t) {
  return [" ", "_"].includes(t)
    ? t
    : t
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[_\s]/, "-")
        .toLowerCase();
}
function Nc(t) {
  return ["keydown", "keyup"].includes(t);
}
function po(t) {
  return ["contextmenu", "click", "mouse"].some((e) => t.includes(e));
}
function Bc(t, e) {
  let n = e.filter(
    (s) =>
      ![
        "window",
        "document",
        "prevent",
        "stop",
        "once",
        "capture",
        "self",
        "away",
        "outside",
        "passive",
        "preserve-scroll",
      ].includes(s)
  );
  if (n.includes("debounce")) {
    let s = n.indexOf("debounce");
    n.splice(s, We((n[s + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
  }
  if (n.includes("throttle")) {
    let s = n.indexOf("throttle");
    n.splice(s, We((n[s + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
  }
  if (n.length === 0 || (n.length === 1 && ci(t.key).includes(n[0]))) return !1;
  const i = ["ctrl", "shift", "alt", "meta", "cmd", "super"].filter((s) =>
    n.includes(s)
  );
  return (
    (n = n.filter((s) => !i.includes(s))),
    !(
      i.length > 0 &&
      i.filter(
        (o) => ((o === "cmd" || o === "super") && (o = "meta"), t[`${o}Key`])
      ).length === i.length &&
      (po(t.type) || ci(t.key).includes(n[0]))
    )
  );
}
function ci(t) {
  if (!t) return [];
  t = Dc(t);
  let e = {
    ctrl: "control",
    slash: "/",
    space: " ",
    spacebar: " ",
    cmd: "meta",
    esc: "escape",
    up: "arrow-up",
    down: "arrow-down",
    left: "arrow-left",
    right: "arrow-right",
    period: ".",
    comma: ",",
    equal: "=",
    minus: "-",
    underscore: "_",
  };
  return (
    (e[t] = t),
    Object.keys(e)
      .map((n) => {
        if (e[n] === t) return n;
      })
      .filter((n) => n)
  );
}
F("model", (t, { modifiers: e, expression: n }, { effect: r, cleanup: i }) => {
  let s = t;
  e.includes("parent") && (s = t.parentNode);
  let o = N(s, n),
    a;
  typeof n == "string"
    ? (a = N(s, `${n} = __placeholder`))
    : typeof n == "function" && typeof n() == "string"
    ? (a = N(s, `${n()} = __placeholder`))
    : (a = () => {});
  let l = () => {
      let h;
      return o((d) => (h = d)), ui(h) ? h.get() : h;
    },
    u = (h) => {
      let d;
      o((m) => (d = m)),
        ui(d) ? d.set(h) : a(() => {}, { scope: { __placeholder: h } });
    };
  typeof n == "string" &&
    t.type === "radio" &&
    k(() => {
      t.hasAttribute("name") || t.setAttribute("name", n);
    });
  let c =
      t.tagName.toLowerCase() === "select" ||
      ["checkbox", "radio"].includes(t.type) ||
      e.includes("lazy")
        ? "change"
        : "input",
    f = ut
      ? () => {}
      : In(t, c, e, (h) => {
          u(ln(t, e, h, l()));
        });
  if (
    (e.includes("fill") &&
      ([void 0, null, ""].includes(l()) ||
        (vr(t) && Array.isArray(l())) ||
        (t.tagName.toLowerCase() === "select" && t.multiple)) &&
      u(ln(t, e, { target: t }, l())),
    t._x_removeModelListeners || (t._x_removeModelListeners = {}),
    (t._x_removeModelListeners.default = f),
    i(() => t._x_removeModelListeners.default()),
    t.form)
  ) {
    let h = In(t.form, "reset", [], (d) => {
      gr(() => t._x_model && t._x_model.set(ln(t, e, { target: t }, l())));
    });
    i(() => h());
  }
  (t._x_model = {
    get() {
      return l();
    },
    set(h) {
      u(h);
    },
  }),
    (t._x_forceModelUpdate = (h) => {
      h === void 0 && typeof n == "string" && n.match(/\./) && (h = ""),
        (window.fromModel = !0),
        k(() => Bs(t, "value", h)),
        delete window.fromModel;
    }),
    r(() => {
      let h = l();
      (e.includes("unintrusive") && document.activeElement.isSameNode(t)) ||
        t._x_forceModelUpdate(h);
    });
});
function ln(t, e, n, r) {
  return k(() => {
    if (n instanceof CustomEvent && n.detail !== void 0)
      return n.detail !== null && n.detail !== void 0
        ? n.detail
        : n.target.value;
    if (vr(t))
      if (Array.isArray(r)) {
        let i = null;
        return (
          e.includes("number")
            ? (i = cn(n.target.value))
            : e.includes("boolean")
            ? (i = Fe(n.target.value))
            : (i = n.target.value),
          n.target.checked
            ? r.includes(i)
              ? r
              : r.concat([i])
            : r.filter((s) => !jc(s, i))
        );
      } else return n.target.checked;
    else {
      if (t.tagName.toLowerCase() === "select" && t.multiple)
        return e.includes("number")
          ? Array.from(n.target.selectedOptions).map((i) => {
              let s = i.value || i.text;
              return cn(s);
            })
          : e.includes("boolean")
          ? Array.from(n.target.selectedOptions).map((i) => {
              let s = i.value || i.text;
              return Fe(s);
            })
          : Array.from(n.target.selectedOptions).map((i) => i.value || i.text);
      {
        let i;
        return (
          Ws(t)
            ? n.target.checked
              ? (i = n.target.value)
              : (i = r)
            : (i = n.target.value),
          e.includes("number")
            ? cn(i)
            : e.includes("boolean")
            ? Fe(i)
            : e.includes("trim")
            ? i.trim()
            : i
        );
      }
    }
  });
}
function cn(t) {
  let e = t ? parseFloat(t) : null;
  return Hc(e) ? e : t;
}
function jc(t, e) {
  return t == e;
}
function Hc(t) {
  return !Array.isArray(t) && !isNaN(t);
}
function ui(t) {
  return (
    t !== null &&
    typeof t == "object" &&
    typeof t.get == "function" &&
    typeof t.set == "function"
  );
}
F("cloak", (t) =>
  queueMicrotask(() => k(() => t.removeAttribute(Lt("cloak"))))
);
Rs(() => `[${Lt("init")}]`);
F(
  "init",
  pt((t, { expression: e }, { evaluate: n }) =>
    typeof e == "string" ? !!e.trim() && n(e, {}, !1) : n(e, {}, !1)
  )
);
F("text", (t, { expression: e }, { effect: n, evaluateLater: r }) => {
  let i = r(e);
  n(() => {
    i((s) => {
      k(() => {
        t.textContent = s;
      });
    });
  });
});
F("html", (t, { expression: e }, { effect: n, evaluateLater: r }) => {
  let i = r(e);
  n(() => {
    i((s) => {
      k(() => {
        (t.innerHTML = s), (t._x_ignoreSelf = !0), Q(t), delete t._x_ignoreSelf;
      });
    });
  });
});
dr(Ts(":", As(Lt("bind:"))));
var mo = (
  t,
  { value: e, modifiers: n, expression: r, original: i },
  { effect: s, cleanup: o }
) => {
  if (!e) {
    let l = {};
    zl(l),
      N(t, r)(
        (c) => {
          Ys(t, c, i);
        },
        { scope: l }
      );
    return;
  }
  if (e === "key") return Uc(t, r);
  if (
    t._x_inlineBindings &&
    t._x_inlineBindings[e] &&
    t._x_inlineBindings[e].extract
  )
    return;
  let a = N(t, r);
  s(() =>
    a((l) => {
      l === void 0 && typeof r == "string" && r.match(/\./) && (l = ""),
        k(() => Bs(t, e, l, n));
    })
  ),
    o(() => {
      t._x_undoAddedClasses && t._x_undoAddedClasses(),
        t._x_undoAddedStyles && t._x_undoAddedStyles();
    });
};
mo.inline = (t, { value: e, modifiers: n, expression: r }) => {
  e &&
    (t._x_inlineBindings || (t._x_inlineBindings = {}),
    (t._x_inlineBindings[e] = { expression: r, extract: !1 }));
};
F("bind", mo);
function Uc(t, e) {
  t._x_keyExpression = e;
}
$s(() => `[${Lt("data")}]`);
F("data", (t, { expression: e }, { cleanup: n }) => {
  if (Wc(t)) return;
  e = e === "" ? "{}" : e;
  let r = {};
  An(r, t);
  let i = {};
  Yl(i, r);
  let s = _t(t, e, { scope: i });
  (s === void 0 || s === !0) && (s = {}), An(s, t);
  let o = Ft(s);
  ms(o);
  let a = he(t, o);
  o.init && _t(t, o.init),
    n(() => {
      o.destroy && _t(t, o.destroy), a();
    });
});
Ze((t, e) => {
  t._x_dataStack &&
    ((e._x_dataStack = t._x_dataStack),
    e.setAttribute("data-has-alpine-state", !0));
});
function Wc(t) {
  return ut ? (kn ? !0 : t.hasAttribute("data-has-alpine-state")) : !1;
}
F("show", (t, { modifiers: e, expression: n }, { effect: r }) => {
  let i = N(t, n);
  t._x_doHide ||
    (t._x_doHide = () => {
      k(() => {
        t.style.setProperty(
          "display",
          "none",
          e.includes("important") ? "important" : void 0
        );
      });
    }),
    t._x_doShow ||
      (t._x_doShow = () => {
        k(() => {
          t.style.length === 1 && t.style.display === "none"
            ? t.removeAttribute("style")
            : t.style.removeProperty("display");
        });
      });
  let s = () => {
      t._x_doHide(), (t._x_isShown = !1);
    },
    o = () => {
      t._x_doShow(), (t._x_isShown = !0);
    },
    a = () => setTimeout(o),
    l = On(
      (f) => (f ? o() : s()),
      (f) => {
        typeof t._x_toggleAndCascadeWithTransitions == "function"
          ? t._x_toggleAndCascadeWithTransitions(t, f, o, s)
          : f
          ? a()
          : s();
      }
    ),
    u,
    c = !0;
  r(() =>
    i((f) => {
      (!c && f === u) ||
        (e.includes("immediate") && (f ? a() : s()), l(f), (u = f), (c = !1));
    })
  );
});
F("for", (t, { expression: e }, { effect: n, cleanup: r }) => {
  let i = qc(e),
    s = N(t, i.items),
    o = N(t, t._x_keyExpression || "index");
  (t._x_prevKeys = []),
    (t._x_lookup = {}),
    n(() => Kc(t, i, s, o)),
    r(() => {
      Object.values(t._x_lookup).forEach((a) =>
        k(() => {
          Nt(a), a.remove();
        })
      ),
        delete t._x_prevKeys,
        delete t._x_lookup;
    });
});
function Kc(t, e, n, r) {
  let i = (o) => typeof o == "object" && !Array.isArray(o),
    s = t;
  n((o) => {
    zc(o) && o >= 0 && (o = Array.from(Array(o).keys(), (p) => p + 1)),
      o === void 0 && (o = []);
    let a = t._x_lookup,
      l = t._x_prevKeys,
      u = [],
      c = [];
    if (i(o))
      o = Object.entries(o).map(([p, g]) => {
        let v = fi(e, g, p, o);
        r(
          (b) => {
            c.includes(b) && U("Duplicate key on x-for", t), c.push(b);
          },
          { scope: { index: p, ...v } }
        ),
          u.push(v);
      });
    else
      for (let p = 0; p < o.length; p++) {
        let g = fi(e, o[p], p, o);
        r(
          (v) => {
            c.includes(v) && U("Duplicate key on x-for", t), c.push(v);
          },
          { scope: { index: p, ...g } }
        ),
          u.push(g);
      }
    let f = [],
      h = [],
      d = [],
      m = [];
    for (let p = 0; p < l.length; p++) {
      let g = l[p];
      c.indexOf(g) === -1 && d.push(g);
    }
    l = l.filter((p) => !d.includes(p));
    let y = "template";
    for (let p = 0; p < c.length; p++) {
      let g = c[p],
        v = l.indexOf(g);
      if (v === -1) l.splice(p, 0, g), f.push([y, p]);
      else if (v !== p) {
        let b = l.splice(p, 1)[0],
          w = l.splice(v - 1, 1)[0];
        l.splice(p, 0, w), l.splice(v, 0, b), h.push([b, w]);
      } else m.push(g);
      y = g;
    }
    for (let p = 0; p < d.length; p++) {
      let g = d[p];
      g in a &&
        (k(() => {
          Nt(a[g]), a[g].remove();
        }),
        delete a[g]);
    }
    for (let p = 0; p < h.length; p++) {
      let [g, v] = h[p],
        b = a[g],
        w = a[v],
        S = document.createElement("div");
      k(() => {
        w || U('x-for ":key" is undefined or invalid', s, v, a),
          w.after(S),
          b.after(w),
          w._x_currentIfEl && w.after(w._x_currentIfEl),
          S.before(b),
          b._x_currentIfEl && b.after(b._x_currentIfEl),
          S.remove();
      }),
        w._x_refreshXForScope(u[c.indexOf(v)]);
    }
    for (let p = 0; p < f.length; p++) {
      let [g, v] = f[p],
        b = g === "template" ? s : a[g];
      b._x_currentIfEl && (b = b._x_currentIfEl);
      let w = u[v],
        S = c[v],
        A = document.importNode(s.content, !0).firstElementChild,
        C = Ft(w);
      he(A, C, s),
        (A._x_refreshXForScope = (T) => {
          Object.entries(T).forEach(([x, _]) => {
            C[x] = _;
          });
        }),
        k(() => {
          b.after(A), pt(() => Q(A))();
        }),
        typeof S == "object" &&
          U(
            "x-for key cannot be an object, it must be a string or an integer",
            s
          ),
        (a[S] = A);
    }
    for (let p = 0; p < m.length; p++)
      a[m[p]]._x_refreshXForScope(u[c.indexOf(m[p])]);
    s._x_prevKeys = c;
  });
}
function qc(t) {
  let e = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
    n = /^\s*\(|\)\s*$/g,
    r = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
    i = t.match(r);
  if (!i) return;
  let s = {};
  s.items = i[2].trim();
  let o = i[1].replace(n, "").trim(),
    a = o.match(e);
  return (
    a
      ? ((s.item = o.replace(e, "").trim()),
        (s.index = a[1].trim()),
        a[2] && (s.collection = a[2].trim()))
      : (s.item = o),
    s
  );
}
function fi(t, e, n, r) {
  let i = {};
  return (
    /^\[.*\]$/.test(t.item) && Array.isArray(e)
      ? t.item
          .replace("[", "")
          .replace("]", "")
          .split(",")
          .map((o) => o.trim())
          .forEach((o, a) => {
            i[o] = e[a];
          })
      : /^\{.*\}$/.test(t.item) && !Array.isArray(e) && typeof e == "object"
      ? t.item
          .replace("{", "")
          .replace("}", "")
          .split(",")
          .map((o) => o.trim())
          .forEach((o) => {
            i[o] = e[o];
          })
      : (i[t.item] = e),
    t.index && (i[t.index] = n),
    t.collection && (i[t.collection] = r),
    i
  );
}
function zc(t) {
  return !Array.isArray(t) && !isNaN(t);
}
function go() {}
go.inline = (t, { expression: e }, { cleanup: n }) => {
  let r = Ye(t);
  r._x_refs || (r._x_refs = {}),
    (r._x_refs[e] = t),
    n(() => delete r._x_refs[e]);
};
F("ref", go);
F("if", (t, { expression: e }, { effect: n, cleanup: r }) => {
  t.tagName.toLowerCase() !== "template" &&
    U("x-if can only be used on a <template> tag", t);
  let i = N(t, e),
    s = () => {
      if (t._x_currentIfEl) return t._x_currentIfEl;
      let a = t.content.cloneNode(!0).firstElementChild;
      return (
        he(a, {}, t),
        k(() => {
          t.after(a), pt(() => Q(a))();
        }),
        (t._x_currentIfEl = a),
        (t._x_undoIf = () => {
          k(() => {
            Nt(a), a.remove();
          }),
            delete t._x_currentIfEl;
        }),
        a
      );
    },
    o = () => {
      t._x_undoIf && (t._x_undoIf(), delete t._x_undoIf);
    };
  n(() =>
    i((a) => {
      a ? s() : o();
    })
  ),
    r(() => t._x_undoIf && t._x_undoIf());
});
F("id", (t, { expression: e }, { evaluate: n }) => {
  n(e).forEach((i) => $c(t, i));
});
Ze((t, e) => {
  t._x_ids && (e._x_ids = t._x_ids);
});
dr(Ts("@", As(Lt("on:"))));
F(
  "on",
  pt((t, { value: e, modifiers: n, expression: r }, { cleanup: i }) => {
    let s = r ? N(t, r) : () => {};
    t.tagName.toLowerCase() === "template" &&
      (t._x_forwardEvents || (t._x_forwardEvents = []),
      t._x_forwardEvents.includes(e) || t._x_forwardEvents.push(e));
    let o = In(t, e, n, (a) => {
      s(() => {}, { scope: { $event: a }, params: [a] });
    });
    i(() => o());
  })
);
en("Collapse", "collapse", "collapse");
en("Intersect", "intersect", "intersect");
en("Focus", "trap", "focus");
en("Mask", "mask", "mask");
function en(t, e, n) {
  F(e, (r) =>
    U(
      `You can't use [x-${e}] without first installing the "${t}" plugin here: https://alpinejs.dev/plugins/${n}`,
      r
    )
  );
}
pe.setEvaluator(bs);
pe.setReactivityEngine({ reactive: Ar, effect: sc, release: oc, raw: O });
var Gc = pe,
  et = Gc;
const un = new WeakMap();
function fn(t, e, n, r) {
  if (!t && !un.has(e)) return !1;
  const i = un.get(e) ?? new WeakMap();
  un.set(e, i);
  const s = i.get(n) ?? new Set();
  i.set(n, s);
  const o = s.has(r);
  return t ? s.add(r) : s.delete(r), o && t;
}
function Yc(t, e) {
  let n = t.target;
  if (
    (n instanceof Text && (n = n.parentElement),
    n instanceof Element && t.currentTarget instanceof Node)
  ) {
    const r = n.closest(e);
    if (r && t.currentTarget.contains(r)) return r;
  }
}
function Xc(t, e, n, r = {}) {
  const { signal: i, base: s = document } = r;
  if (i?.aborted) return;
  const { once: o, ...a } = r,
    l = s instanceof Document ? s.documentElement : s,
    u = !!(typeof r == "object" ? r.capture : r),
    c = (d) => {
      const m = Yc(d, String(t));
      if (m) {
        const y = Object.assign(d, { delegateTarget: m });
        n.call(l, y), o && (l.removeEventListener(e, c, a), fn(!1, l, n, f));
      }
    },
    f = JSON.stringify({ selector: t, type: e, capture: u });
  fn(!0, l, n, f) || l.addEventListener(e, c, a),
    i?.addEventListener("abort", () => {
      fn(!1, l, n, f);
    });
}
function Zc(t) {
  for (var e = [], n = 0; n < t.length; ) {
    var r = t[n];
    if (r === "*" || r === "+" || r === "?") {
      e.push({ type: "MODIFIER", index: n, value: t[n++] });
      continue;
    }
    if (r === "\\") {
      e.push({ type: "ESCAPED_CHAR", index: n++, value: t[n++] });
      continue;
    }
    if (r === "{") {
      e.push({ type: "OPEN", index: n, value: t[n++] });
      continue;
    }
    if (r === "}") {
      e.push({ type: "CLOSE", index: n, value: t[n++] });
      continue;
    }
    if (r === ":") {
      for (var i = "", s = n + 1; s < t.length; ) {
        var o = t.charCodeAt(s);
        if (
          (o >= 48 && o <= 57) ||
          (o >= 65 && o <= 90) ||
          (o >= 97 && o <= 122) ||
          o === 95
        ) {
          i += t[s++];
          continue;
        }
        break;
      }
      if (!i) throw new TypeError("Missing parameter name at ".concat(n));
      e.push({ type: "NAME", index: n, value: i }), (n = s);
      continue;
    }
    if (r === "(") {
      var a = 1,
        l = "",
        s = n + 1;
      if (t[s] === "?")
        throw new TypeError('Pattern cannot start with "?" at '.concat(s));
      for (; s < t.length; ) {
        if (t[s] === "\\") {
          l += t[s++] + t[s++];
          continue;
        }
        if (t[s] === ")") {
          if ((a--, a === 0)) {
            s++;
            break;
          }
        } else if (t[s] === "(" && (a++, t[s + 1] !== "?"))
          throw new TypeError("Capturing groups are not allowed at ".concat(s));
        l += t[s++];
      }
      if (a) throw new TypeError("Unbalanced pattern at ".concat(n));
      if (!l) throw new TypeError("Missing pattern at ".concat(n));
      e.push({ type: "PATTERN", index: n, value: l }), (n = s);
      continue;
    }
    e.push({ type: "CHAR", index: n, value: t[n++] });
  }
  return e.push({ type: "END", index: n, value: "" }), e;
}
function Jc(t, e) {
  e === void 0 && (e = {});
  for (
    var n = Zc(t),
      r = e.prefixes,
      i = r === void 0 ? "./" : r,
      s = e.delimiter,
      o = s === void 0 ? "/#?" : s,
      a = [],
      l = 0,
      u = 0,
      c = "",
      f = function (x) {
        if (u < n.length && n[u].type === x) return n[u++].value;
      },
      h = function (x) {
        var _ = f(x);
        if (_ !== void 0) return _;
        var V = n[u],
          X = V.type,
          nt = V.index;
        throw new TypeError(
          "Unexpected ".concat(X, " at ").concat(nt, ", expected ").concat(x)
        );
      },
      d = function () {
        for (var x = "", _; (_ = f("CHAR") || f("ESCAPED_CHAR")); ) x += _;
        return x;
      },
      m = function (x) {
        for (var _ = 0, V = o; _ < V.length; _++) {
          var X = V[_];
          if (x.indexOf(X) > -1) return !0;
        }
        return !1;
      },
      y = function (x) {
        var _ = a[a.length - 1],
          V = x || (_ && typeof _ == "string" ? _ : "");
        if (_ && !V)
          throw new TypeError(
            'Must have text between two parameters, missing text after "'.concat(
              _.name,
              '"'
            )
          );
        return !V || m(V)
          ? "[^".concat(ct(o), "]+?")
          : "(?:(?!".concat(ct(V), ")[^").concat(ct(o), "])+?");
      };
    u < n.length;

  ) {
    var p = f("CHAR"),
      g = f("NAME"),
      v = f("PATTERN");
    if (g || v) {
      var b = p || "";
      i.indexOf(b) === -1 && ((c += b), (b = "")),
        c && (a.push(c), (c = "")),
        a.push({
          name: g || l++,
          prefix: b,
          suffix: "",
          pattern: v || y(b),
          modifier: f("MODIFIER") || "",
        });
      continue;
    }
    var w = p || f("ESCAPED_CHAR");
    if (w) {
      c += w;
      continue;
    }
    c && (a.push(c), (c = ""));
    var S = f("OPEN");
    if (S) {
      var b = d(),
        A = f("NAME") || "",
        C = f("PATTERN") || "",
        T = d();
      h("CLOSE"),
        a.push({
          name: A || (C ? l++ : ""),
          pattern: A && !C ? y(b) : C,
          prefix: b,
          suffix: T,
          modifier: f("MODIFIER") || "",
        });
      continue;
    }
    h("END");
  }
  return a;
}
function Qc(t, e) {
  var n = [],
    r = vo(t, n, e);
  return tu(r, n, e);
}
function tu(t, e, n) {
  n === void 0 && (n = {});
  var r = n.decode,
    i =
      r === void 0
        ? function (s) {
            return s;
          }
        : r;
  return function (s) {
    var o = t.exec(s);
    if (!o) return !1;
    for (
      var a = o[0],
        l = o.index,
        u = Object.create(null),
        c = function (h) {
          if (o[h] === void 0) return "continue";
          var d = e[h - 1];
          d.modifier === "*" || d.modifier === "+"
            ? (u[d.name] = o[h].split(d.prefix + d.suffix).map(function (m) {
                return i(m, d);
              }))
            : (u[d.name] = i(o[h], d));
        },
        f = 1;
      f < o.length;
      f++
    )
      c(f);
    return { path: a, index: l, params: u };
  };
}
function ct(t) {
  return t.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function yo(t) {
  return t && t.sensitive ? "" : "i";
}
function eu(t, e) {
  if (!e) return t;
  for (var n = /\((?:\?<(.*?)>)?(?!\?)/g, r = 0, i = n.exec(t.source); i; )
    e.push({
      name: i[1] || r++,
      prefix: "",
      suffix: "",
      modifier: "",
      pattern: "",
    }),
      (i = n.exec(t.source));
  return t;
}
function nu(t, e, n) {
  var r = t.map(function (i) {
    return vo(i, e, n).source;
  });
  return new RegExp("(?:".concat(r.join("|"), ")"), yo(n));
}
function ru(t, e, n) {
  return iu(Jc(t, n), e, n);
}
function iu(t, e, n) {
  n === void 0 && (n = {});
  for (
    var r = n.strict,
      i = r === void 0 ? !1 : r,
      s = n.start,
      o = s === void 0 ? !0 : s,
      a = n.end,
      l = a === void 0 ? !0 : a,
      u = n.encode,
      c =
        u === void 0
          ? function (_) {
              return _;
            }
          : u,
      f = n.delimiter,
      h = f === void 0 ? "/#?" : f,
      d = n.endsWith,
      m = d === void 0 ? "" : d,
      y = "[".concat(ct(m), "]|$"),
      p = "[".concat(ct(h), "]"),
      g = o ? "^" : "",
      v = 0,
      b = t;
    v < b.length;
    v++
  ) {
    var w = b[v];
    if (typeof w == "string") g += ct(c(w));
    else {
      var S = ct(c(w.prefix)),
        A = ct(c(w.suffix));
      if (w.pattern)
        if ((e && e.push(w), S || A))
          if (w.modifier === "+" || w.modifier === "*") {
            var C = w.modifier === "*" ? "?" : "";
            g += "(?:"
              .concat(S, "((?:")
              .concat(w.pattern, ")(?:")
              .concat(A)
              .concat(S, "(?:")
              .concat(w.pattern, "))*)")
              .concat(A, ")")
              .concat(C);
          } else
            g += "(?:"
              .concat(S, "(")
              .concat(w.pattern, ")")
              .concat(A, ")")
              .concat(w.modifier);
        else {
          if (w.modifier === "+" || w.modifier === "*")
            throw new TypeError(
              'Can not repeat "'.concat(w.name, '" without a prefix and suffix')
            );
          g += "(".concat(w.pattern, ")").concat(w.modifier);
        }
      else g += "(?:".concat(S).concat(A, ")").concat(w.modifier);
    }
  }
  if (l)
    i || (g += "".concat(p, "?")),
      (g += n.endsWith ? "(?=".concat(y, ")") : "$");
  else {
    var T = t[t.length - 1],
      x = typeof T == "string" ? p.indexOf(T[T.length - 1]) > -1 : T === void 0;
    i || (g += "(?:".concat(p, "(?=").concat(y, "))?")),
      x || (g += "(?=".concat(p, "|").concat(y, ")"));
  }
  return new RegExp(g, yo(n));
}
function vo(t, e, n) {
  return t instanceof RegExp
    ? eu(t, e)
    : Array.isArray(t)
    ? nu(t, e, n)
    : ru(t, e, n);
}
function I() {
  return (
    (I = Object.assign
      ? Object.assign.bind()
      : function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
          return t;
        }),
    I.apply(null, arguments)
  );
}
const Er = (t, e) =>
    String(t)
      .toLowerCase()
      .replace(/[\s/_.]+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-")
      .replace(/^-+|-+$/g, "") ||
    e ||
    "",
  ht = ({ hash: t } = {}) =>
    window.location.pathname +
    window.location.search +
    (t ? window.location.hash : ""),
  su = (t, e = {}) => {
    const n = I(
      {
        url: (t = t || ht({ hash: !0 })),
        random: Math.random(),
        source: "swup",
      },
      e
    );
    window.history.pushState(n, "", t);
  },
  Qt = (t = null, e = {}) => {
    t = t || ht({ hash: !0 });
    const n = I(
      {},
      window.history.state || {},
      { url: t, random: Math.random(), source: "swup" },
      e
    );
    window.history.replaceState(n, "", t);
  },
  ou = (t, e, n, r) => {
    const i = new AbortController();
    return (
      (r = I({}, r, { signal: i.signal })),
      Xc(t, e, n, r),
      { destroy: () => i.abort() }
    );
  };
let P = class Ie extends URL {
  constructor(e, n = document.baseURI) {
    super(e.toString(), n), Object.setPrototypeOf(this, Ie.prototype);
  }
  get url() {
    return this.pathname + this.search;
  }
  static fromElement(e) {
    const n = e.getAttribute("href") || e.getAttribute("xlink:href") || "";
    return new Ie(n);
  }
  static fromUrl(e) {
    return new Ie(e);
  }
};
const hi = (t, e) => {
  Array.isArray(t) && !t.length && (t = "");
  try {
    return Qc(t, e);
  } catch (n) {
    throw new Error(`[swup] Error parsing path "${String(t)}":
${String(n)}`);
  }
};
let Ce = class extends Error {
  constructor(e, n) {
    super(e),
      (this.url = void 0),
      (this.status = void 0),
      (this.aborted = void 0),
      (this.timedOut = void 0),
      (this.name = "FetchError"),
      (this.url = n.url),
      (this.status = n.status),
      (this.aborted = n.aborted || !1),
      (this.timedOut = n.timedOut || !1);
  }
};
async function au(t, e = {}) {
  var n;
  t = P.fromUrl(t).url;
  const { visit: r = this.visit } = e,
    i = I({}, this.options.requestHeaders, e.headers),
    s = (n = e.timeout) != null ? n : this.options.timeout,
    o = new AbortController(),
    { signal: a } = o;
  e = I({}, e, { headers: i, signal: a });
  let l,
    u = !1,
    c = null;
  s &&
    s > 0 &&
    (c = setTimeout(() => {
      (u = !0), o.abort("timeout");
    }, s));
  try {
    (l = await this.hooks.call(
      "fetch:request",
      r,
      { url: t, options: e },
      (p, { url: g, options: v }) => fetch(g, v)
    )),
      c && clearTimeout(c);
  } catch (p) {
    throw u
      ? (this.hooks.call("fetch:timeout", r, { url: t }),
        new Ce(`Request timed out: ${t}`, { url: t, timedOut: u }))
      : p?.name === "AbortError" || a.aborted
      ? new Ce(`Request aborted: ${t}`, { url: t, aborted: !0 })
      : p;
  }
  const { status: f, url: h } = l,
    d = await l.text();
  if (f === 500)
    throw (
      (this.hooks.call("fetch:error", r, { status: f, response: l, url: h }),
      new Ce(`Server error: ${h}`, { status: f, url: h }))
    );
  if (!d) throw new Ce(`Empty response: ${h}`, { status: f, url: h });
  const { url: m } = P.fromUrl(h),
    y = { url: m, html: d };
  return (
    !r.cache.write ||
      (e.method && e.method !== "GET") ||
      t !== m ||
      this.cache.set(y.url, y),
    y
  );
}
let lu = class {
  constructor(e) {
    (this.swup = void 0), (this.pages = new Map()), (this.swup = e);
  }
  get size() {
    return this.pages.size;
  }
  get all() {
    const e = new Map();
    return (
      this.pages.forEach((n, r) => {
        e.set(r, I({}, n));
      }),
      e
    );
  }
  has(e) {
    return this.pages.has(this.resolve(e));
  }
  get(e) {
    const n = this.pages.get(this.resolve(e));
    return n && I({}, n);
  }
  set(e, n) {
    (n = I({}, n, { url: (e = this.resolve(e)) })),
      this.pages.set(e, n),
      this.swup.hooks.callSync("cache:set", void 0, { page: n });
  }
  update(e, n) {
    e = this.resolve(e);
    const r = I({}, this.get(e), n, { url: e });
    this.pages.set(e, r);
  }
  delete(e) {
    this.pages.delete(this.resolve(e));
  }
  clear() {
    this.pages.clear(), this.swup.hooks.callSync("cache:clear", void 0, void 0);
  }
  prune(e) {
    this.pages.forEach((n, r) => {
      e(r, n) && this.delete(r);
    });
  }
  resolve(e) {
    const { url: n } = P.fromUrl(e);
    return this.swup.resolveUrl(n);
  }
};
const Ln = (t, e = document) => e.querySelector(t),
  Cr = (t, e = document) => Array.from(e.querySelectorAll(t)),
  wo = () =>
    new Promise((t) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    });
function bo(t) {
  return (
    !!t &&
    (typeof t == "object" || typeof t == "function") &&
    typeof t.then == "function"
  );
}
function cu(t, e = []) {
  return new Promise((n, r) => {
    const i = t(...e);
    bo(i) ? i.then(n, r) : n(i);
  });
}
function uu(t) {
  var e;
  (e = t = t || document.body) == null || e.getBoundingClientRect();
}
function di(t, e) {
  const n = t?.closest(`[${e}]`);
  return n != null && n.hasAttribute(e) ? n?.getAttribute(e) || !0 : void 0;
}
class fu {
  constructor(e) {
    (this.swup = void 0),
      (this.swupClasses = [
        "to-",
        "is-changing",
        "is-rendering",
        "is-popstate",
        "is-animating",
        "is-leaving",
      ]),
      (this.swup = e);
  }
  get selectors() {
    const { scope: e } = this.swup.visit.animation;
    return e === "containers"
      ? this.swup.visit.containers
      : e === "html"
      ? ["html"]
      : Array.isArray(e)
      ? e
      : [];
  }
  get selector() {
    return this.selectors.join(",");
  }
  get targets() {
    return this.selector.trim() ? Cr(this.selector) : [];
  }
  add(...e) {
    this.targets.forEach((n) => n.classList.add(...e));
  }
  remove(...e) {
    this.targets.forEach((n) => n.classList.remove(...e));
  }
  clear() {
    this.targets.forEach((e) => {
      const n = e.className.split(" ").filter((r) => this.isSwupClass(r));
      e.classList.remove(...n);
    });
  }
  isSwupClass(e) {
    return this.swupClasses.some((n) => e.startsWith(n));
  }
}
let So = class {
  constructor(e, n) {
    (this.id = void 0),
      (this.state = void 0),
      (this.from = void 0),
      (this.to = void 0),
      (this.containers = void 0),
      (this.animation = void 0),
      (this.trigger = void 0),
      (this.cache = void 0),
      (this.history = void 0),
      (this.scroll = void 0),
      (this.meta = void 0);
    const { to: r, from: i, hash: s, el: o, event: a } = n;
    (this.id = Math.random()),
      (this.state = 1),
      (this.from = { url: i ?? e.location.url, hash: e.location.hash }),
      (this.to = { url: r, hash: s }),
      (this.containers = e.options.containers),
      (this.animation = {
        animate: !0,
        wait: !1,
        name: void 0,
        native: e.options.native,
        scope: e.options.animationScope,
        selector: e.options.animationSelector,
      }),
      (this.trigger = { el: o, event: a }),
      (this.cache = { read: e.options.cache, write: e.options.cache }),
      (this.history = { action: "push", popstate: !1, direction: void 0 }),
      (this.scroll = { reset: !0, target: void 0 }),
      (this.meta = {});
  }
  advance(e) {
    this.state < e && (this.state = e);
  }
  abort() {
    this.state = 8;
  }
  get done() {
    return this.state >= 7;
  }
};
function hu(t) {
  return new So(this, t);
}
let du = class {
  constructor(e) {
    (this.swup = void 0),
      (this.registry = new Map()),
      (this.hooks = [
        "animation:out:start",
        "animation:out:await",
        "animation:out:end",
        "animation:in:start",
        "animation:in:await",
        "animation:in:end",
        "animation:skip",
        "cache:clear",
        "cache:set",
        "content:replace",
        "content:scroll",
        "enable",
        "disable",
        "fetch:request",
        "fetch:error",
        "fetch:timeout",
        "history:popstate",
        "link:click",
        "link:self",
        "link:anchor",
        "link:newtab",
        "page:load",
        "page:view",
        "scroll:top",
        "scroll:anchor",
        "visit:start",
        "visit:transition",
        "visit:abort",
        "visit:end",
      ]),
      (this.swup = e),
      this.init();
  }
  init() {
    this.hooks.forEach((e) => this.create(e));
  }
  create(e) {
    this.registry.has(e) || this.registry.set(e, new Map());
  }
  exists(e) {
    return this.registry.has(e);
  }
  get(e) {
    const n = this.registry.get(e);
    if (n) return n;
    console.error(`Unknown hook '${e}'`);
  }
  clear() {
    this.registry.forEach((e) => e.clear());
  }
  on(e, n, r = {}) {
    const i = this.get(e);
    if (!i) return console.warn(`Hook '${e}' not found.`), () => {};
    const s = I({}, r, { id: i.size + 1, hook: e, handler: n });
    return i.set(n, s), () => this.off(e, n);
  }
  before(e, n, r = {}) {
    return this.on(e, n, I({}, r, { before: !0 }));
  }
  replace(e, n, r = {}) {
    return this.on(e, n, I({}, r, { replace: !0 }));
  }
  once(e, n, r = {}) {
    return this.on(e, n, I({}, r, { once: !0 }));
  }
  off(e, n) {
    const r = this.get(e);
    r && n
      ? r.delete(n) || console.warn(`Handler for hook '${e}' not found.`)
      : r && r.clear();
  }
  async call(e, n, r, i) {
    const [s, o, a] = this.parseCallArgs(e, n, r, i),
      { before: l, handler: u, after: c } = this.getHandlers(e, a);
    await this.run(l, s, o);
    const [f] = await this.run(u, s, o, !0);
    return await this.run(c, s, o), this.dispatchDomEvent(e, s, o), f;
  }
  callSync(e, n, r, i) {
    const [s, o, a] = this.parseCallArgs(e, n, r, i),
      { before: l, handler: u, after: c } = this.getHandlers(e, a);
    this.runSync(l, s, o);
    const [f] = this.runSync(u, s, o, !0);
    return this.runSync(c, s, o), this.dispatchDomEvent(e, s, o), f;
  }
  parseCallArgs(e, n, r, i) {
    return n instanceof So || (typeof n != "object" && typeof r != "function")
      ? [n, r, i]
      : [void 0, n, r];
  }
  async run(e, n = this.swup.visit, r, i = !1) {
    const s = [];
    for (const { hook: o, handler: a, defaultHandler: l, once: u } of e)
      if (n == null || !n.done) {
        u && this.off(o, a);
        try {
          const c = await cu(a, [n, r, l]);
          s.push(c);
        } catch (c) {
          if (i) throw c;
          console.error(`Error in hook '${o}':`, c);
        }
      }
    return s;
  }
  runSync(e, n = this.swup.visit, r, i = !1) {
    const s = [];
    for (const { hook: o, handler: a, defaultHandler: l, once: u } of e)
      if (n == null || !n.done) {
        u && this.off(o, a);
        try {
          const c = a(n, r, l);
          s.push(c),
            bo(c) &&
              console.warn(
                `Swup will not await Promises in handler for synchronous hook '${o}'.`
              );
        } catch (c) {
          if (i) throw c;
          console.error(`Error in hook '${o}':`, c);
        }
      }
    return s;
  }
  getHandlers(e, n) {
    const r = this.get(e);
    if (!r)
      return { found: !1, before: [], handler: [], after: [], replaced: !1 };
    const i = Array.from(r.values()),
      s = this.sortRegistrations,
      o = i.filter(({ before: f, replace: h }) => f && !h).sort(s),
      a = i
        .filter(({ replace: f }) => f)
        .filter((f) => !0)
        .sort(s),
      l = i.filter(({ before: f, replace: h }) => !f && !h).sort(s),
      u = a.length > 0;
    let c = [];
    if (n && ((c = [{ id: 0, hook: e, handler: n }]), u)) {
      const f = a.length - 1,
        { handler: h, once: d } = a[f],
        m = (y) => {
          const p = a[y - 1];
          return p ? (g, v) => p.handler(g, v, m(y - 1)) : n;
        };
      c = [{ id: 0, hook: e, once: d, handler: h, defaultHandler: m(f) }];
    }
    return { found: !0, before: o, handler: c, after: l, replaced: u };
  }
  sortRegistrations(e, n) {
    var r, i;
    return (
      ((r = e.priority) != null ? r : 0) - ((i = n.priority) != null ? i : 0) ||
      e.id - n.id ||
      0
    );
  }
  dispatchDomEvent(e, n, r) {
    if (n != null && n.done) return;
    const i = { hook: e, args: r, visit: n || this.swup.visit };
    document.dispatchEvent(
      new CustomEvent("swup:any", { detail: i, bubbles: !0 })
    ),
      document.dispatchEvent(
        new CustomEvent(`swup:${e}`, { detail: i, bubbles: !0 })
      );
  }
  parseName(e) {
    const [n, ...r] = e.split(".");
    return [n, r.reduce((i, s) => I({}, i, { [s]: !0 }), {})];
  }
};
const pu = (t) => {
    if ((t && t.charAt(0) === "#" && (t = t.substring(1)), !t)) return null;
    const e = decodeURIComponent(t);
    let n =
      document.getElementById(t) ||
      document.getElementById(e) ||
      Ln(`a[name='${CSS.escape(t)}']`) ||
      Ln(`a[name='${CSS.escape(e)}']`);
    return n || t !== "top" || (n = document.body), n;
  },
  Pe = "transition",
  hn = "animation";
async function mu({ selector: t, elements: e }) {
  if (t === !1 && !e) return;
  let n = [];
  if (e) n = Array.from(e);
  else if (t && ((n = Cr(t, document.body)), !n.length))
    return void console.warn(
      `[swup] No elements found matching animationSelector \`${t}\``
    );
  const r = n.map((i) =>
    (function (s) {
      const {
        type: o,
        timeout: a,
        propCount: l,
      } = (function (u) {
        const c = window.getComputedStyle(u),
          f = Me(c, `${Pe}Delay`),
          h = Me(c, `${Pe}Duration`),
          d = pi(f, h),
          m = Me(c, `${hn}Delay`),
          y = Me(c, `${hn}Duration`),
          p = pi(m, y),
          g = Math.max(d, p),
          v = g > 0 ? (d > p ? Pe : hn) : null;
        return {
          type: v,
          timeout: g,
          propCount: v ? (v === Pe ? h.length : y.length) : 0,
        };
      })(s);
      return (
        !(!o || !a) &&
        new Promise((u) => {
          const c = `${o}end`,
            f = performance.now();
          let h = 0;
          const d = () => {
              s.removeEventListener(c, m), u();
            },
            m = (y) => {
              y.target === s &&
                ((performance.now() - f) / 1e3 < y.elapsedTime ||
                  (++h >= l && d()));
            };
          setTimeout(() => {
            h < l && d();
          }, a + 1),
            s.addEventListener(c, m);
        })
      );
    })(i)
  );
  r.filter(Boolean).length > 0
    ? await Promise.all(r)
    : t &&
      console.warn(
        `[swup] No CSS animation duration defined on elements matching \`${t}\``
      );
}
function Me(t, e) {
  return (t[e] || "").split(", ");
}
function pi(t, e) {
  for (; t.length < e.length; ) t = t.concat(t);
  return Math.max(...e.map((n, r) => mi(n) + mi(t[r])));
}
function mi(t) {
  return 1e3 * parseFloat(t);
}
function gu(t, e = {}, n = {}) {
  if (typeof t != "string")
    throw new Error("swup.navigate() requires a URL parameter");
  if (this.shouldIgnoreVisit(t, { el: n.el, event: n.event }))
    return void window.location.assign(t);
  const { url: r, hash: i } = P.fromUrl(t),
    s = this.createVisit(I({}, n, { to: r, hash: i }));
  this.performNavigation(s, e);
}
async function yu(t, e = {}) {
  if (this.navigating) {
    if (this.visit.state >= 6)
      return (
        (t.state = 2),
        void (this.onVisitEnd = () => this.performNavigation(t, e))
      );
    await this.hooks.call("visit:abort", this.visit, void 0),
      delete this.visit.to.document,
      (this.visit.state = 8);
  }
  (this.navigating = !0), (this.visit = t);
  const { el: n } = t.trigger;
  (e.referrer = e.referrer || this.location.url),
    e.animate === !1 && (t.animation.animate = !1),
    t.animation.animate || this.classes.clear();
  const r = e.history || di(n, "data-swup-history");
  typeof r == "string" &&
    ["push", "replace"].includes(r) &&
    (t.history.action = r);
  const i = e.animation || di(n, "data-swup-animation");
  var s, o;
  typeof i == "string" && (t.animation.name = i),
    (t.meta = e.meta || {}),
    typeof e.cache == "object"
      ? ((t.cache.read = (s = e.cache.read) != null ? s : t.cache.read),
        (t.cache.write = (o = e.cache.write) != null ? o : t.cache.write))
      : e.cache !== void 0 && (t.cache = { read: !!e.cache, write: !!e.cache }),
    delete e.cache;
  try {
    await this.hooks.call("visit:start", t, void 0), (t.state = 3);
    const a = this.hooks.call("page:load", t, { options: e }, async (u, c) => {
      let f;
      return (
        u.cache.read && (f = this.cache.get(u.to.url)),
        (c.page = f || (await this.fetchPage(u.to.url, c.options))),
        (c.cache = !!f),
        c.page
      );
    });
    a.then(({ html: u }) => {
      t.advance(5),
        (t.to.html = u),
        (t.to.document = new DOMParser().parseFromString(u, "text/html"));
    });
    const l = t.to.url + t.to.hash;
    if (
      (t.history.popstate ||
        (t.history.action === "replace" || t.to.url === this.location.url
          ? Qt(l)
          : (this.currentHistoryIndex++,
            su(l, { index: this.currentHistoryIndex }))),
      (this.location = P.fromUrl(l)),
      t.history.popstate && this.classes.add("is-popstate"),
      t.animation.name && this.classes.add(`to-${Er(t.animation.name)}`),
      t.animation.wait && (await a),
      t.done ||
        (await this.hooks.call("visit:transition", t, void 0, async () => {
          if (!t.animation.animate)
            return (
              await this.hooks.call("animation:skip", void 0),
              void (await this.renderPage(t, await a))
            );
          t.advance(4),
            await this.animatePageOut(t),
            t.animation.native && document.startViewTransition
              ? await document.startViewTransition(
                  async () => await this.renderPage(t, await a)
                ).finished
              : await this.renderPage(t, await a),
            await this.animatePageIn(t);
        }),
        t.done))
    )
      return;
    await this.hooks.call("visit:end", t, void 0, () => this.classes.clear()),
      (t.state = 7),
      (this.navigating = !1),
      this.onVisitEnd && (this.onVisitEnd(), (this.onVisitEnd = void 0));
  } catch (a) {
    if (!a || (a != null && a.aborted)) return void (t.state = 8);
    (t.state = 9),
      console.error(a),
      (this.options.skipPopStateHandling = () => (
        window.location.assign(t.to.url + t.to.hash), !0
      )),
      window.history.back();
  } finally {
    delete t.to.document;
  }
}
const vu = async function (t) {
    await this.hooks.call("animation:out:start", t, void 0, () => {
      this.classes.add("is-changing", "is-animating", "is-leaving");
    }),
      await this.hooks.call(
        "animation:out:await",
        t,
        { skip: !1 },
        (e, { skip: n }) => {
          if (!n)
            return this.awaitAnimations({ selector: e.animation.selector });
        }
      ),
      await this.hooks.call("animation:out:end", t, void 0);
  },
  wu = function (t) {
    var e;
    const n = t.to.document;
    if (!n) return !1;
    const r =
      ((e = n.querySelector("title")) == null ? void 0 : e.innerText) || "";
    document.title = r;
    const i = Cr('[data-swup-persist]:not([data-swup-persist=""])'),
      s = t.containers
        .map((o) => {
          const a = document.querySelector(o),
            l = n.querySelector(o);
          return a && l
            ? (a.replaceWith(l.cloneNode(!0)), !0)
            : (a ||
                console.warn(
                  `[swup] Container missing in current document: ${o}`
                ),
              l ||
                console.warn(
                  `[swup] Container missing in incoming document: ${o}`
                ),
              !1);
        })
        .filter(Boolean);
    return (
      i.forEach((o) => {
        const a = o.getAttribute("data-swup-persist"),
          l = Ln(`[data-swup-persist="${a}"]`);
        l && l !== o && l.replaceWith(o);
      }),
      s.length === t.containers.length
    );
  },
  bu = function (t) {
    const e = { behavior: "auto" },
      { target: n, reset: r } = t.scroll,
      i = n ?? t.to.hash;
    let s = !1;
    return (
      i &&
        (s = this.hooks.callSync(
          "scroll:anchor",
          t,
          { hash: i, options: e },
          (o, { hash: a, options: l }) => {
            const u = this.getAnchorElement(a);
            return u && u.scrollIntoView(l), !!u;
          }
        )),
      r &&
        !s &&
        (s = this.hooks.callSync(
          "scroll:top",
          t,
          { options: e },
          (o, { options: a }) => (
            window.scrollTo(I({ top: 0, left: 0 }, a)), !0
          )
        )),
      s
    );
  },
  Su = async function (t) {
    if (t.done) return;
    const e = this.hooks.call(
      "animation:in:await",
      t,
      { skip: !1 },
      (n, { skip: r }) => {
        if (!r) return this.awaitAnimations({ selector: n.animation.selector });
      }
    );
    await wo(),
      await this.hooks.call("animation:in:start", t, void 0, () => {
        this.classes.remove("is-animating");
      }),
      await e,
      await this.hooks.call("animation:in:end", t, void 0);
  },
  _u = async function (t, e) {
    if (t.done) return;
    t.advance(6);
    const { url: n } = e;
    this.isSameResolvedUrl(ht(), n) ||
      (Qt(n),
      (this.location = P.fromUrl(n)),
      (t.to.url = this.location.url),
      (t.to.hash = this.location.hash)),
      await this.hooks.call("content:replace", t, { page: e }, (r, {}) => {
        if (
          (this.classes.remove("is-leaving"),
          r.animation.animate && this.classes.add("is-rendering"),
          !this.replaceContent(r))
        )
          throw new Error("[swup] Container mismatch, aborting");
        r.animation.animate &&
          (this.classes.add("is-changing", "is-animating", "is-rendering"),
          r.animation.name && this.classes.add(`to-${Er(r.animation.name)}`));
      }),
      await this.hooks.call("content:scroll", t, void 0, () =>
        this.scrollToContent(t)
      ),
      await this.hooks.call("page:view", t, {
        url: this.location.url,
        title: document.title,
      });
  },
  xu = function (t) {
    var e;
    if (((e = t), !!e?.isSwupPlugin)) {
      if (((t.swup = this), !t._checkRequirements || t._checkRequirements()))
        return (
          t._beforeMount && t._beforeMount(),
          t.mount(),
          this.plugins.push(t),
          this.plugins
        );
    } else console.error("Not a swup plugin instance", t);
  };
function Tu(t) {
  const e = this.findPlugin(t);
  if (e)
    return (
      e.unmount(),
      e._afterUnmount && e._afterUnmount(),
      (this.plugins = this.plugins.filter((n) => n !== e)),
      this.plugins
    );
  console.error("No such plugin", e);
}
function Au(t) {
  return this.plugins.find(
    (e) => e === t || e.name === t || e.name === `Swup${String(t)}`
  );
}
function Eu(t) {
  if (typeof this.options.resolveUrl != "function")
    return (
      console.warn("[swup] options.resolveUrl expects a callback function."), t
    );
  const e = this.options.resolveUrl(t);
  return e && typeof e == "string"
    ? e.startsWith("//") || e.startsWith("http")
      ? (console.warn(
          "[swup] options.resolveUrl needs to return a relative url"
        ),
        t)
      : e
    : (console.warn("[swup] options.resolveUrl needs to return a url"), t);
}
function Cu(t, e) {
  return this.resolveUrl(t) === this.resolveUrl(e);
}
const Pu = {
  animateHistoryBrowsing: !1,
  animationSelector: '[class*="transition-"]',
  animationScope: "html",
  cache: !0,
  containers: ["#swup"],
  hooks: {},
  ignoreVisit: (t, { el: e } = {}) =>
    !(e == null || !e.closest("[data-no-swup]")),
  linkSelector: "a[href]",
  linkToSelf: "scroll",
  native: !1,
  plugins: [],
  resolveUrl: (t) => t,
  requestHeaders: {
    "X-Requested-With": "swup",
    Accept: "text/html, application/xhtml+xml",
  },
  skipPopStateHandling: (t) => {
    var e;
    return ((e = t.state) == null ? void 0 : e.source) !== "swup";
  },
  timeout: 0,
};
let Mu = class {
  get currentPageUrl() {
    return this.location.url;
  }
  constructor(e = {}) {
    var n, r;
    (this.version = "4.8.2"),
      (this.options = void 0),
      (this.defaults = Pu),
      (this.plugins = []),
      (this.visit = void 0),
      (this.cache = void 0),
      (this.hooks = void 0),
      (this.classes = void 0),
      (this.location = P.fromUrl(window.location.href)),
      (this.currentHistoryIndex = void 0),
      (this.clickDelegate = void 0),
      (this.navigating = !1),
      (this.onVisitEnd = void 0),
      (this.use = xu),
      (this.unuse = Tu),
      (this.findPlugin = Au),
      (this.log = () => {}),
      (this.navigate = gu),
      (this.performNavigation = yu),
      (this.createVisit = hu),
      (this.delegateEvent = ou),
      (this.fetchPage = au),
      (this.awaitAnimations = mu),
      (this.renderPage = _u),
      (this.replaceContent = wu),
      (this.animatePageIn = Su),
      (this.animatePageOut = vu),
      (this.scrollToContent = bu),
      (this.getAnchorElement = pu),
      (this.getCurrentUrl = ht),
      (this.resolveUrl = Eu),
      (this.isSameResolvedUrl = Cu),
      (this.options = I({}, this.defaults, e)),
      (this.handleLinkClick = this.handleLinkClick.bind(this)),
      (this.handlePopState = this.handlePopState.bind(this)),
      (this.cache = new lu(this)),
      (this.classes = new fu(this)),
      (this.hooks = new du(this)),
      (this.visit = this.createVisit({ to: "" })),
      (this.currentHistoryIndex =
        (n = (r = window.history.state) == null ? void 0 : r.index) != null
          ? n
          : 1),
      this.enable();
  }
  async enable() {
    var e;
    const { linkSelector: n } = this.options;
    (this.clickDelegate = this.delegateEvent(n, "click", this.handleLinkClick)),
      window.addEventListener("popstate", this.handlePopState),
      this.options.animateHistoryBrowsing &&
        (window.history.scrollRestoration = "manual"),
      (this.options.native =
        this.options.native && !!document.startViewTransition),
      this.options.plugins.forEach((r) => this.use(r));
    for (const [r, i] of Object.entries(this.options.hooks)) {
      const [s, o] = this.hooks.parseName(r);
      this.hooks.on(s, i, o);
    }
    ((e = window.history.state) == null ? void 0 : e.source) !== "swup" &&
      Qt(null, { index: this.currentHistoryIndex }),
      await wo(),
      await this.hooks.call("enable", void 0, void 0, () => {
        const r = document.documentElement;
        r.classList.add("swup-enabled"),
          r.classList.toggle("swup-native", this.options.native);
      });
  }
  async destroy() {
    this.clickDelegate.destroy(),
      window.removeEventListener("popstate", this.handlePopState),
      this.cache.clear(),
      this.options.plugins.forEach((e) => this.unuse(e)),
      await this.hooks.call("disable", void 0, void 0, () => {
        const e = document.documentElement;
        e.classList.remove("swup-enabled"), e.classList.remove("swup-native");
      }),
      this.hooks.clear();
  }
  shouldIgnoreVisit(e, { el: n, event: r } = {}) {
    const { origin: i, url: s, hash: o } = P.fromUrl(e);
    return (
      i !== window.location.origin ||
      !(!n || !this.triggerWillOpenNewWindow(n)) ||
      !!this.options.ignoreVisit(s + o, { el: n, event: r })
    );
  }
  handleLinkClick(e) {
    const n = e.delegateTarget,
      { href: r, url: i, hash: s } = P.fromElement(n);
    if (this.shouldIgnoreVisit(r, { el: n, event: e })) return;
    if (this.navigating && i === this.visit.to.url)
      return void e.preventDefault();
    const o = this.createVisit({ to: i, hash: s, el: n, event: e });
    e.metaKey || e.ctrlKey || e.shiftKey || e.altKey
      ? this.hooks.callSync("link:newtab", o, { href: r })
      : e.button === 0 &&
        this.hooks.callSync("link:click", o, { el: n, event: e }, () => {
          var a;
          const l = (a = o.from.url) != null ? a : "";
          e.preventDefault(),
            i && i !== l
              ? this.isSameResolvedUrl(i, l) || this.performNavigation(o)
              : s
              ? this.hooks.callSync("link:anchor", o, { hash: s }, () => {
                  Qt(i + s), this.scrollToContent(o);
                })
              : this.hooks.callSync("link:self", o, void 0, () => {
                  this.options.linkToSelf === "navigate"
                    ? this.performNavigation(o)
                    : (Qt(i), this.scrollToContent(o));
                });
        });
  }
  handlePopState(e) {
    var n, r, i, s;
    const o =
      (n = (r = e.state) == null ? void 0 : r.url) != null
        ? n
        : window.location.href;
    if (
      this.options.skipPopStateHandling(e) ||
      this.isSameResolvedUrl(ht(), this.location.url)
    )
      return;
    const { url: a, hash: l } = P.fromUrl(o),
      u = this.createVisit({ to: a, hash: l, event: e });
    u.history.popstate = !0;
    const c = (i = (s = e.state) == null ? void 0 : s.index) != null ? i : 0;
    c &&
      c !== this.currentHistoryIndex &&
      ((u.history.direction =
        c - this.currentHistoryIndex > 0 ? "forwards" : "backwards"),
      (this.currentHistoryIndex = c)),
      (u.animation.animate = !1),
      (u.scroll.reset = !1),
      (u.scroll.target = !1),
      this.options.animateHistoryBrowsing &&
        ((u.animation.animate = !0), (u.scroll.reset = !0)),
      this.hooks.callSync("history:popstate", u, { event: e }, () => {
        this.performNavigation(u);
      });
  }
  triggerWillOpenNewWindow(e) {
    return !!e.matches('[download], [target="_blank"]');
  }
};
function te() {
  return (
    (te = Object.assign
      ? Object.assign.bind()
      : function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
          return t;
        }),
    te.apply(this, arguments)
  );
}
const gi = (t) =>
  String(t)
    .split(".")
    .map((e) => String(parseInt(e || "0", 10)))
    .concat(["0", "0"])
    .slice(0, 3)
    .join(".");
let me = class {
  constructor() {
    (this.isSwupPlugin = !0),
      (this.swup = void 0),
      (this.version = void 0),
      (this.requires = {}),
      (this.handlersToUnregister = []);
  }
  mount() {}
  unmount() {
    this.handlersToUnregister.forEach((e) => e()),
      (this.handlersToUnregister = []);
  }
  _beforeMount() {
    if (!this.name)
      throw new Error(
        "You must define a name of plugin when creating a class."
      );
  }
  _afterUnmount() {}
  _checkRequirements() {
    return (
      typeof this.requires != "object" ||
        Object.entries(this.requires).forEach(([e, n]) => {
          if (
            !(function (r, i, s) {
              const o = (function (a, l) {
                var u;
                if (a === "swup") return (u = l.version) != null ? u : "";
                {
                  var c;
                  const f = l.findPlugin(a);
                  return (c = f?.version) != null ? c : "";
                }
              })(r, s);
              return (
                !!o &&
                ((a, l) =>
                  l.every((u) => {
                    const [, c, f] = u.match(/^([\D]+)?(.*)$/) || [];
                    var h, d;
                    return ((m, y) => {
                      const p = {
                        "": (g) => g === 0,
                        ">": (g) => g > 0,
                        ">=": (g) => g >= 0,
                        "<": (g) => g < 0,
                        "<=": (g) => g <= 0,
                      };
                      return (p[y] || p[""])(m);
                    })(
                      ((d = f),
                      (h = gi((h = a))),
                      (d = gi(d)),
                      h.localeCompare(d, void 0, { numeric: !0 })),
                      c || ">="
                    );
                  }))(o, i)
              );
            })(e, (n = Array.isArray(n) ? n : [n]), this.swup)
          ) {
            const r = `${e} ${n.join(", ")}`;
            throw new Error(
              `Plugin version mismatch: ${this.name} requires ${r}`
            );
          }
        }),
      !0
    );
  }
  on(e, n, r = {}) {
    var i;
    n =
      !(i = n).name.startsWith("bound ") || i.hasOwnProperty("prototype")
        ? n.bind(this)
        : n;
    const s = this.swup.hooks.on(e, n, r);
    return this.handlersToUnregister.push(s), s;
  }
  once(e, n, r = {}) {
    return this.on(e, n, te({}, r, { once: !0 }));
  }
  before(e, n, r = {}) {
    return this.on(e, n, te({}, r, { before: !0 }));
  }
  replace(e, n, r = {}) {
    return this.on(e, n, te({}, r, { replace: !0 }));
  }
  off(e, n) {
    return this.swup.hooks.off(e, n);
  }
};
(function () {
  if (
    !(typeof window > "u" || typeof document > "u" || typeof HTMLElement > "u")
  ) {
    var t = !1;
    try {
      var e = document.createElement("div");
      e.addEventListener(
        "focus",
        function (s) {
          s.preventDefault(), s.stopPropagation();
        },
        !0
      ),
        e.focus(
          Object.defineProperty({}, "preventScroll", {
            get: function () {
              if (
                navigator &&
                typeof navigator.userAgent < "u" &&
                navigator.userAgent &&
                navigator.userAgent.match(/Edge\/1[7-8]/)
              )
                return (t = !1);
              t = !0;
            },
          })
        );
    } catch {}
    if (HTMLElement.prototype.nativeFocus === void 0 && !t) {
      HTMLElement.prototype.nativeFocus = HTMLElement.prototype.focus;
      var n = function (s) {
          for (
            var o = s.parentNode,
              a = [],
              l = document.scrollingElement || document.documentElement;
            o && o !== l;

          )
            (o.offsetHeight < o.scrollHeight ||
              o.offsetWidth < o.scrollWidth) &&
              a.push([o, o.scrollTop, o.scrollLeft]),
              (o = o.parentNode);
          return (o = l), a.push([o, o.scrollTop, o.scrollLeft]), a;
        },
        r = function (s) {
          for (var o = 0; o < s.length; o++)
            (s[o][0].scrollTop = s[o][1]), (s[o][0].scrollLeft = s[o][2]);
          s = [];
        },
        i = function (s) {
          if (s && s.preventScroll) {
            var o = n(this);
            if (typeof setTimeout == "function") {
              var a = this;
              setTimeout(function () {
                a.nativeFocus(), r(o);
              }, 0);
            } else this.nativeFocus(), r(o);
          } else this.nativeFocus();
        };
      HTMLElement.prototype.focus = i;
    }
  }
})();
function Dn() {
  return (
    (Dn = Object.assign
      ? Object.assign.bind()
      : function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
          return t;
        }),
    Dn.apply(this, arguments)
  );
}
function yi(t, e) {
  return Object.keys(e).reduce(
    (n, r) => n.replace(`{${r}}`, e[r] || ""),
    t || ""
  );
}
let Ou = class {
  constructor() {
    var e;
    (this.id = "swup-announcer"),
      (this.style =
        "position:absolute;top:0;left:0;clip:rect(0 0 0 0);clip-path:inset(50%);overflow:hidden;white-space:nowrap;word-wrap:normal;width:1px;height:1px;"),
      (this.region = void 0),
      (this.region = (e = this.getRegion()) != null ? e : this.createRegion());
  }
  getRegion() {
    return document.getElementById(this.id);
  }
  createRegion() {
    const e = (function (n) {
      const r = document.createElement("template");
      return (r.innerHTML = n), r.content.children[0];
    })(
      `<p aria-live="assertive" aria-atomic="true" id="${this.id}" style="${this.style}"></p>`
    );
    return document.body.appendChild(e), e;
  }
  announce(e, n = 0) {
    return new Promise((r) => {
      setTimeout(() => {
        this.region.textContent === e && (e = `${e}.`),
          (this.region.textContent = ""),
          (this.region.textContent = e),
          r();
      }, n);
    });
  }
};
function vi(t) {
  let e;
  if (
    ((e = typeof t == "string" ? document.querySelector(t) : t),
    !(e instanceof HTMLElement))
  )
    return;
  const n = e.getAttribute("tabindex");
  e.setAttribute("tabindex", "-1"),
    e.focus({ preventScroll: !0 }),
    n !== null && e.setAttribute("tabindex", n);
}
let Vu = class extends me {
  constructor(e = {}) {
    super(),
      (this.name = "SwupA11yPlugin"),
      (this.requires = { swup: ">=4" }),
      (this.defaults = {
        headingSelector: "h1",
        respectReducedMotion: !0,
        autofocus: !1,
        announcements: {
          visit: "Navigated to: {title}",
          url: "New page at {url}",
        },
      }),
      (this.options = void 0),
      (this.announcer = void 0),
      (this.announcementDelay = 100),
      (this.rootSelector = "body"),
      (this.handleAnchorScroll = (n, { hash: r }) => {
        const i = this.swup.getAnchorElement(r);
        i instanceof HTMLElement && vi(i);
      }),
      (this.options = Dn({}, this.defaults, e)),
      (this.announcer = new Ou());
  }
  mount() {
    this.swup.hooks.create("content:announce"),
      this.swup.hooks.create("content:focus"),
      this.before("visit:start", this.prepareVisit),
      this.on("visit:start", this.markAsBusy),
      this.on("visit:end", this.unmarkAsBusy),
      this.on("visit:end", this.focusContent),
      this.on("visit:end", this.announceContent),
      this.on("scroll:anchor", this.handleAnchorScroll),
      this.before("visit:start", this.disableAnimations),
      this.before("link:self", this.disableAnimations),
      this.before("link:anchor", this.disableAnimations),
      (this.swup.announce = this.announce.bind(this));
  }
  unmount() {
    this.swup.announce = void 0;
  }
  async announce(e) {
    await this.announcer.announce(e);
  }
  markAsBusy() {
    document.documentElement.setAttribute("aria-busy", "true");
  }
  unmarkAsBusy() {
    document.documentElement.removeAttribute("aria-busy");
  }
  prepareVisit(e) {
    e.a11y = { announce: void 0, focus: this.rootSelector };
  }
  announceContent(e) {
    this.swup.hooks.callSync("content:announce", e, void 0, (n) => {
      n.a11y.announce === void 0 &&
        (n.a11y.announce = this.getPageAnnouncement()),
        n.a11y.announce &&
          this.announcer.announce(n.a11y.announce, this.announcementDelay);
    });
  }
  focusContent(e) {
    this.swup.hooks.callSync("content:focus", e, void 0, (n) => {
      n.a11y.focus &&
        ((this.options.autofocus &&
          (function () {
            const r = (function () {
              const i = document.querySelector("body [autofocus]");
              if (
                i &&
                !i.closest('[inert], [aria-disabled], [aria-hidden="true"]')
              )
                return i;
            })();
            return !!r && (r !== document.activeElement && r.focus(), !0);
          })() === !0) ||
          vi(n.a11y.focus));
    });
  }
  getPageAnnouncement() {
    const { headingSelector: e, announcements: n } = this.options;
    return (function ({ headingSelector: r = "h1", announcements: i = {} }) {
      var s, o;
      const a = document.documentElement.lang || "*",
        { href: l, url: u, pathname: c } = P.fromUrl(window.location.href),
        f = (s = (o = i[a]) != null ? o : i["*"]) != null ? s : i;
      if (typeof f != "object") return;
      const h = document.querySelector(r);
      h ||
        console.warn(
          `SwupA11yPlugin: No main heading (${r}) found on new page`
        );
      const d =
        h?.getAttribute("aria-label") ||
        h?.textContent ||
        document.title ||
        yi(f.url, { href: l, url: u, path: c });
      return yi(f.visit, { title: d, href: l, url: u, path: c });
    })({ headingSelector: e, announcements: n });
  }
  disableAnimations(e) {
    this.options.respectReducedMotion &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
      ((e.animation.animate = !1), (e.scroll.animate = !1));
  }
};
function Ke() {
  return (
    (Ke = Object.assign
      ? Object.assign.bind()
      : function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
          return t;
        }),
    Ke.apply(null, arguments)
  );
}
function wi() {
  return window.matchMedia("(hover: hover)").matches;
}
function Oe(t) {
  return !!t && (t instanceof HTMLAnchorElement || t instanceof SVGAElement);
}
const bi = window.requestIdleCallback || ((t) => setTimeout(t, 1)),
  ku = ["preloadVisibleLinks"];
let $u = class extends me {
  constructor(e = {}) {
    var n;
    super(),
      (n = this),
      (this.name = "SwupPreloadPlugin"),
      (this.requires = { swup: ">=4.5" }),
      (this.defaults = {
        throttle: 5,
        preloadInitialPage: !0,
        preloadHoveredLinks: !0,
        preloadVisibleLinks: {
          enabled: !1,
          threshold: 0.2,
          delay: 500,
          containers: ["body"],
          ignore: () => !1,
        },
      }),
      (this.options = void 0),
      (this.queue = void 0),
      (this.preloadObserver = void 0),
      (this.preloadPromises = new Map()),
      (this.mouseEnterDelegate = void 0),
      (this.touchStartDelegate = void 0),
      (this.focusDelegate = void 0),
      (this.onPageLoad = (s, o, a) => {
        const { url: l } = s.to;
        return l && this.preloadPromises.has(l)
          ? this.preloadPromises.get(l)
          : a(s, o);
      }),
      (this.onMouseEnter = async function (s) {
        if (s.target !== s.delegateTarget || !wi()) return;
        const o = s.delegateTarget;
        if (!Oe(o)) return;
        const { url: a, hash: l } = P.fromElement(o),
          u = n.swup.createVisit({ to: a, hash: l, el: o, event: s });
        n.swup.hooks.callSync("link:hover", u, { el: o, event: s }),
          n.preload(o, { priority: !0 });
      }),
      (this.onTouchStart = (s) => {
        if (wi()) return;
        const o = s.delegateTarget;
        Oe(o) && this.preload(o, { priority: !0 });
      }),
      (this.onFocus = (s) => {
        const o = s.delegateTarget;
        Oe(o) && this.preload(o, { priority: !0 });
      });
    const { preloadVisibleLinks: r } = e,
      i = (function (s, o) {
        if (s == null) return {};
        var a = {};
        for (var l in s)
          if ({}.hasOwnProperty.call(s, l)) {
            if (o.includes(l)) continue;
            a[l] = s[l];
          }
        return a;
      })(e, ku);
    (this.options = Ke({}, this.defaults, i)),
      typeof r == "object"
        ? (this.options.preloadVisibleLinks = Ke(
            {},
            this.options.preloadVisibleLinks,
            { enabled: !0 },
            r
          ))
        : (this.options.preloadVisibleLinks.enabled = !!r),
      (this.preload = this.preload.bind(this)),
      (this.queue = (function (s = 1) {
        const o = [],
          a = [];
        let l = 0,
          u = 0;
        function c() {
          u < s &&
            l > 0 &&
            ((a.shift() || o.shift() || (() => {}))(), l--, u++);
        }
        return {
          add: function (f, h = !1) {
            if (f.__queued) {
              if (!h) return;
              {
                const d = o.indexOf(f);
                if (d >= 0) {
                  const m = o.splice(d, 1);
                  l -= m.length;
                }
              }
            }
            (f.__queued = !0), (h ? a : o).push(f), l++, l <= 1 && c();
          },
          next: function () {
            u--, c();
          },
        };
      })(this.options.throttle));
  }
  mount() {
    const e = this.swup;
    e.options.cache
      ? (e.hooks.create("page:preload"),
        e.hooks.create("link:hover"),
        (e.preload = this.preload),
        (e.preloadLinks = this.preloadLinks),
        this.replace("page:load", this.onPageLoad),
        this.preloadLinks(),
        this.on("page:view", () => this.preloadLinks()),
        this.options.preloadVisibleLinks.enabled &&
          (this.preloadVisibleLinks(),
          this.on("page:view", () => this.preloadVisibleLinks())),
        this.options.preloadHoveredLinks && this.preloadLinksOnAttention(),
        this.options.preloadInitialPage && this.preload(ht()))
      : console.warn(
          "SwupPreloadPlugin: swup cache needs to be enabled for preloading"
        );
  }
  unmount() {
    var e, n, r;
    (this.swup.preload = void 0),
      (this.swup.preloadLinks = void 0),
      this.preloadPromises.clear(),
      (e = this.mouseEnterDelegate) == null || e.destroy(),
      (n = this.touchStartDelegate) == null || n.destroy(),
      (r = this.focusDelegate) == null || r.destroy(),
      this.stopPreloadingVisibleLinks();
  }
  async preload(e, n = {}) {
    var r;
    let i, s;
    const o = (r = n.priority) != null && r;
    if (Array.isArray(e)) return Promise.all(e.map((l) => this.preload(l)));
    if (Oe(e)) (s = e), ({ href: i } = P.fromElement(e));
    else {
      if (typeof e != "string") return;
      i = e;
    }
    if (!i) return;
    if (this.swup.cache.has(i)) return this.swup.cache.get(i);
    if (this.preloadPromises.has(i)) return this.preloadPromises.get(i);
    if (!this.shouldPreload(i, { el: s })) return;
    const a = new Promise((l) => {
      this.queue.add(() => {
        this.performPreload(i)
          .catch(() => {})
          .then((u) => l(u))
          .finally(() => {
            this.queue.next(), this.preloadPromises.delete(i);
          });
      }, o);
    });
    return this.preloadPromises.set(i, a), a;
  }
  preloadLinks() {
    bi(() => {
      Array.from(
        document.querySelectorAll(
          "a[data-swup-preload], [data-swup-preload-all] a"
        )
      ).forEach((e) => this.preload(e));
    });
  }
  preloadLinksOnAttention() {
    const { swup: e } = this,
      { linkSelector: n } = e.options,
      r = { passive: !0, capture: !0 };
    (this.mouseEnterDelegate = e.delegateEvent(
      n,
      "mouseenter",
      this.onMouseEnter,
      r
    )),
      (this.touchStartDelegate = e.delegateEvent(
        n,
        "touchstart",
        this.onTouchStart,
        r
      )),
      (this.focusDelegate = e.delegateEvent(n, "focus", this.onFocus, r));
  }
  preloadVisibleLinks() {
    if (this.preloadObserver) return void this.preloadObserver.update();
    const {
      threshold: e,
      delay: n,
      containers: r,
    } = this.options.preloadVisibleLinks;
    (this.preloadObserver = (function ({
      threshold: i,
      delay: s,
      containers: o,
      callback: a,
      filter: l,
    }) {
      const u = new Map(),
        c = new IntersectionObserver(
          (m) => {
            m.forEach((y) => {
              y.isIntersecting ? f(y.target) : h(y.target);
            });
          },
          { threshold: i }
        ),
        f = (m) => {
          var y;
          const { href: p } = P.fromElement(m),
            g = (y = u.get(p)) != null ? y : new Set();
          u.set(p, g),
            g.add(m),
            setTimeout(() => {
              const v = u.get(p);
              v != null && v.size && (a(m), c.unobserve(m), v.delete(m));
            }, s);
        },
        h = (m) => {
          var y;
          const { href: p } = P.fromElement(m);
          (y = u.get(p)) == null || y.delete(m);
        },
        d = () => {
          bi(() => {
            const m = o.map((y) => `${y} a[*|href]`).join(", ");
            Array.from(document.querySelectorAll(m))
              .filter((y) => l(y))
              .forEach((y) => c.observe(y));
          });
        };
      return {
        start: () => d(),
        stop: () => c.disconnect(),
        update: () => (u.clear(), d()),
      };
    })({
      threshold: e,
      delay: n,
      containers: r,
      callback: (i) => this.preload(i),
      filter: (i) => {
        if (
          this.options.preloadVisibleLinks.ignore(i) ||
          !i.matches(this.swup.options.linkSelector)
        )
          return !1;
        const { href: s } = P.fromElement(i);
        return this.shouldPreload(s, { el: i });
      },
    })),
      this.preloadObserver.start();
  }
  stopPreloadingVisibleLinks() {
    this.preloadObserver && this.preloadObserver.stop();
  }
  shouldPreload(e, { el: n } = {}) {
    const { url: r, href: i } = P.fromUrl(e);
    return !(
      !(function () {
        if (navigator.connection) {
          var s;
          if (
            navigator.connection.saveData ||
            ((s = navigator.connection.effectiveType) != null &&
              s.endsWith("2g"))
          )
            return !1;
        }
        return !0;
      })() ||
      this.swup.cache.has(r) ||
      this.preloadPromises.has(r) ||
      this.swup.shouldIgnoreVisit(i, { el: n }) ||
      (n && this.swup.resolveUrl(r) === this.swup.resolveUrl(ht()))
    );
  }
  async performPreload(e) {
    var n = this;
    const { url: r } = P.fromUrl(e),
      i = this.swup.createVisit({ to: r });
    return await this.swup.hooks.call(
      "page:preload",
      i,
      { url: r },
      async function (o, a) {
        return (a.page = await n.swup.fetchPage(e, { visit: o })), a.page;
      }
    );
  }
};
const Si = (t) => typeof t == "object" && t != null && t.nodeType === 1,
  _i = (t, e) => (!e || t !== "hidden") && t !== "visible" && t !== "clip",
  dn = (t, e) => {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
      const n = getComputedStyle(t, null);
      return (
        _i(n.overflowY, e) ||
        _i(n.overflowX, e) ||
        ((r) => {
          const i = ((s) => {
            if (!s.ownerDocument || !s.ownerDocument.defaultView) return null;
            try {
              return s.ownerDocument.defaultView.frameElement;
            } catch {
              return null;
            }
          })(r);
          return (
            !!i &&
            (i.clientHeight < r.scrollHeight || i.clientWidth < r.scrollWidth)
          );
        })(t)
      );
    }
    return !1;
  },
  Ru = (t) => {
    const e = t.parentElement;
    return e ?? (t.getRootNode().host || null);
  },
  Fu = (t, e) => {
    var n, r, i, s;
    if (typeof document > "u") return [];
    const { boundary: o, skipOverflowHiddenElements: a } = e,
      l = typeof o == "function" ? o : (x) => x !== o;
    if (!Si(t)) throw new TypeError("Invalid target");
    const u = document.scrollingElement || document.documentElement,
      c = [];
    let f = t;
    for (; Si(f) && l(f); ) {
      if (((f = Ru(f)), f === u)) {
        c.push(f);
        break;
      }
      (f != null &&
        f === document.body &&
        dn(f) &&
        !dn(document.documentElement)) ||
        (f != null && dn(f, a) && c.push(f));
    }
    (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ||
      innerWidth,
      (s = (i = window.visualViewport) == null ? void 0 : i.height) != null ||
        innerHeight;
    const { scrollX: h, scrollY: d } = window,
      {
        height: m,
        width: y,
        top: p,
        right: g,
        bottom: v,
        left: b,
      } = t.getBoundingClientRect(),
      { top: w, left: S } = ((x) => {
        const _ = window.getComputedStyle(x);
        return {
          top: parseFloat(_.scrollMarginTop) || 0,
          right: parseFloat(_.scrollMarginRight) || 0,
          bottom: parseFloat(_.scrollMarginBottom) || 0,
          left: parseFloat(_.scrollMarginLeft) || 0,
        };
      })(t);
    let A = p - w,
      C = b - S;
    const T = [];
    for (let x = 0; x < c.length; x++) {
      const _ = c[x],
        {
          height: V,
          width: X,
          top: nt,
          right: Da,
          bottom: Na,
          left: rn,
        } = _.getBoundingClientRect(),
        B = getComputedStyle(_),
        H = parseInt(B.borderLeftWidth, 10),
        Wt = parseInt(B.borderTopWidth, 10),
        we = parseInt(B.borderRightWidth, 10),
        be = parseInt(B.borderBottomWidth, 10);
      let K = 0,
        q = 0;
      const Se =
          "offsetWidth" in _ ? _.offsetWidth - _.clientWidth - H - we : 0,
        gt =
          "offsetHeight" in _ ? _.offsetHeight - _.clientHeight - Wt - be : 0,
        rt =
          "offsetWidth" in _
            ? _.offsetWidth === 0
              ? 0
              : X / _.offsetWidth
            : 0,
        it =
          "offsetHeight" in _
            ? _.offsetHeight === 0
              ? 0
              : V / _.offsetHeight
            : 0;
      if (u === _)
        (K = A), (q = C), (K = Math.max(0, K + d)), (q = Math.max(0, q + h));
      else {
        (K = A - nt - Wt), (q = C - rn - H);
        const { scrollLeft: st, scrollTop: ot } = _;
        (K =
          it === 0
            ? 0
            : Math.max(0, Math.min(ot + K / it, _.scrollHeight - V / it + gt))),
          (q =
            rt === 0
              ? 0
              : Math.max(
                  0,
                  Math.min(st + q / rt, _.scrollWidth - X / rt + Se)
                )),
          (A += ot - K),
          (C += st - q);
      }
      T.push({ el: _, top: K, left: q });
    }
    return T;
  };
function Nn() {
  return (
    (Nn = Object.assign
      ? Object.assign.bind()
      : function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
          return t;
        }),
    Nn.apply(null, arguments)
  );
}
const xi = (t, e = document) => Array.from(e.querySelectorAll(t));
let Iu = class extends me {
  constructor(e = {}) {
    super(),
      (this.name = "SwupScrollPlugin"),
      (this.requires = { swup: ">=4.2.0" }),
      (this.defaults = {
        doScrollingRightAway: !1,
        animateScroll: { betweenPages: !0, samePageWithHash: !0, samePage: !0 },
        getAnchorElement: void 0,
        offset: 0,
        scrollContainers: "[data-swup-scroll-container]",
        shouldResetScrollPosition: () => !0,
        markScrollTarget: !1,
        scrollFunction: void 0,
      }),
      (this.options = void 0),
      (this.cachedScrollPositions = {}),
      (this.previousScrollRestoration = void 0),
      (this.currentCacheKey = void 0),
      (this.getAnchorElement = (n = "") =>
        typeof this.options.getAnchorElement == "function"
          ? this.options.getAnchorElement(n)
          : this.swup.getAnchorElement(n)),
      (this.getOffset = (n, r, i) => {
        let s;
        return (
          (s =
            typeof this.options.offset == "function"
              ? this.options.offset(n, r, i)
              : this.options.offset),
          typeof s == "object" &&
          typeof s.top == "number" &&
          typeof s.left == "number"
            ? s
            : { top: parseInt(String(s ?? ""), 10) || 0, left: 0 }
        );
      }),
      (this.onBeforeLinkToSelf = (n) => {
        n.scroll.animate = this.shouldAnimate("samePage");
      }),
      (this.handleScrollToTop = (n) => (
        this.scrollTo({ top: 0, left: 0 }, n.scroll.animate), !0
      )),
      (this.onBeforeLinkToAnchor = (n) => {
        n.scroll.animate = this.shouldAnimate("samePageWithHash");
      }),
      (this.handleScrollToAnchor = (n, { hash: r }) =>
        this.maybeScrollToAnchor(r, n.scroll.animate)),
      (this.onBeforeVisitStart = (n) => {
        (n.scroll.scrolledToContent = !1),
          (n.scroll.animate = this.shouldAnimate("betweenPages"));
      }),
      (this.onVisitStart = (n) => {
        var r;
        this.cacheScrollPositions(n.from.url),
          this.maybeResetScrollPositions(n);
        const i = (r = n.scroll.target) != null ? r : n.to.hash;
        n.scroll.animate &&
          this.options.doScrollingRightAway &&
          !i &&
          this.doScrollingBetweenPages(n);
      }),
      (this.handleScrollToContent = (n) => {
        n.scroll.scrolledToContent || this.doScrollingBetweenPages(n),
          this.restoreScrollContainers(n.to.url);
      }),
      (this.doScrollingBetweenPages = (n) => {
        var r;
        if (n.history.popstate && !n.animation.animate) return;
        const i = (r = n.scroll.target) != null ? r : n.to.hash;
        if (
          (i && this.maybeScrollToAnchor(i, n.scroll.animate)) ||
          !n.scroll.reset
        )
          return;
        const s = this.getCachedScrollPositions(n.to.url),
          { top: o = 0, left: a = 0 } = s?.window || { top: 0, left: 0 };
        requestAnimationFrame(() =>
          this.scrollTo({ top: o, left: a }, n.scroll.animate)
        ),
          (n.scroll.scrolledToContent = !0);
      }),
      (this.maybeResetScrollPositions = (n) => {
        const { popstate: r } = n.history,
          { url: i } = n.to,
          { el: s } = n.trigger;
        r ||
          (s && !this.options.shouldResetScrollPosition(s)) ||
          this.resetScrollPositions(i);
      }),
      (this.options = Nn({}, this.defaults, e));
  }
  mount() {
    const e = this.swup;
    e.hooks.create("scroll:start"),
      e.hooks.create("scroll:end"),
      (e.scrollTo = this.scrollTo.bind(this)),
      (this.previousScrollRestoration = window.history.scrollRestoration),
      e.options.animateHistoryBrowsing &&
        (window.history.scrollRestoration = "manual"),
      (this.updateScrollTarget = this.updateScrollTarget.bind(this)),
      this.options.markScrollTarget &&
        (window.addEventListener("popstate", this.updateScrollTarget),
        window.addEventListener("hashchange", this.updateScrollTarget),
        this.on("page:view", this.updateScrollTarget),
        this.on("link:anchor", this.updateScrollTarget),
        this.on("link:self", this.updateScrollTarget),
        this.updateScrollTarget()),
      this.before("visit:start", this.onBeforeVisitStart, { priority: -1 }),
      this.on("visit:start", this.onVisitStart, { priority: 1 }),
      this.replace("content:scroll", this.handleScrollToContent),
      this.before("link:self", this.onBeforeLinkToSelf, { priority: -1 }),
      this.replace("scroll:top", this.handleScrollToTop),
      this.before("link:anchor", this.onBeforeLinkToAnchor, { priority: -1 }),
      this.replace("scroll:anchor", this.handleScrollToAnchor);
  }
  unmount() {
    super.unmount(),
      this.previousScrollRestoration &&
        (window.history.scrollRestoration = this.previousScrollRestoration),
      window.removeEventListener("popstate", this.updateScrollTarget),
      window.removeEventListener("hashchange", this.updateScrollTarget),
      (this.cachedScrollPositions = {}),
      delete this.swup.scrollTo;
  }
  shouldAnimate(e) {
    return typeof this.options.animateScroll == "boolean"
      ? this.options.animateScroll
      : this.options.animateScroll[e];
  }
  maybeScrollToAnchor(e, n = !1) {
    if (!e) return !1;
    const r = this.getAnchorElement(e);
    return r
      ? r instanceof Element
        ? (this.scrollElementIntoView(r, n), !0)
        : (console.warn(`Anchor target ${e} is not a DOM node`), !1)
      : (console.warn(`Anchor target ${e} not found`), !1);
  }
  cacheScrollPositions(e) {
    const n = this.swup.resolveUrl(e),
      r = xi(this.options.scrollContainers).map((s) => ({
        top: s.scrollTop,
        left: s.scrollLeft,
      })),
      i = {
        window: { top: window.scrollY, left: window.scrollX },
        containers: r,
      };
    this.cachedScrollPositions[n] = i;
  }
  resetScrollPositions(e) {
    const n = this.swup.resolveUrl(e);
    delete this.cachedScrollPositions[n];
  }
  getCachedScrollPositions(e) {
    const n = this.swup.resolveUrl(e);
    return this.cachedScrollPositions[n];
  }
  restoreScrollContainers(e) {
    const n = this.getCachedScrollPositions(e);
    n &&
      n.containers.length !== 0 &&
      xi(this.options.scrollContainers).forEach((r, i) => {
        const s = n.containers[i];
        s != null && ((r.scrollTop = s.top), (r.scrollLeft = s.left));
      });
  }
  updateScrollTarget() {
    var e;
    const { hash: n } = window.location,
      r = document.querySelector("[data-swup-scroll-target]");
    let i = this.getAnchorElement(n);
    i instanceof HTMLBodyElement && (i = null),
      r !== i &&
        (r?.removeAttribute("data-swup-scroll-target"),
        (e = i) == null || e.setAttribute("data-swup-scroll-target", ""));
  }
  getRootScrollContainer() {
    return document.scrollingElement instanceof HTMLElement
      ? document.scrollingElement
      : document.documentElement;
  }
  scrollTo(e, n = !0, r) {
    var i;
    const s = this.swup.createVisit({ to: this.swup.location.url }),
      { top: o = 0, left: a = 0 } = typeof e == "number" ? { top: e } : e;
    r != null || (r = this.getRootScrollContainer()),
      ((i = this.options.scrollFunction) != null ? i : this.applyScroll)(
        r,
        o,
        a,
        n,
        () => this.swup.hooks.callSync("scroll:start", s, void 0),
        () => this.swup.hooks.callSync("scroll:end", s, void 0)
      );
  }
  applyScroll(e, n, r, i, s, o) {
    const a =
      e instanceof HTMLHtmlElement || e instanceof HTMLBodyElement ? window : e;
    s(),
      a.addEventListener("scrollend", o, { once: !0 }),
      a.addEventListener(
        "wheel",
        () => {
          e.scrollTo({
            top: e.scrollTop,
            left: e.scrollLeft,
            behavior: "instant",
          });
        },
        { once: !0 }
      ),
      e.scrollTo({ top: n, left: r, behavior: i ? "smooth" : "instant" });
  }
  scrollElementIntoView(e, n = !1) {
    Fu(e, {}).forEach(({ top: r, left: i, el: s }) => {
      const { top: o = 0, left: a = 0 } = this.getOffset(e, s, {
        top: r,
        left: i,
      });
      this.scrollTo({ top: r - o, left: i - a }, n, s);
    });
  }
};
function Pt() {
  return (
    (Pt = Object.assign
      ? Object.assign.bind()
      : function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
          return t;
        }),
    Pt.apply(null, arguments)
  );
}
window.process || (window.process = {}),
  window.process.env || (window.process.env = {});
const _o = ["test"].includes("production"),
  M = ["development", "test"].includes("production"),
  xo = (t, e, n) => (t == null ? t : `\x1B[${e}m${String(t)}\x1B[${n}m`),
  pn = (t) => (_o ? t : `🧩 ${((e) => xo(e, 1, 22))(t)}`),
  L = (t) => (_o ? t : ((e) => xo(e, 94, 39))(t));
class Lu {
  log(...e) {
    const n = e.shift();
    console.log(pn(n), ...e);
  }
  warn(...e) {
    const n = e.shift();
    console.warn(pn(n), ...e);
  }
  error(...e) {
    const n = e.shift();
    console.error(pn(n), ...e);
  }
  logIf(e, ...n) {
    e && this.log(...n);
  }
  warnIf(e, ...n) {
    e && this.warn(...n);
  }
  errorIf(e, ...n) {
    e && this.error(...n);
  }
}
const To = (t) => {
    (function ({ parsedRules: e, swup: n, logger: r }) {
      const i = n.getCurrentUrl();
      e.filter((s) => s.matchesFrom(i) || s.matchesTo(i)).forEach((s) => {
        s.containers.forEach((o) => {
          const a = qe(`${o}:not([data-swup-fragment])`, n);
          if (!a) return;
          const l = a.getAttribute("data-swup-fragment-url");
          l &&
            M &&
            r?.log(`fragment url ${L(l)} for ${L(o)} provided by server`);
          const { url: u } = P.fromUrl(l || i);
          a.setAttribute("data-swup-fragment", ""),
            (a.__swupFragment = { url: u, selector: o });
        });
      });
    })(t),
      (function ({ logger: e, swup: n }) {
        const r = "data-swup-link-to-fragment";
        document.querySelectorAll(`a[${r}]`).forEach((i) => {
          var s;
          const o = i.getAttribute(r);
          if (!o)
            return void (
              M &&
              (e == null ||
                e.warn(`[${r}] needs to contain a valid fragment selector`))
            );
          const a = qe(o, n);
          if (!a)
            return void (
              M &&
              (e == null ||
                e.log(`ignoring ${L(`[${r}="${o}"]`)} as ${L(o)} is missing`))
            );
          const l = (s = a.__swupFragment) == null ? void 0 : s.url;
          l
            ? (Pr(l, n.getCurrentUrl()) &&
                M &&
                e?.warn(
                  `The fragment URL of ${o} is identical to the current URL. This could mean that [data-swup-fragment-url] needs to be provided by the server.`
                ),
              (i.href = l))
            : M && e?.warn(`no fragment infos found on ${o}`);
        });
      })(t),
      (function ({ logger: e }) {
        document
          .querySelectorAll("dialog[data-swup-fragment][open]")
          .forEach((n) => {
            n.__swupFragment
              ? n.__swupFragment.modalShown ||
                ((n.__swupFragment.modalShown = !0),
                n.removeAttribute("open"),
                n.showModal == null || n.showModal(),
                n.addEventListener(
                  "keydown",
                  (r) => r.key === "Escape" && r.preventDefault()
                ))
              : M && e?.warn("fragment properties missing on element:", n);
          });
      })(t);
  },
  Bn = (t, e) => {
    var n;
    const r = (n = t.__swupFragment) == null ? void 0 : n.url;
    return !!r && Pr(r, e);
  },
  Pr = (t, e) => Ti(t) === Ti(e),
  Ti = (t) => {
    if (!t.trim()) return t;
    const e = P.fromUrl(t);
    return e.searchParams.sort(), e.pathname.replace(/\/+$/g, "") + e.search;
  },
  Ao = (t) => {
    const e = t.from.url,
      n = t.to.url;
    if (e && n) return { from: e, to: n };
  },
  Mr = (t, e) => {
    if (t == null || !t.name) return;
    const { name: n, containers: r } = t;
    r.forEach((i) => {
      var s;
      (s = document.querySelector(i)) == null ||
        s.classList.toggle(`to-${n}`, e);
    });
  },
  Eo = (t, e, n) => e.find((r) => r.matches(t, n));
function Co(t) {
  return (
    !!t &&
    t.containers.every((e) => {
      var n;
      return (
        ((n = document.querySelector(e)) == null || (n = n.tagName) == null
          ? void 0
          : n.toLowerCase()) === "template"
      );
    })
  );
}
function qe(t, e) {
  for (const n of e.options.containers) {
    const r = document.querySelector(n);
    if (r != null && r.matches(t)) return r;
    const i = r?.querySelector(t);
    if (i) return i;
  }
}
function Ai(t) {
  if (!Array.isArray(t))
    throw new Error("cloneRules() expects an array of rules");
  return t.map((e) =>
    Pt({}, e, {
      from: Array.isArray(e.from) ? [...e.from] : e.from,
      to: Array.isArray(e.to) ? [...e.to] : e.to,
      containers: [...e.containers],
    })
  );
}
class Du {
  constructor(e) {
    var n, r;
    (this.matchesFrom = void 0),
      (this.matchesTo = void 0),
      (this.swup = void 0),
      (this.from = void 0),
      (this.to = void 0),
      (this.containers = void 0),
      (this.name = void 0),
      (this.scroll = !1),
      (this.focus = void 0),
      (this.logger = void 0),
      (this.if = () => !0),
      (this.watchSearchParams = void 0),
      (this.swup = e.swup),
      (this.logger = e.logger),
      (this.from = e.from || ""),
      (this.to = e.to || ""),
      e.name && (this.name = Er(e.name)),
      e.scroll !== void 0 && (this.scroll = e.scroll),
      e.focus !== void 0 && (this.focus = e.focus),
      typeof e.if == "function" && (this.if = e.if),
      e.watchSearchParams !== void 0 &&
        (this.watchSearchParams = e.watchSearchParams),
      (this.containers = this.parseContainers(e.containers)),
      M &&
        ((n = this.logger) == null ||
          n.errorIf(
            !this.to,
            "Every fragment rule must contain a 'to' path",
            this
          ),
        (r = this.logger) == null ||
          r.errorIf(
            !this.from,
            "Every fragment rule must contain a 'from' path",
            this
          )),
      (this.matchesFrom = hi(this.from)),
      (this.matchesTo = hi(this.to));
  }
  parseContainers(e) {
    var n, r;
    return Array.isArray(e) && e.length
      ? ((r = e.map((i) => i.trim())), [...new Set(r)]).filter((i) => {
          var s;
          const o = this.validateSelector(i);
          return (
            (s = this.logger) == null || s.errorIf(o instanceof Error, o),
            o === !0
          );
        })
      : (M &&
          ((n = this.logger) == null ||
            n.error(
              "Every fragment rule must contain an array of containers",
              this.getDebugInfo()
            )),
        []);
  }
  validateSelector(e) {
    return e.startsWith("#")
      ? !e.match(/\s|>/) ||
          new Error(`fragment selectors must not be nested: ${e}`)
      : new Error(`fragment selectors must be IDs: ${e}`);
  }
  getDebugInfo() {
    const { from: e, to: n, containers: r, watchSearchParams: i } = this;
    return {
      from: String(e),
      to: String(n),
      containers: String(r),
      watchSearchParams: i ? String(i) : void 0,
    };
  }
  hasSearchParamsChanged(e, n) {
    if (!this.watchSearchParams) return !1;
    const r = P.fromUrl(e),
      i = P.fromUrl(n);
    return (
      r.pathname === i.pathname &&
      (this.watchSearchParams === !0
        ? r.search !== i.search
        : !!Array.isArray(this.watchSearchParams) &&
          this.watchSearchParams.some(
            (s) => r.searchParams.get(s) !== i.searchParams.get(s)
          ))
    );
  }
  isSearchParamOnlyChange(e) {
    if (!this.watchSearchParams) return !1;
    const { url: n } = P.fromUrl(e.from),
      { url: r } = P.fromUrl(e.to),
      i = !!this.matchesFrom(n),
      s = !!this.matchesTo(n),
      o = !!this.matchesFrom(r),
      a = !!this.matchesTo(r);
    return (
      !((!i && !s) || (!o && !a)) && this.hasSearchParamsChanged(e.from, e.to)
    );
  }
  matches(e, n) {
    var r;
    if (!this.if(n))
      return (
        M &&
          ((r = this.logger) == null ||
            r.log("ignoring fragment rule due to custom rule.if:", this)),
        !1
      );
    const { url: i } = P.fromUrl(e.from),
      { url: s } = P.fromUrl(e.to),
      o = this.isSearchParamOnlyChange(e),
      a = !!this.matchesFrom(i) && !!this.matchesTo(s),
      l = P.fromUrl(e.from),
      u = P.fromUrl(e.to);
    if (l.pathname === u.pathname && l.search !== u.search) {
      if (!o) return !1;
      var c;
      M &&
        ((c = this.logger) == null ||
          c.log(
            "fragment rule matched due to search parameter change:",
            this.getDebugInfo()
          ));
    } else if (!a) return !1;
    for (const h of this.containers) {
      const d = this.validateFragmentSelectorForMatch(h);
      var f;
      if (d instanceof Error)
        return (
          M && ((f = this.logger) == null || f.error(d, this.getDebugInfo())),
          !1
        );
    }
    return !0;
  }
  validateFragmentSelectorForMatch(e) {
    return document.querySelector(e)
      ? !!qe(e, this.swup) ||
          new Error(
            `skipping rule since ${L(
              e
            )} is outside of swup's default containers`
          )
      : new Error(
          `skipping rule since ${L(e)} doesn't exist in the current document`
        );
  }
}
const Nu = function (t) {
    const e = Ao(t);
    e && Eo(e, this.parsedRules, t) && (t.scroll.reset = !1);
  },
  Bu = async function (t) {
    const e = Ao(t);
    if (!e) return;
    const n = this.getFragmentVisit(e, t);
    if (!n) return;
    var r;
    (t.fragmentVisit = n),
      M &&
        ((r = this.logger) == null ||
          r.log(`fragment visit: ${L(t.fragmentVisit.containers.join(", "))}`)),
      (t.scroll = (function (o, a) {
        return typeof o.scroll == "boolean"
          ? Pt({}, a, { reset: o.scroll })
          : typeof o.scroll != "string" || a.target
          ? a
          : Pt({}, a, { target: o.scroll });
      })(n, t.scroll));
    const i = t.a11y;
    var s;
    n.focus !== void 0 &&
      (M &&
        ((s = this.logger) == null ||
          s.errorIf(
            !i,
            "Can't set visit.a11y.focus. Is @swup/a11y-plugin installed?"
          )),
      i && (i.focus = n.focus)),
      (t.animation.scope = t.fragmentVisit.containers),
      (t.containers = t.fragmentVisit.containers),
      (t.animation.selector = t.fragmentVisit.containers.join(",")),
      Mr(n, !0);
  },
  ju = function (t, e) {
    var n, r;
    t.fragmentVisit &&
      Co(t.fragmentVisit) &&
      (M &&
        ((n = this.logger) == null ||
          n.log(
            `${L("out")}-animation skipped for ${L(
              (r = t.fragmentVisit) == null ? void 0 : r.containers.toString()
            )}`
          )),
      (e.skip = !0));
  },
  Hu = function (t, e) {
    var n, r;
    t.fragmentVisit &&
      Co(t.fragmentVisit) &&
      (M &&
        ((n = this.logger) == null ||
          n.log(
            `${L("in")}-animation skipped for ${L(
              (r = t.fragmentVisit) == null ? void 0 : r.containers.toString()
            )}`
          )),
      (e.skip = !0));
  },
  Uu = function (t, e) {
    var n;
    if (t.trigger.el || !t.to.url) return;
    const r = this.swup.cache.get(t.to.url);
    r &&
      r.fragmentHtml &&
      ((t.to.document = new DOMParser().parseFromString(
        r.fragmentHtml,
        "text/html"
      )),
      (t.to.html = r.fragmentHtml),
      M &&
        ((n = this.logger) == null ||
          n.log(`fragment cache used for ${L(t.to.url)}`)));
  },
  Wu = function (t) {
    Mr(t.fragmentVisit, !0),
      To(this),
      (({ swup: e, logger: n }) => {
        const r = e.getCurrentUrl(),
          i = e.cache,
          s = i.get(r);
        if (!s) return;
        const o = new DOMParser().parseFromString(s.html, "text/html"),
          a = [],
          l = Array.from(
            document.querySelectorAll("[data-swup-fragment]")
          ).filter((u) => !u.matches("template") && !Bn(u, r));
        l.length &&
          (e.options.cache
            ? (l.forEach((u) => {
                var c, f;
                if (u.querySelector("[data-swup-fragment]") != null) return;
                const h = (c = u.__swupFragment) == null ? void 0 : c.url;
                if (!h)
                  return void (
                    M &&
                    (n == null || n.warn("no fragment url found:", u))
                  );
                const d = (f = u.__swupFragment) == null ? void 0 : f.selector;
                if (!d)
                  return void (
                    M &&
                    (n == null || n.warn("no fragment selector found:", u))
                  );
                const m = i.get(h);
                if (!m) return;
                const y = o.querySelector(d);
                if (!y) return;
                const p = new DOMParser()
                  .parseFromString(m.html, "text/html")
                  .querySelector(d);
                p &&
                  (p.setAttribute("data-swup-fragment-url", h),
                  y.replaceWith(p),
                  a.push(u));
              }),
              a.length &&
                (i.update(r, { fragmentHtml: o.documentElement.outerHTML }),
                a.forEach((u) => {
                  var c, f;
                  const h =
                      ((c = u.__swupFragment) == null ? void 0 : c.url) || "",
                    d =
                      ((f = u.__swupFragment) == null ? void 0 : f.selector) ||
                      "";
                  M && n?.log(`updated cache with ${L(d)} from ${L(h)}`);
                })))
            : M &&
              n?.warn(
                "can't cache foreign fragment elements without swup's cache"
              ));
      })(this);
  },
  Ku = function (t) {
    Mr(t.fragmentVisit, !1);
  };
class qu extends me {
  get parsedRules() {
    return this._parsedRules;
  }
  constructor(e) {
    super(),
      (this.name = "SwupFragmentPlugin"),
      (this.requires = { swup: ">=4.6" }),
      (this._rawRules = []),
      (this._parsedRules = []),
      (this.options = void 0),
      (this.defaults = { rules: [], debug: !1 }),
      (this.logger = void 0),
      (this.options = Pt({}, this.defaults, e));
  }
  mount() {
    const e = this.swup;
    var n;
    this.setRules(this.options.rules),
      M && this.options.debug && (this.logger = new Lu()),
      this.before("link:self", Nu),
      this.on("visit:start", Bu),
      this.before("animation:out:await", ju),
      this.before("animation:in:await", Hu),
      this.before("content:replace", Uu),
      this.on("content:replace", Wu),
      this.on("visit:end", Ku),
      M &&
        ((n = this.logger) == null ||
          n.warnIf(
            !e.options.cache,
            "fragment caching will only work with swup's cache being active"
          )),
      To(this);
  }
  unmount() {
    super.unmount(),
      document.querySelectorAll("[data-swup-fragment]").forEach((e) => {
        e.removeAttribute("data-swup-fragment-url"), delete e.__swupFragment;
      });
  }
  setRules(e) {
    var n;
    (this._rawRules = Ai(e)),
      (this._parsedRules = e.map((r) => this.parseRule(r))),
      M &&
        ((n = this.logger) == null ||
          n.log("Updated fragment rules", this.getRules()));
  }
  getRules() {
    return Ai(this._rawRules);
  }
  prependRule(e) {
    this.setRules([e, ...this.getRules()]);
  }
  appendRule(e) {
    this.setRules([...this.getRules(), e]);
  }
  parseRule(e) {
    return new Du(Pt({}, e, { logger: this.logger, swup: this.swup }));
  }
  getFragmentVisit(e, n) {
    const r = Eo(e, this.parsedRules, n || this.swup.createVisit(e));
    if (!r) return;
    const i = ((l, u, c, f) => {
      let h = u
        .map((m) => {
          const y = document.querySelector(m);
          return y
            ? qe(m, c)
              ? { selector: m, el: y }
              : (M &&
                  f?.error(`${L(m)} is outside of swup's default containers`),
                !1)
            : (M && f?.log(`${L(m)} missing in current document`), !1);
        })
        .filter((m) => !!m);
      const d = h.every((m) => Bn(m.el, l.to));
      return (
        Pr(l.from, l.to) ||
          (d && c.options.linkToSelf === "navigate") ||
          (h = h.filter(
            (m) =>
              !Bn(m.el, l.to) ||
              (M &&
                f?.log(
                  `ignoring fragment ${L(
                    m.selector
                  )} as it already matches the current URL`
                ),
              !1)
          )),
        h.map((m) => m.selector)
      );
    })(e, r.containers, this.swup, this.logger);
    if (!i.length) return;
    const { name: s, scroll: o, focus: a } = r;
    return { containers: i, name: s, scroll: o, focus: a };
  }
}
function jn() {
  return (
    (jn = Object.assign
      ? Object.assign.bind()
      : function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
          return t;
        }),
    jn.apply(this, arguments)
  );
}
function Ei(t, e, { stripEmptyParams: n = !1 } = {}) {
  const r = Ve("method", t, e),
    i = Ve("enctype", t, e),
    s = i === "multipart/form-data",
    o = Ve("target", t, e, ""),
    { origin: a, href: l } = P.fromUrl(Ve("action", t, e)),
    u = new FormData(t, e);
  let c, f;
  if ((r === "POST" && (c = s ? u : new URLSearchParams(u)), r === "GET")) {
    const m = n
      ? (function (y) {
          const p = new FormData();
          for (const [g, v] of Array.from(y.entries()))
            v !== "" && p.append(g, v);
          return p;
        })(u)
      : u;
    f = (function (y, p) {
      const [g, v] = [...y.split(/(?=#)/), ""],
        b = g.split("?")[0],
        w = new URLSearchParams(p).toString();
      return w ? `${b}?${w}${v}` : b + v;
    })(l, m);
  } else f = l;
  const { url: h, hash: d } = P.fromUrl(f);
  return {
    origin: a,
    action: l,
    href: f,
    url: h,
    hash: d,
    method: r,
    target: o,
    data: u,
    body: c,
    encoding: i,
  };
}
function Ve(t, e, n, r) {
  var i, s;
  return (function (o, a) {
    switch (o) {
      case "action":
        return a ?? ht();
      case "method":
        return (a || "get").toUpperCase();
      case "enctype":
        return (a || "application/x-www-form-urlencoded").toLowerCase();
      default:
        return a ?? null;
    }
  })(
    t,
    (i = (s = n?.getAttribute(`form${t}`)) != null ? s : e.getAttribute(t)) !=
      null
      ? i
      : r
  );
}
class zu extends me {
  constructor(e = {}) {
    super(),
      (this.name = "SwupFormsPlugin"),
      (this.requires = { swup: ">=4" }),
      (this.defaults = {
        formSelector: "form[data-swup-form]",
        inlineFormSelector: "form[data-swup-inline-form]",
        stripEmptyParams: !1,
      }),
      (this.options = void 0),
      (this.specialKeys = void 0),
      (this.formSubmitDelegate = void 0),
      (this.prepareInlineForms = (n) => {
        const { el: r } = n.trigger;
        if (r == null || !r.matches(this.options.inlineFormSelector)) return;
        if (!r.id)
          return void console.error(
            "[@swup/forms-plugin] inline forms must have an id attribute:",
            r
          );
        const i = `#${r.id}`;
        (n.containers = [i]),
          (n.animation.scope = "containers"),
          (n.animation.selector = i),
          (n.scroll.target = i);
        const s = n.a11y;
        typeof s == "object" && (s.focus = i);
      }),
      (this.options = jn({}, this.defaults, e)),
      (this.specialKeys = (function (n) {
        let r = {};
        function i() {
          r = {};
        }
        function s({ key: l }) {
          n.includes(l) && (r[l] = !0);
        }
        function o({ key: l }) {
          n.includes(l) && (r[l] = !1);
        }
        function a() {
          i();
        }
        return {
          watch: function () {
            document.addEventListener("keydown", s),
              document.addEventListener("keyup", o),
              window.addEventListener("blur", a);
          },
          unwatch: function () {
            document.removeEventListener("keydown", s),
              document.removeEventListener("keyup", o),
              document.removeEventListener("blur", a),
              i();
          },
          get pressed() {
            return Object.values(r).filter(Boolean).length > 0;
          },
        };
      })(["Meta", "Control", "Shift"])),
      (this.beforeFormSubmit = this.beforeFormSubmit.bind(this));
  }
  mount() {
    this.swup.hooks.create("form:submit"),
      this.swup.hooks.create("form:submit:newtab"),
      this.specialKeys.watch(),
      (this.formSubmitDelegate = this.swup.delegateEvent(
        this.options.formSelector,
        "submit",
        this.beforeFormSubmit,
        { capture: !0 }
      )),
      this.on("visit:start", this.prepareInlineForms, { priority: 1 });
  }
  unmount() {
    var e;
    (e = this.formSubmitDelegate) == null || e.destroy(),
      this.specialKeys.unwatch();
  }
  beforeFormSubmit(e) {
    const n = this.swup,
      { delegateTarget: r, submitter: i } = e,
      { href: s, url: o, hash: a, target: l } = Ei(r, i),
      u = this.specialKeys.pressed,
      c = l === "_blank",
      f = u || c,
      h = n.createVisit({ to: o, hash: a, el: r, event: e });
    if (f || !n.shouldIgnoreVisit(s, { el: r, event: e }))
      if (c) n.hooks.callSync("form:submit:newtab", h, { el: r, event: e });
      else if (u) {
        n.hooks.callSync("form:submit:newtab", h, { el: r, event: e });
        const d = (function (m) {
          const y = m.getAttribute("target") || "";
          return (
            m.setAttribute("target", "_blank"),
            () => {
              y ? m.setAttribute("target", y) : m.removeAttribute("target");
            }
          );
        })(r);
        r.addEventListener("submit", () => setTimeout(d), { once: !0 });
      } else
        n.hooks.callSync("form:submit", h, { el: r, event: e }, () => {
          this.submitForm(e);
        });
  }
  submitForm(e) {
    const { delegateTarget: n, submitter: r } = e,
      { stripEmptyParams: i } = this.options,
      { href: s, method: o, body: a } = Ei(n, r, { stripEmptyParams: i });
    ["GET", "POST"].includes(o)
      ? (e.preventDefault(),
        this.swup.navigate(
          s,
          { method: o, body: a, cache: { read: !1, write: !0 } },
          { el: n, event: e }
        ))
      : console.warn(`Unsupported form method: ${o}`);
  }
}
function ee() {
  return (
    (ee = Object.assign
      ? Object.assign.bind()
      : function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
          return t;
        }),
    ee.apply(this, arguments)
  );
}
const Ci = (t) =>
  String(t)
    .split(".")
    .map((e) => String(parseInt(e || "0", 10)))
    .concat(["0", "0"])
    .slice(0, 3)
    .join(".");
let Gu = class {
  constructor() {
    (this.isSwupPlugin = !0),
      (this.swup = void 0),
      (this.version = void 0),
      (this.requires = {}),
      (this.handlersToUnregister = []);
  }
  mount() {}
  unmount() {
    this.handlersToUnregister.forEach((e) => e()),
      (this.handlersToUnregister = []);
  }
  _beforeMount() {
    if (!this.name)
      throw new Error(
        "You must define a name of plugin when creating a class."
      );
  }
  _afterUnmount() {}
  _checkRequirements() {
    return (
      typeof this.requires != "object" ||
        Object.entries(this.requires).forEach(([e, n]) => {
          if (
            !(function (r, i, s) {
              const o = (function (a, l) {
                var u;
                if (a === "swup") return (u = l.version) != null ? u : "";
                {
                  var c;
                  const f = l.findPlugin(a);
                  return (c = f?.version) != null ? c : "";
                }
              })(r, s);
              return (
                !!o &&
                ((a, l) =>
                  l.every((u) => {
                    const [, c, f] = u.match(/^([\D]+)?(.*)$/) || [];
                    var h, d;
                    return ((m, y) => {
                      const p = {
                        "": (g) => g === 0,
                        ">": (g) => g > 0,
                        ">=": (g) => g >= 0,
                        "<": (g) => g < 0,
                        "<=": (g) => g <= 0,
                      };
                      return (p[y] || p[""])(m);
                    })(
                      ((d = f),
                      (h = Ci((h = a))),
                      (d = Ci(d)),
                      h.localeCompare(d, void 0, { numeric: !0 })),
                      c || ">="
                    );
                  }))(o, i)
              );
            })(e, (n = Array.isArray(n) ? n : [n]), this.swup)
          ) {
            const r = `${e} ${n.join(", ")}`;
            throw new Error(
              `Plugin version mismatch: ${this.name} requires ${r}`
            );
          }
        }),
      !0
    );
  }
  on(e, n, r = {}) {
    var i;
    n =
      !(i = n).name.startsWith("bound ") || i.hasOwnProperty("prototype")
        ? n.bind(this)
        : n;
    const s = this.swup.hooks.on(e, n, r);
    return this.handlersToUnregister.push(s), s;
  }
  once(e, n, r = {}) {
    return this.on(e, n, ee({}, r, { once: !0 }));
  }
  before(e, n, r = {}) {
    return this.on(e, n, ee({}, r, { before: !0 }));
  }
  replace(e, n, r = {}) {
    return this.on(e, n, ee({}, r, { replace: !0 }));
  }
  off(e, n) {
    return this.swup.hooks.off(e, n);
  }
};
function Hn() {
  return (
    (Hn = Object.assign
      ? Object.assign.bind()
      : function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
          return t;
        }),
    Hn.apply(this, arguments)
  );
}
class Yu extends Gu {
  constructor(e = {}) {
    super(),
      (this.name = "SwupParallelPlugin"),
      (this.requires = { swup: ">=4.6" }),
      (this.defaults = { containers: [], keep: 0 }),
      (this.options = void 0),
      (this.originalContainers = null),
      (this.parallelContainers = []),
      (this.startVisit = (n) => {
        (this.originalContainers = null),
          this.visitHasPotentialParallelAnimation(n) &&
            ((n.animation.wait = !0), (n.animation.parallel = !0));
      }),
      (this.skipOutAnimation = (n, r) => {
        this.isParallelVisit(n) && (r.skip = !0);
      }),
      (this.insertContainers = (n) => {
        if (!this.isParallelVisit(n)) return;
        const r = this.getParallelContainersForVisit(n);
        (this.parallelContainers = r),
          this.swup.hooks.call("content:insert", { containers: r }, () => {
            for (const {
              all: s,
              next: o,
              previous: a,
              keep: l,
              remove: u,
            } of r)
              s.forEach((c, f) =>
                c.style.setProperty("--swup-parallel-container", `${f}`)
              ),
                a.setAttribute("aria-hidden", "true"),
                a.before(o),
                n.animation.animate &&
                  (o.classList.add("is-next-container"),
                  uu(o),
                  o.classList.remove("is-next-container")),
                a.classList.add("is-previous-container"),
                l.forEach((c) => c.classList.add("is-kept-container")),
                u.forEach((c) => c.classList.add("is-removing-container"));
          }),
          (this.originalContainers = n.containers);
        const i = this.parallelContainers.map(({ selector: s }) => s);
        n.containers = n.containers.filter((s) => !i.includes(s));
      }),
      (this.resetContainers = (n) => {
        this.originalContainers && (n.containers = this.originalContainers);
      }),
      (this.cleanupContainers = () => {
        const n = this.parallelContainers;
        this.swup.hooks.call("content:remove", { containers: n }, () => {
          for (const { remove: r, next: i } of n)
            r.forEach((s) => s.remove()),
              i.classList.remove("is-next-container");
        }),
          (this.parallelContainers = []);
      }),
      (this.options = Hn({}, this.defaults, e));
  }
  mount() {
    this.options.containers.length ||
      (this.options.containers = this.swup.options.containers),
      this.swup.hooks.create("content:insert"),
      this.swup.hooks.create("content:remove"),
      this.on("visit:start", this.startVisit, { priority: 1 }),
      this.before("animation:out:await", this.skipOutAnimation, {
        priority: 1,
      }),
      this.before("content:replace", this.insertContainers, { priority: 1 }),
      this.on("content:replace", this.resetContainers),
      this.on("visit:end", this.cleanupContainers);
  }
  getParallelContainersForVisit(e) {
    const { containers: n } = this.options,
      r = n.filter((i) => e.containers.includes(i));
    return r.length
      ? r.reduce((i, s) => {
          let { keep: o } = this.options;
          (o = typeof o == "object" ? o[s] : o), (o = Math.max(0, Number(o)));
          const a = e.to.document.querySelector(s),
            l = Array.from(document.querySelectorAll(s)),
            u = l[0],
            c = l.slice(0, o),
            f = l.slice(o),
            h = [...new Set([a, u, ...c, ...f])];
          return a && u
            ? [
                ...i,
                {
                  selector: s,
                  next: a,
                  previous: u,
                  keep: c,
                  remove: f,
                  all: h,
                },
              ]
            : (console.warn(`Parallel container ${s} not found`), i);
        }, [])
      : (console.warn(
          "No parallel containers found in list of replaced containers"
        ),
        []);
  }
  isParallelVisit(e) {
    return e.animation.parallel;
  }
  markVisitAsParallelAnimation(e) {
    (e.animation.wait = !0), (e.animation.parallel = !0);
  }
  visitHasPotentialParallelAnimation(e) {
    return e.animation.parallel !== !1 && this.visitHasParallelContainers(e);
  }
  visitHasParallelContainers(e) {
    return this.options.containers.some((n) => {
      const r = document.querySelector(n);
      return r?.matches(e.containers.join(","));
    });
  }
}
function Xu(t) {
  t.directive(
    "intersect",
    t.skipDuringClone(
      (
        e,
        { value: n, expression: r, modifiers: i },
        { evaluateLater: s, cleanup: o }
      ) => {
        let a = s(r),
          l = { rootMargin: Qu(i), threshold: Zu(i) },
          u = new IntersectionObserver((c) => {
            c.forEach((f) => {
              f.isIntersecting !== (n === "leave") &&
                (a(), i.includes("once") && u.disconnect());
            });
          }, l);
        u.observe(e),
          o(() => {
            u.disconnect();
          });
      }
    )
  );
}
function Zu(t) {
  if (t.includes("full")) return 0.99;
  if (t.includes("half")) return 0.5;
  if (!t.includes("threshold")) return 0;
  let e = t[t.indexOf("threshold") + 1];
  return e === "100" ? 1 : e === "0" ? 0 : +`.${e}`;
}
function Ju(t) {
  let e = t.match(/^(-?[0-9]+)(px|%)?$/);
  return e ? e[1] + (e[2] || "px") : void 0;
}
function Qu(t) {
  const e = "margin",
    n = "0px 0px 0px 0px",
    r = t.indexOf(e);
  if (r === -1) return n;
  let i = [];
  for (let s = 1; s < 5; s++) i.push(Ju(t[r + s] || ""));
  return (i = i.filter((s) => s !== void 0)), i.length ? i.join(" ").trim() : n;
}
var tf = Xu;
function ef(t) {
  t.directive("collapse", e),
    (e.inline = (n, { modifiers: r }) => {
      r.includes("min") && ((n._x_doShow = () => {}), (n._x_doHide = () => {}));
    });
  function e(n, { modifiers: r }) {
    let i = Pi(r, "duration", 250) / 1e3,
      s = Pi(r, "min", 0),
      o = !r.includes("min");
    n._x_isShown || (n.style.height = `${s}px`),
      !n._x_isShown && o && (n.hidden = !0),
      n._x_isShown || (n.style.overflow = "hidden");
    let a = (u, c) => {
        let f = t.setStyles(u, c);
        return c.height ? () => {} : f;
      },
      l = {
        transitionProperty: "height",
        transitionDuration: `${i}s`,
        transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)",
      };
    n._x_transition = {
      in(u = () => {}, c = () => {}) {
        o && (n.hidden = !1), o && (n.style.display = null);
        let f = n.getBoundingClientRect().height;
        n.style.height = "auto";
        let h = n.getBoundingClientRect().height;
        f === h && (f = s),
          t.transition(
            n,
            t.setStyles,
            {
              during: l,
              start: { height: f + "px" },
              end: { height: h + "px" },
            },
            () => (n._x_isShown = !0),
            () => {
              Math.abs(n.getBoundingClientRect().height - h) < 1 &&
                (n.style.overflow = null);
            }
          );
      },
      out(u = () => {}, c = () => {}) {
        let f = n.getBoundingClientRect().height;
        t.transition(
          n,
          a,
          { during: l, start: { height: f + "px" }, end: { height: s + "px" } },
          () => (n.style.overflow = "hidden"),
          () => {
            (n._x_isShown = !1),
              n.style.height == `${s}px` &&
                o &&
                ((n.style.display = "none"), (n.hidden = !0));
          }
        );
      },
    };
  }
}
function Pi(t, e, n) {
  if (t.indexOf(e) === -1) return n;
  const r = t[t.indexOf(e) + 1];
  if (!r) return n;
  if (e === "duration") {
    let i = r.match(/([0-9]+)ms/);
    if (i) return i[1];
  }
  if (e === "min") {
    let i = r.match(/([0-9]+)px/);
    if (i) return i[1];
  }
  return r;
}
var nf = ef;
async function rf({ listId: t, companyId: e, phoneNumber: n, email: r }) {
  const i = {
    method: "POST",
    headers: { revision: "2024-02-15", "content-type": "application/json" },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                ...(r && { email: r }),
                ...(n && { phone_number: n }),
              },
            },
          },
        },
        relationships: { list: { data: { type: "list", id: t } } },
      },
    }),
  };
  try {
    const s = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${e}`,
      i
    );
    if (s.status == 202 || s.status == 200) return s;
    const { errors: o } = await s.json();
    return o[0];
  } catch {
    throw Error("Something went wrong");
  }
}
const sf = "U47D4d",
  of = (t) => ({
    email: "",
    success: !1,
    error: null,
    loading: !1,
    invalid: !1,
    validateEmail(e) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
    },
    async submit() {
      if (!this.email) return (this.invalid = !0);
      if (this.validateEmail(this.email)) this.invalid = !1;
      else return (this.invalid = !0);
      if (!t) {
        this.error = "Missing List ID";
        return;
      }
      this.loading = !0;
      try {
        const e = await rf({ listId: t, email: this.email, companyId: sf });
        e.status == 202 || e.status == 200
          ? ((this.success = !0),
            window.dispatchEvent(
              new CustomEvent("shouldOpen", {
                detail: { email: this.email, listId: t, source: "newsletter" },
              })
            ))
          : e.errors?.[0]?.code === "invalid"
          ? (this.invalid = !0)
          : (this.error = e.errors ? e.errors[0] : "Unknown error");
      } catch (e) {
        throw ((this.error = "Something went wrong"), e);
      } finally {
        (this.invalid = !1), (this.loading = !1);
      }
    },
  }),
af = (t) => ({
    email: "",
    sms: "",
    whatsapp: "",
    init() {
      // Email message
      const emailSubject = "Plant a garden in Palestine with me";
      const emailBody = "Hi Friend,\n\nFor every email signup, ZAIIE—a new beauty brand powered by the olive tree—is sending $1 to Thamra, a grassroots organization building community gardens across Gaza.\n\n1 email = $1 to help plant these gardens, strengthening food sovereignty from the ground up.\n\nI just signed up. You can too ↓\n\nhttps://zaiie.com\n\nxoxo";
      
      // SMS message (shorter)
      const smsText = "Plant a garden in Palestine with me.\n\nFor every email signup, ZAIIE—a new beauty brand powered by the olive tree—is sending $1 to Thamra to build and plant gardens across Gaza.\n\nI just signed up. You can too ↓\n\nhttps://zaiie.com";
      
      // WhatsApp message (longer with extra line)
      const whatsappText = "Plant a garden in Palestine with me.\n\nFor every email signup, ZAIIE—a new beauty brand powered by the olive tree—is sending $1 to Thamra to build and plant gardens across Gaza.\n\n1 email = $1 to help plant these gardens.\n\nI just signed up. You can too ↓\n\nhttps://zaiie.com";
      
      const r = /Android/i.test(navigator.userAgent) ? "sms:?body=" : "sms:&body=";
      
      this.email = `mailto:?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
      this.sms = `${r}${encodeURIComponent(smsText)}`;
      this.whatsapp = `https://wa.me/?text=${encodeURIComponent(whatsappText)}`;
    },
  });
function lf(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Po(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
const dt = (t, e, n) => (n > e ? e : n < t ? t : n);
let Or = () => {};
const tt = {},
  Mo = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t);
function Oo(t) {
  return typeof t == "object" && t !== null;
}
const Vo = (t) => /^0[^.\s]+$/u.test(t);
function Vr(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const mt = (t) => t,
  cf = (t, e) => (n) => e(t(n)),
  kr = (...t) => t.reduce(cf),
  nn = (t, e, n) => {
    const r = e - t;
    return r === 0 ? 1 : (n - t) / r;
  };
class ko {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return lf(this.subscriptions, e), () => Po(this.subscriptions, e);
  }
  notify(e, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1) this.subscriptions[0](e, n, r);
      else
        for (let s = 0; s < i; s++) {
          const o = this.subscriptions[s];
          o && o(e, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const J = (t) => t * 1e3,
  z = (t) => t / 1e3;
function $r(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const uf = (t, e, n) => {
    const r = e - t;
    return ((((n - t) % r) + r) % r) + t;
  },
  $o = (t, e, n) =>
    (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t,
  ff = 1e-7,
  hf = 12;
function df(t, e, n, r, i) {
  let s,
    o,
    a = 0;
  do (o = e + (n - e) / 2), (s = $o(o, r, i) - t), s > 0 ? (n = o) : (e = o);
  while (Math.abs(s) > ff && ++a < hf);
  return o;
}
function ge(t, e, n, r) {
  if (t === e && n === r) return mt;
  const i = (s) => df(s, 0, 1, t, n);
  return (s) => (s === 0 || s === 1 ? s : $o(i(s), e, r));
}
const Ro = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2,
  Fo = (t) => (e) => 1 - t(1 - e),
  Io = ge(0.33, 1.53, 0.69, 0.99),
  Rr = Fo(Io),
  Lo = Ro(Rr),
  Do = (t) =>
    (t *= 2) < 1 ? 0.5 * Rr(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))),
  Fr = (t) => 1 - Math.sin(Math.acos(t)),
  pf = Fo(Fr),
  No = Ro(Fr),
  mf = ge(0.42, 0, 1, 1),
  gf = ge(0, 0, 0.58, 1),
  Bo = ge(0.42, 0, 0.58, 1),
  jo = (t) => Array.isArray(t) && typeof t[0] != "number";
function Ho(t, e) {
  return jo(t) ? t[uf(0, t.length, e)] : t;
}
const Uo = (t) => Array.isArray(t) && typeof t[0] == "number",
  yf = {
    linear: mt,
    easeIn: mf,
    easeInOut: Bo,
    easeOut: gf,
    circIn: Fr,
    circInOut: No,
    circOut: pf,
    backIn: Rr,
    backInOut: Lo,
    backOut: Io,
    anticipate: Do,
  },
  vf = (t) => typeof t == "string",
  Mi = (t) => {
    if (Uo(t)) {
      Or(t.length === 4);
      const [e, n, r, i] = t;
      return ge(e, n, r, i);
    } else if (vf(t)) return yf[t];
    return t;
  },
  ke = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender",
  ];
function wf(t, e) {
  let n = new Set(),
    r = new Set(),
    i = !1,
    s = !1;
  const o = new WeakSet();
  let a = { delta: 0, timestamp: 0, isProcessing: !1 };
  function l(c) {
    o.has(c) && (u.schedule(c), t()), c(a);
  }
  const u = {
    schedule: (c, f = !1, h = !1) => {
      const m = h && i ? n : r;
      return f && o.add(c), m.has(c) || m.add(c), c;
    },
    cancel: (c) => {
      r.delete(c), o.delete(c);
    },
    process: (c) => {
      if (((a = c), i)) {
        s = !0;
        return;
      }
      (i = !0),
        ([n, r] = [r, n]),
        n.forEach(l),
        n.clear(),
        (i = !1),
        s && ((s = !1), u.process(c));
    },
  };
  return u;
}
const bf = 40;
function Wo(t, e) {
  let n = !1,
    r = !0;
  const i = { delta: 0, timestamp: 0, isProcessing: !1 },
    s = () => (n = !0),
    o = ke.reduce((b, w) => ((b[w] = wf(s)), b), {}),
    {
      setup: a,
      read: l,
      resolveKeyframes: u,
      preUpdate: c,
      update: f,
      preRender: h,
      render: d,
      postRender: m,
    } = o,
    y = () => {
      const b = tt.useManualTiming ? i.timestamp : performance.now();
      (n = !1),
        tt.useManualTiming ||
          (i.delta = r ? 1e3 / 60 : Math.max(Math.min(b - i.timestamp, bf), 1)),
        (i.timestamp = b),
        (i.isProcessing = !0),
        a.process(i),
        l.process(i),
        u.process(i),
        c.process(i),
        f.process(i),
        h.process(i),
        d.process(i),
        m.process(i),
        (i.isProcessing = !1),
        n && e && ((r = !1), t(y));
    },
    p = () => {
      (n = !0), (r = !0), i.isProcessing || t(y);
    };
  return {
    schedule: ke.reduce((b, w) => {
      const S = o[w];
      return (b[w] = (A, C = !1, T = !1) => (n || p(), S.schedule(A, C, T))), b;
    }, {}),
    cancel: (b) => {
      for (let w = 0; w < ke.length; w++) o[ke[w]].cancel(b);
    },
    state: i,
    steps: o,
  };
}
const {
  schedule: j,
  cancel: se,
  state: oe,
} = Wo(typeof requestAnimationFrame < "u" ? requestAnimationFrame : mt, !0);
let Le;
function Sf() {
  Le = void 0;
}
const W = {
    now: () => (
      Le === void 0 &&
        W.set(
          oe.isProcessing || tt.useManualTiming
            ? oe.timestamp
            : performance.now()
        ),
      Le
    ),
    set: (t) => {
      (Le = t), queueMicrotask(Sf);
    },
  },
  Ko = (t) => (e) => typeof e == "string" && e.startsWith(t),
  qo = Ko("--"),
  _f = Ko("var(--"),
  Ir = (t) => (_f(t) ? xf.test(t.split("/*")[0].trim()) : !1),
  xf =
    /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu,
  Bt = {
    test: (t) => typeof t == "number",
    parse: parseFloat,
    transform: (t) => t,
  },
  ae = { ...Bt, transform: (t) => dt(0, 1, t) },
  $e = { ...Bt, default: 1 },
  ne = (t) => Math.round(t * 1e5) / 1e5,
  Lr = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Tf(t) {
  return t == null;
}
const Af =
    /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
  Dr = (t, e) => (n) =>
    !!(
      (typeof n == "string" && Af.test(n) && n.startsWith(t)) ||
      (e && !Tf(n) && Object.prototype.hasOwnProperty.call(n, e))
    ),
  zo = (t, e, n) => (r) => {
    if (typeof r != "string") return r;
    const [i, s, o, a] = r.match(Lr);
    return {
      [t]: parseFloat(i),
      [e]: parseFloat(s),
      [n]: parseFloat(o),
      alpha: a !== void 0 ? parseFloat(a) : 1,
    };
  },
  Ef = (t) => dt(0, 255, t),
  mn = { ...Bt, transform: (t) => Math.round(Ef(t)) },
  wt = {
    test: Dr("rgb", "red"),
    parse: zo("red", "green", "blue"),
    transform: ({ red: t, green: e, blue: n, alpha: r = 1 }) =>
      "rgba(" +
      mn.transform(t) +
      ", " +
      mn.transform(e) +
      ", " +
      mn.transform(n) +
      ", " +
      ne(ae.transform(r)) +
      ")",
  };
function Cf(t) {
  let e = "",
    n = "",
    r = "",
    i = "";
  return (
    t.length > 5
      ? ((e = t.substring(1, 3)),
        (n = t.substring(3, 5)),
        (r = t.substring(5, 7)),
        (i = t.substring(7, 9)))
      : ((e = t.substring(1, 2)),
        (n = t.substring(2, 3)),
        (r = t.substring(3, 4)),
        (i = t.substring(4, 5)),
        (e += e),
        (n += n),
        (r += r),
        (i += i)),
    {
      red: parseInt(e, 16),
      green: parseInt(n, 16),
      blue: parseInt(r, 16),
      alpha: i ? parseInt(i, 16) / 255 : 1,
    }
  );
}
const Un = { test: Dr("#"), parse: Cf, transform: wt.transform },
  ye = (t) => ({
    test: (e) =>
      typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
    parse: parseFloat,
    transform: (e) => `${e}${t}`,
  }),
  lt = ye("deg"),
  kt = ye("%"),
  E = ye("px"),
  Pf = ye("vh"),
  Mf = ye("vw"),
  Oi = {
    ...kt,
    parse: (t) => kt.parse(t) / 100,
    transform: (t) => kt.transform(t * 100),
  },
  Ot = {
    test: Dr("hsl", "hue"),
    parse: zo("hue", "saturation", "lightness"),
    transform: ({ hue: t, saturation: e, lightness: n, alpha: r = 1 }) =>
      "hsla(" +
      Math.round(t) +
      ", " +
      kt.transform(ne(e)) +
      ", " +
      kt.transform(ne(n)) +
      ", " +
      ne(ae.transform(r)) +
      ")",
  },
  R = {
    test: (t) => wt.test(t) || Un.test(t) || Ot.test(t),
    parse: (t) =>
      wt.test(t) ? wt.parse(t) : Ot.test(t) ? Ot.parse(t) : Un.parse(t),
    transform: (t) =>
      typeof t == "string"
        ? t
        : t.hasOwnProperty("red")
        ? wt.transform(t)
        : Ot.transform(t),
    getAnimatableNone: (t) => {
      const e = R.parse(t);
      return (e.alpha = 0), R.transform(e);
    },
  },
  Of =
    /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Vf(t) {
  return (
    isNaN(t) &&
    typeof t == "string" &&
    (t.match(Lr)?.length || 0) + (t.match(Of)?.length || 0) > 0
  );
}
const Go = "number",
  Yo = "color",
  kf = "var",
  $f = "var(",
  Vi = "${}",
  Rf =
    /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function le(t) {
  const e = t.toString(),
    n = [],
    r = { color: [], number: [], var: [] },
    i = [];
  let s = 0;
  const a = e
    .replace(
      Rf,
      (l) => (
        R.test(l)
          ? (r.color.push(s), i.push(Yo), n.push(R.parse(l)))
          : l.startsWith($f)
          ? (r.var.push(s), i.push(kf), n.push(l))
          : (r.number.push(s), i.push(Go), n.push(parseFloat(l))),
        ++s,
        Vi
      )
    )
    .split(Vi);
  return { values: n, split: a, indexes: r, types: i };
}
function Xo(t) {
  return le(t).values;
}
function Zo(t) {
  const { split: e, types: n } = le(t),
    r = e.length;
  return (i) => {
    let s = "";
    for (let o = 0; o < r; o++)
      if (((s += e[o]), i[o] !== void 0)) {
        const a = n[o];
        a === Go
          ? (s += ne(i[o]))
          : a === Yo
          ? (s += R.transform(i[o]))
          : (s += i[o]);
      }
    return s;
  };
}
const Ff = (t) =>
  typeof t == "number" ? 0 : R.test(t) ? R.getAnimatableNone(t) : t;
function If(t) {
  const e = Xo(t);
  return Zo(t)(e.map(Ff));
}
const jt = {
  test: Vf,
  parse: Xo,
  createTransformer: Zo,
  getAnimatableNone: If,
};
function gn(t, e, n) {
  return (
    n < 0 && (n += 1),
    n > 1 && (n -= 1),
    n < 1 / 6
      ? t + (e - t) * 6 * n
      : n < 1 / 2
      ? e
      : n < 2 / 3
      ? t + (e - t) * (2 / 3 - n) * 6
      : t
  );
}
function Lf({ hue: t, saturation: e, lightness: n, alpha: r }) {
  (t /= 360), (e /= 100), (n /= 100);
  let i = 0,
    s = 0,
    o = 0;
  if (!e) i = s = o = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e,
      l = 2 * n - a;
    (i = gn(l, a, t + 1 / 3)), (s = gn(l, a, t)), (o = gn(l, a, t - 1 / 3));
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(s * 255),
    blue: Math.round(o * 255),
    alpha: r,
  };
}
function ze(t, e) {
  return (n) => (n > 0 ? e : t);
}
const ve = (t, e, n) => t + (e - t) * n,
  yn = (t, e, n) => {
    const r = t * t,
      i = n * (e * e - r) + r;
    return i < 0 ? 0 : Math.sqrt(i);
  },
  Df = [Un, wt, Ot],
  Nf = (t) => Df.find((e) => e.test(t));
function ki(t) {
  const e = Nf(t);
  if (!e) return !1;
  let n = e.parse(t);
  return e === Ot && (n = Lf(n)), n;
}
const $i = (t, e) => {
    const n = ki(t),
      r = ki(e);
    if (!n || !r) return ze(t, e);
    const i = { ...n };
    return (s) => (
      (i.red = yn(n.red, r.red, s)),
      (i.green = yn(n.green, r.green, s)),
      (i.blue = yn(n.blue, r.blue, s)),
      (i.alpha = ve(n.alpha, r.alpha, s)),
      wt.transform(i)
    );
  },
  Wn = new Set(["none", "hidden"]);
function Bf(t, e) {
  return Wn.has(t) ? (n) => (n <= 0 ? t : e) : (n) => (n >= 1 ? e : t);
}
function jf(t, e) {
  return (n) => ve(t, e, n);
}
function Nr(t) {
  return typeof t == "number"
    ? jf
    : typeof t == "string"
    ? Ir(t)
      ? ze
      : R.test(t)
      ? $i
      : Wf
    : Array.isArray(t)
    ? Jo
    : typeof t == "object"
    ? R.test(t)
      ? $i
      : Hf
    : ze;
}
function Jo(t, e) {
  const n = [...t],
    r = n.length,
    i = t.map((s, o) => Nr(s)(s, e[o]));
  return (s) => {
    for (let o = 0; o < r; o++) n[o] = i[o](s);
    return n;
  };
}
function Hf(t, e) {
  const n = { ...t, ...e },
    r = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (r[i] = Nr(t[i])(t[i], e[i]));
  return (i) => {
    for (const s in r) n[s] = r[s](i);
    return n;
  };
}
function Uf(t, e) {
  const n = [],
    r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < e.values.length; i++) {
    const s = e.types[i],
      o = t.indexes[s][r[s]],
      a = t.values[o] ?? 0;
    (n[i] = a), r[s]++;
  }
  return n;
}
const Wf = (t, e) => {
  const n = jt.createTransformer(e),
    r = le(t),
    i = le(e);
  return r.indexes.var.length === i.indexes.var.length &&
    r.indexes.color.length === i.indexes.color.length &&
    r.indexes.number.length >= i.indexes.number.length
    ? (Wn.has(t) && !i.values.length) || (Wn.has(e) && !r.values.length)
      ? Bf(t, e)
      : kr(Jo(Uf(r, i), i.values), n)
    : ze(t, e);
};
function Qo(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number"
    ? ve(t, e, n)
    : Nr(t)(t, e);
}
const Kf = (t) => {
    const e = ({ timestamp: n }) => t(n);
    return {
      start: (n = !0) => j.update(e, n),
      stop: () => se(e),
      now: () => (oe.isProcessing ? oe.timestamp : W.now()),
    };
  },
  ta = (t, e, n = 10) => {
    let r = "";
    const i = Math.max(Math.round(e / n), 2);
    for (let s = 0; s < i; s++)
      r += Math.round(t(s / (i - 1)) * 1e4) / 1e4 + ", ";
    return `linear(${r.substring(0, r.length - 2)})`;
  },
  Ge = 2e4;
function Br(t) {
  let e = 0;
  const n = 50;
  let r = t.next(e);
  for (; !r.done && e < Ge; ) (e += n), (r = t.next(e));
  return e >= Ge ? 1 / 0 : e;
}
function ea(t, e = 100, n) {
  const r = n({ ...t, keyframes: [0, e] }),
    i = Math.min(Br(r), Ge);
  return {
    type: "keyframes",
    ease: (s) => r.next(i * s).value / e,
    duration: z(i),
  };
}
const qf = 5;
function na(t, e, n) {
  const r = Math.max(e - qf, 0);
  return $r(n - t(r), e - r);
}
const $ = {
    stiffness: 100,
    damping: 10,
    mass: 1,
    velocity: 0,
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    restSpeed: { granular: 0.01, default: 2 },
    restDelta: { granular: 0.005, default: 0.5 },
    minDuration: 0.01,
    maxDuration: 10,
    minDamping: 0.05,
    maxDamping: 1,
  },
  vn = 0.001;
function zf({
  duration: t = $.duration,
  bounce: e = $.bounce,
  velocity: n = $.velocity,
  mass: r = $.mass,
}) {
  let i,
    s,
    o = 1 - e;
  (o = dt($.minDamping, $.maxDamping, o)),
    (t = dt($.minDuration, $.maxDuration, z(t))),
    o < 1
      ? ((i = (u) => {
          const c = u * o,
            f = c * t,
            h = c - n,
            d = Kn(u, o),
            m = Math.exp(-f);
          return vn - (h / d) * m;
        }),
        (s = (u) => {
          const f = u * o * t,
            h = f * n + n,
            d = Math.pow(o, 2) * Math.pow(u, 2) * t,
            m = Math.exp(-f),
            y = Kn(Math.pow(u, 2), o);
          return ((-i(u) + vn > 0 ? -1 : 1) * ((h - d) * m)) / y;
        }))
      : ((i = (u) => {
          const c = Math.exp(-u * t),
            f = (u - n) * t + 1;
          return -vn + c * f;
        }),
        (s = (u) => {
          const c = Math.exp(-u * t),
            f = (n - u) * (t * t);
          return c * f;
        }));
  const a = 5 / t,
    l = Yf(i, s, a);
  if (((t = J(t)), isNaN(l)))
    return { stiffness: $.stiffness, damping: $.damping, duration: t };
  {
    const u = Math.pow(l, 2) * r;
    return { stiffness: u, damping: o * 2 * Math.sqrt(r * u), duration: t };
  }
}
const Gf = 12;
function Yf(t, e, n) {
  let r = n;
  for (let i = 1; i < Gf; i++) r = r - t(r) / e(r);
  return r;
}
function Kn(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const Xf = ["duration", "bounce"],
  Zf = ["stiffness", "damping", "mass"];
function Ri(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function Jf(t) {
  let e = {
    velocity: $.velocity,
    stiffness: $.stiffness,
    damping: $.damping,
    mass: $.mass,
    isResolvedFromDuration: !1,
    ...t,
  };
  if (!Ri(t, Zf) && Ri(t, Xf))
    if (t.visualDuration) {
      const n = t.visualDuration,
        r = (2 * Math.PI) / (n * 1.2),
        i = r * r,
        s = 2 * dt(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(i);
      e = { ...e, mass: $.mass, stiffness: i, damping: s };
    } else {
      const n = zf(t);
      (e = { ...e, ...n, mass: $.mass }), (e.isResolvedFromDuration = !0);
    }
  return e;
}
function ce(t = $.visualDuration, e = $.bounce) {
  const n =
    typeof t != "object"
      ? { visualDuration: t, keyframes: [0, 1], bounce: e }
      : t;
  let { restSpeed: r, restDelta: i } = n;
  const s = n.keyframes[0],
    o = n.keyframes[n.keyframes.length - 1],
    a = { done: !1, value: s },
    {
      stiffness: l,
      damping: u,
      mass: c,
      duration: f,
      velocity: h,
      isResolvedFromDuration: d,
    } = Jf({ ...n, velocity: -z(n.velocity || 0) }),
    m = h || 0,
    y = u / (2 * Math.sqrt(l * c)),
    p = o - s,
    g = z(Math.sqrt(l / c)),
    v = Math.abs(p) < 5;
  r || (r = v ? $.restSpeed.granular : $.restSpeed.default),
    i || (i = v ? $.restDelta.granular : $.restDelta.default);
  let b;
  if (y < 1) {
    const S = Kn(g, y);
    b = (A) => {
      const C = Math.exp(-y * g * A);
      return (
        o - C * (((m + y * g * p) / S) * Math.sin(S * A) + p * Math.cos(S * A))
      );
    };
  } else if (y === 1) b = (S) => o - Math.exp(-g * S) * (p + (m + g * p) * S);
  else {
    const S = g * Math.sqrt(y * y - 1);
    b = (A) => {
      const C = Math.exp(-y * g * A),
        T = Math.min(S * A, 300);
      return (
        o - (C * ((m + y * g * p) * Math.sinh(T) + S * p * Math.cosh(T))) / S
      );
    };
  }
  const w = {
    calculatedDuration: (d && f) || null,
    next: (S) => {
      const A = b(S);
      if (d) a.done = S >= f;
      else {
        let C = S === 0 ? m : 0;
        y < 1 && (C = S === 0 ? J(m) : na(b, S, A));
        const T = Math.abs(C) <= r,
          x = Math.abs(o - A) <= i;
        a.done = T && x;
      }
      return (a.value = a.done ? o : A), a;
    },
    toString: () => {
      const S = Math.min(Br(w), Ge),
        A = ta((C) => w.next(S * C).value, S, 30);
      return S + "ms " + A;
    },
    toTransition: () => {},
  };
  return w;
}
ce.applyToOptions = (t) => {
  const e = ea(t, 100, ce);
  return (
    (t.ease = e.ease), (t.duration = J(e.duration)), (t.type = "keyframes"), t
  );
};
function qn({
  keyframes: t,
  velocity: e = 0,
  power: n = 0.8,
  timeConstant: r = 325,
  bounceDamping: i = 10,
  bounceStiffness: s = 500,
  modifyTarget: o,
  min: a,
  max: l,
  restDelta: u = 0.5,
  restSpeed: c,
}) {
  const f = t[0],
    h = { done: !1, value: f },
    d = (T) => (a !== void 0 && T < a) || (l !== void 0 && T > l),
    m = (T) =>
      a === void 0
        ? l
        : l === void 0 || Math.abs(a - T) < Math.abs(l - T)
        ? a
        : l;
  let y = n * e;
  const p = f + y,
    g = o === void 0 ? p : o(p);
  g !== p && (y = g - f);
  const v = (T) => -y * Math.exp(-T / r),
    b = (T) => g + v(T),
    w = (T) => {
      const x = v(T),
        _ = b(T);
      (h.done = Math.abs(x) <= u), (h.value = h.done ? g : _);
    };
  let S, A;
  const C = (T) => {
    d(h.value) &&
      ((S = T),
      (A = ce({
        keyframes: [h.value, m(h.value)],
        velocity: na(b, T, h.value),
        damping: i,
        stiffness: s,
        restDelta: u,
        restSpeed: c,
      })));
  };
  return (
    C(0),
    {
      calculatedDuration: null,
      next: (T) => {
        let x = !1;
        return (
          !A && S === void 0 && ((x = !0), w(T), C(T)),
          S !== void 0 && T >= S ? A.next(T - S) : (!x && w(T), h)
        );
      },
    }
  );
}
function Qf(t, e, n) {
  const r = [],
    i = n || tt.mix || Qo,
    s = t.length - 1;
  for (let o = 0; o < s; o++) {
    let a = i(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] || mt : e;
      a = kr(l, a);
    }
    r.push(a);
  }
  return r;
}
function ra(t, e, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const s = t.length;
  if ((Or(s === e.length), s === 1)) return () => e[0];
  if (s === 2 && e[0] === e[1]) return () => e[1];
  const o = t[0] === t[1];
  t[0] > t[s - 1] && ((t = [...t].reverse()), (e = [...e].reverse()));
  const a = Qf(e, r, i),
    l = a.length,
    u = (c) => {
      if (o && c < t[0]) return e[0];
      let f = 0;
      if (l > 1) for (; f < t.length - 2 && !(c < t[f + 1]); f++);
      const h = nn(t[f], t[f + 1], c);
      return a[f](h);
    };
  return n ? (c) => u(dt(t[0], t[s - 1], c)) : u;
}
function ia(t, e) {
  const n = t[t.length - 1];
  for (let r = 1; r <= e; r++) {
    const i = nn(0, e, r);
    t.push(ve(n, 1, i));
  }
}
function jr(t) {
  const e = [0];
  return ia(e, t.length - 1), e;
}
function th(t, e) {
  return t.map((n) => n * e);
}
function eh(t, e) {
  return t.map(() => e || Bo).splice(0, t.length - 1);
}
function re({
  duration: t = 300,
  keyframes: e,
  times: n,
  ease: r = "easeInOut",
}) {
  const i = jo(r) ? r.map(Mi) : Mi(r),
    s = { done: !1, value: e[0] },
    o = th(n && n.length === e.length ? n : jr(e), t),
    a = ra(o, e, { ease: Array.isArray(i) ? i : eh(e, i) });
  return {
    calculatedDuration: t,
    next: (l) => ((s.value = a(l)), (s.done = l >= t), s),
  };
}
const nh = (t) => t !== null;
function Hr(t, { repeat: e, repeatType: n = "loop" }, r, i = 1) {
  const s = t.filter(nh),
    a = i < 0 || (e && n !== "loop" && e % 2 === 1) ? 0 : s.length - 1;
  return !a || r === void 0 ? s[a] : r;
}
const rh = { decay: qn, inertia: qn, tween: re, keyframes: re, spring: ce };
function sa(t) {
  typeof t.type == "string" && (t.type = rh[t.type]);
}
class Ur {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  then(e, n) {
    return this.finished.then(e, n);
  }
}
const ih = (t) => t / 100;
class Wr extends Ur {
  constructor(e) {
    super(),
      (this.state = "idle"),
      (this.startTime = null),
      (this.isStopped = !1),
      (this.currentTime = 0),
      (this.holdTime = null),
      (this.playbackSpeed = 1),
      (this.stop = () => {
        const { motionValue: n } = this.options;
        n && n.updatedAt !== W.now() && this.tick(W.now()),
          (this.isStopped = !0),
          this.state !== "idle" && (this.teardown(), this.options.onStop?.());
      }),
      (this.options = e),
      this.initAnimation(),
      this.play(),
      e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    sa(e);
    const {
      type: n = re,
      repeat: r = 0,
      repeatDelay: i = 0,
      repeatType: s,
      velocity: o = 0,
    } = e;
    let { keyframes: a } = e;
    const l = n || re;
    l !== re &&
      typeof a[0] != "number" &&
      ((this.mixKeyframes = kr(ih, Qo(a[0], a[1]))), (a = [0, 100]));
    const u = l({ ...e, keyframes: a });
    s === "mirror" &&
      (this.mirroredGenerator = l({
        ...e,
        keyframes: [...a].reverse(),
        velocity: -o,
      })),
      u.calculatedDuration === null && (u.calculatedDuration = Br(u));
    const { calculatedDuration: c } = u;
    (this.calculatedDuration = c),
      (this.resolvedDuration = c + i),
      (this.totalDuration = this.resolvedDuration * (r + 1) - i),
      (this.generator = u);
  }
  updateTime(e) {
    const n = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null
      ? (this.currentTime = this.holdTime)
      : (this.currentTime = n);
  }
  tick(e, n = !1) {
    const {
      generator: r,
      totalDuration: i,
      mixKeyframes: s,
      mirroredGenerator: o,
      resolvedDuration: a,
      calculatedDuration: l,
    } = this;
    if (this.startTime === null) return r.next(0);
    const {
      delay: u = 0,
      keyframes: c,
      repeat: f,
      repeatType: h,
      repeatDelay: d,
      type: m,
      onUpdate: y,
      finalKeyframe: p,
    } = this.options;
    this.speed > 0
      ? (this.startTime = Math.min(this.startTime, e))
      : this.speed < 0 &&
        (this.startTime = Math.min(e - i / this.speed, this.startTime)),
      n ? (this.currentTime = e) : this.updateTime(e);
    const g = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1),
      v = this.playbackSpeed >= 0 ? g < 0 : g > i;
    (this.currentTime = Math.max(g, 0)),
      this.state === "finished" &&
        this.holdTime === null &&
        (this.currentTime = i);
    let b = this.currentTime,
      w = r;
    if (f) {
      const T = Math.min(this.currentTime, i) / a;
      let x = Math.floor(T),
        _ = T % 1;
      !_ && T >= 1 && (_ = 1),
        _ === 1 && x--,
        (x = Math.min(x, f + 1)),
        !!(x % 2) &&
          (h === "reverse"
            ? ((_ = 1 - _), d && (_ -= d / a))
            : h === "mirror" && (w = o)),
        (b = dt(0, 1, _) * a);
    }
    const S = v ? { done: !1, value: c[0] } : w.next(b);
    s && (S.value = s(S.value));
    let { done: A } = S;
    !v &&
      l !== null &&
      (A =
        this.playbackSpeed >= 0
          ? this.currentTime >= i
          : this.currentTime <= 0);
    const C =
      this.holdTime === null &&
      (this.state === "finished" || (this.state === "running" && A));
    return (
      C && m !== qn && (S.value = Hr(c, this.options, p, this.speed)),
      y && y(S.value),
      C && this.finish(),
      S
    );
  }
  then(e, n) {
    return this.finished.then(e, n);
  }
  get duration() {
    return z(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + z(e);
  }
  get time() {
    return z(this.currentTime);
  }
  set time(e) {
    (e = J(e)),
      (this.currentTime = e),
      this.startTime === null ||
      this.holdTime !== null ||
      this.playbackSpeed === 0
        ? (this.holdTime = e)
        : this.driver &&
          (this.startTime = this.driver.now() - e / this.playbackSpeed),
      this.driver?.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    this.updateTime(W.now());
    const n = this.playbackSpeed !== e;
    (this.playbackSpeed = e), n && (this.time = z(this.currentTime));
  }
  play() {
    if (this.isStopped) return;
    const { driver: e = Kf, startTime: n } = this.options;
    this.driver || (this.driver = e((i) => this.tick(i))),
      this.options.onPlay?.();
    const r = this.driver.now();
    this.state === "finished"
      ? (this.updateFinished(), (this.startTime = r))
      : this.holdTime !== null
      ? (this.startTime = r - this.holdTime)
      : this.startTime || (this.startTime = n ?? r),
      this.state === "finished" &&
        this.speed < 0 &&
        (this.startTime += this.calculatedDuration),
      (this.holdTime = null),
      (this.state = "running"),
      this.driver.start();
  }
  pause() {
    (this.state = "paused"),
      this.updateTime(W.now()),
      (this.holdTime = this.currentTime);
  }
  complete() {
    this.state !== "running" && this.play(),
      (this.state = "finished"),
      (this.holdTime = null);
  }
  finish() {
    this.notifyFinished(),
      this.teardown(),
      (this.state = "finished"),
      this.options.onComplete?.();
  }
  cancel() {
    (this.holdTime = null),
      (this.startTime = 0),
      this.tick(0),
      this.teardown(),
      this.options.onCancel?.();
  }
  teardown() {
    (this.state = "idle"),
      this.stopDriver(),
      (this.startTime = this.holdTime = null);
  }
  stopDriver() {
    this.driver && (this.driver.stop(), (this.driver = void 0));
  }
  sample(e) {
    return (this.startTime = 0), this.tick(e, !0);
  }
  attachTimeline(e) {
    return (
      this.options.allowFlatten &&
        ((this.options.type = "keyframes"),
        (this.options.ease = "linear"),
        this.initAnimation()),
      this.driver?.stop(),
      e.observe(this)
    );
  }
}
function sh(t) {
  for (let e = 1; e < t.length; e++) t[e] ?? (t[e] = t[e - 1]);
}
const bt = (t) => (t * 180) / Math.PI,
  zn = (t) => {
    const e = bt(Math.atan2(t[1], t[0]));
    return Gn(e);
  },
  oh = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (t) => (Math.abs(t[0]) + Math.abs(t[3])) / 2,
    rotate: zn,
    rotateZ: zn,
    skewX: (t) => bt(Math.atan(t[1])),
    skewY: (t) => bt(Math.atan(t[2])),
    skew: (t) => (Math.abs(t[1]) + Math.abs(t[2])) / 2,
  },
  Gn = (t) => ((t = t % 360), t < 0 && (t += 360), t),
  Fi = zn,
  Ii = (t) => Math.sqrt(t[0] * t[0] + t[1] * t[1]),
  Li = (t) => Math.sqrt(t[4] * t[4] + t[5] * t[5]),
  ah = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: Ii,
    scaleY: Li,
    scale: (t) => (Ii(t) + Li(t)) / 2,
    rotateX: (t) => Gn(bt(Math.atan2(t[6], t[5]))),
    rotateY: (t) => Gn(bt(Math.atan2(-t[2], t[0]))),
    rotateZ: Fi,
    rotate: Fi,
    skewX: (t) => bt(Math.atan(t[4])),
    skewY: (t) => bt(Math.atan(t[1])),
    skew: (t) => (Math.abs(t[1]) + Math.abs(t[4])) / 2,
  };
function Yn(t) {
  return t.includes("scale") ? 1 : 0;
}
function Xn(t, e) {
  if (!t || t === "none") return Yn(e);
  const n = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (n) (r = ah), (i = n);
  else {
    const a = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    (r = oh), (i = a);
  }
  if (!i) return Yn(e);
  const s = r[e],
    o = i[1].split(",").map(ch);
  return typeof s == "function" ? s(o) : o[s];
}
const lh = (t, e) => {
  const { transform: n = "none" } = getComputedStyle(t);
  return Xn(n, e);
};
function ch(t) {
  return parseFloat(t.trim());
}
const Ht = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY",
  ],
  Ut = new Set(Ht),
  Di = (t) => t === Bt || t === E,
  uh = new Set(["x", "y", "z"]),
  fh = Ht.filter((t) => !uh.has(t));
function hh(t) {
  const e = [];
  return (
    fh.forEach((n) => {
      const r = t.getValue(n);
      r !== void 0 &&
        (e.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
    }),
    e
  );
}
const At = {
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) =>
    t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) =>
    t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  x: (t, { transform: e }) => Xn(e, "x"),
  y: (t, { transform: e }) => Xn(e, "y"),
};
At.translateX = At.x;
At.translateY = At.y;
const Et = new Set();
let Zn = !1,
  Jn = !1,
  Qn = !1;
function oa() {
  if (Jn) {
    const t = Array.from(Et).filter((r) => r.needsMeasurement),
      e = new Set(t.map((r) => r.element)),
      n = new Map();
    e.forEach((r) => {
      const i = hh(r);
      i.length && (n.set(r, i), r.render());
    }),
      t.forEach((r) => r.measureInitialState()),
      e.forEach((r) => {
        r.render();
        const i = n.get(r);
        i &&
          i.forEach(([s, o]) => {
            r.getValue(s)?.set(o);
          });
      }),
      t.forEach((r) => r.measureEndState()),
      t.forEach((r) => {
        r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
      });
  }
  (Jn = !1), (Zn = !1), Et.forEach((t) => t.complete(Qn)), Et.clear();
}
function aa() {
  Et.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (Jn = !0);
  });
}
function dh() {
  (Qn = !0), aa(), oa(), (Qn = !1);
}
class Kr {
  constructor(e, n, r, i, s, o = !1) {
    (this.state = "pending"),
      (this.isAsync = !1),
      (this.needsMeasurement = !1),
      (this.unresolvedKeyframes = [...e]),
      (this.onComplete = n),
      (this.name = r),
      (this.motionValue = i),
      (this.element = s),
      (this.isAsync = o);
  }
  scheduleResolve() {
    (this.state = "scheduled"),
      this.isAsync
        ? (Et.add(this), Zn || ((Zn = !0), j.read(aa), j.resolveKeyframes(oa)))
        : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const {
      unresolvedKeyframes: e,
      name: n,
      element: r,
      motionValue: i,
    } = this;
    if (e[0] === null) {
      const s = i?.get(),
        o = e[e.length - 1];
      if (s !== void 0) e[0] = s;
      else if (r && n) {
        const a = r.readValue(n, o);
        a != null && (e[0] = a);
      }
      e[0] === void 0 && (e[0] = o), i && s === void 0 && i.set(e[0]);
    }
    sh(e);
  }
  setFinalKeyframe() {}
  measureInitialState() {}
  renderEndStyles() {}
  measureEndState() {}
  complete(e = !1) {
    (this.state = "complete"),
      this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e),
      Et.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Et.delete(this), (this.state = "pending"));
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const ph = (t) => t.startsWith("--");
function mh(t, e, n) {
  ph(e) ? t.style.setProperty(e, n) : (t.style[e] = n);
}
const la = Vr(() => window.ScrollTimeline !== void 0),
  gh = {};
function yh(t, e) {
  const n = Vr(t);
  return () => gh[e] ?? n();
}
const ca = yh(() => {
    try {
      document
        .createElement("div")
        .animate({ opacity: 0 }, { easing: "linear(0, 1)" });
    } catch {
      return !1;
    }
    return !0;
  }, "linearEasing"),
  Xt = ([t, e, n, r]) => `cubic-bezier(${t}, ${e}, ${n}, ${r})`,
  Ni = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: Xt([0, 0.65, 0.55, 1]),
    circOut: Xt([0.55, 0, 1, 0.45]),
    backIn: Xt([0.31, 0.01, 0.66, -0.59]),
    backOut: Xt([0.33, 1.53, 0.69, 0.99]),
  };
function ua(t, e) {
  if (t)
    return typeof t == "function"
      ? ca()
        ? ta(t, e)
        : "ease-out"
      : Uo(t)
      ? Xt(t)
      : Array.isArray(t)
      ? t.map((n) => ua(n, e) || Ni.easeOut)
      : Ni[t];
}
function vh(
  t,
  e,
  n,
  {
    delay: r = 0,
    duration: i = 300,
    repeat: s = 0,
    repeatType: o = "loop",
    ease: a = "easeOut",
    times: l,
  } = {},
  u = void 0
) {
  const c = { [e]: n };
  l && (c.offset = l);
  const f = ua(a, i);
  Array.isArray(f) && (c.easing = f);
  const h = {
    delay: r,
    duration: i,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: s + 1,
    direction: o === "reverse" ? "alternate" : "normal",
  };
  return u && (h.pseudoElement = u), t.animate(c, h);
}
function qr(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function wh({ type: t, ...e }) {
  return qr(t) && ca()
    ? t.applyToOptions(e)
    : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class bh extends Ur {
  constructor(e) {
    if ((super(), (this.finishedTime = null), (this.isStopped = !1), !e))
      return;
    const {
      element: n,
      name: r,
      keyframes: i,
      pseudoElement: s,
      allowFlatten: o = !1,
      finalKeyframe: a,
      onComplete: l,
    } = e;
    (this.isPseudoElement = !!s),
      (this.allowFlatten = o),
      (this.options = e),
      Or(typeof e.type != "string");
    const u = wh(e);
    (this.animation = vh(n, r, i, u, s)),
      u.autoplay === !1 && this.animation.pause(),
      (this.animation.onfinish = () => {
        if (((this.finishedTime = this.time), !s)) {
          const c = Hr(i, this.options, a, this.speed);
          this.updateMotionValue ? this.updateMotionValue(c) : mh(n, r, c),
            this.animation.cancel();
        }
        l?.(), this.notifyFinished();
      });
  }
  play() {
    this.isStopped ||
      (this.animation.play(),
      this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {}
  }
  stop() {
    if (this.isStopped) return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" ||
      e === "finished" ||
      (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(),
      this.isPseudoElement || this.cancel());
  }
  commitStyles() {
    this.isPseudoElement || this.animation.commitStyles?.();
  }
  get duration() {
    const e = this.animation.effect?.getComputedTiming?.().duration || 0;
    return z(Number(e));
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + z(e);
  }
  get time() {
    return z(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    (this.finishedTime = null), (this.animation.currentTime = J(e));
  }
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), (this.animation.playbackRate = e);
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(e) {
    this.animation.startTime = e;
  }
  attachTimeline({ timeline: e, observe: n }) {
    return (
      this.allowFlatten &&
        this.animation.effect?.updateTiming({ easing: "linear" }),
      (this.animation.onfinish = null),
      e && la() ? ((this.animation.timeline = e), mt) : n(this)
    );
  }
}
const fa = { anticipate: Do, backInOut: Lo, circInOut: No };
function Sh(t) {
  return t in fa;
}
function _h(t) {
  typeof t.ease == "string" && Sh(t.ease) && (t.ease = fa[t.ease]);
}
const Bi = 10;
class xh extends bh {
  constructor(e) {
    _h(e),
      sa(e),
      super(e),
      e.startTime && (this.startTime = e.startTime),
      (this.options = e);
  }
  updateMotionValue(e) {
    const {
      motionValue: n,
      onUpdate: r,
      onComplete: i,
      element: s,
      ...o
    } = this.options;
    if (!n) return;
    if (e !== void 0) {
      n.set(e);
      return;
    }
    const a = new Wr({ ...o, autoplay: !1 }),
      l = J(this.finishedTime ?? this.time);
    n.setWithVelocity(a.sample(l - Bi).value, a.sample(l).value, Bi), a.stop();
  }
}
const ji = (t, e) =>
  e === "zIndex"
    ? !1
    : !!(
        typeof t == "number" ||
        Array.isArray(t) ||
        (typeof t == "string" &&
          (jt.test(t) || t === "0") &&
          !t.startsWith("url("))
      );
function Th(t) {
  const e = t[0];
  if (t.length === 1) return !0;
  for (let n = 0; n < t.length; n++) if (t[n] !== e) return !0;
}
function Ah(t, e, n, r) {
  const i = t[0];
  if (i === null) return !1;
  if (e === "display" || e === "visibility") return !0;
  const s = t[t.length - 1],
    o = ji(i, e),
    a = ji(s, e);
  return !o || !a ? !1 : Th(t) || ((n === "spring" || qr(n)) && r);
}
function tr(t) {
  (t.duration = 0), (t.type = "keyframes");
}
const Eh = new Set(["opacity", "clipPath", "filter", "transform"]),
  Ch = Vr(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Ph(t) {
  const {
    motionValue: e,
    name: n,
    repeatDelay: r,
    repeatType: i,
    damping: s,
    type: o,
  } = t;
  if (!(e?.owner?.current instanceof HTMLElement)) return !1;
  const { onUpdate: l, transformTemplate: u } = e.owner.getProps();
  return (
    Ch() &&
    n &&
    Eh.has(n) &&
    (n !== "transform" || !u) &&
    !l &&
    !r &&
    i !== "mirror" &&
    s !== 0 &&
    o !== "inertia"
  );
}
const Mh = 40;
class Oh extends Ur {
  constructor({
    autoplay: e = !0,
    delay: n = 0,
    type: r = "keyframes",
    repeat: i = 0,
    repeatDelay: s = 0,
    repeatType: o = "loop",
    keyframes: a,
    name: l,
    motionValue: u,
    element: c,
    ...f
  }) {
    super(),
      (this.stop = () => {
        this._animation && (this._animation.stop(), this.stopTimeline?.()),
          this.keyframeResolver?.cancel();
      }),
      (this.createdAt = W.now());
    const h = {
        autoplay: e,
        delay: n,
        type: r,
        repeat: i,
        repeatDelay: s,
        repeatType: o,
        name: l,
        motionValue: u,
        element: c,
        ...f,
      },
      d = c?.KeyframeResolver || Kr;
    (this.keyframeResolver = new d(
      a,
      (m, y, p) => this.onKeyframesResolved(m, y, h, !p),
      l,
      u,
      c
    )),
      this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(e, n, r, i) {
    this.keyframeResolver = void 0;
    const {
      name: s,
      type: o,
      velocity: a,
      delay: l,
      isHandoff: u,
      onUpdate: c,
    } = r;
    (this.resolvedAt = W.now()),
      Ah(e, s, o, a) ||
        ((tt.instantAnimations || !l) && c?.(Hr(e, r, n)),
        (e[0] = e[e.length - 1]),
        tr(r),
        (r.repeat = 0));
    const h = {
        startTime: i
          ? this.resolvedAt
            ? this.resolvedAt - this.createdAt > Mh
              ? this.resolvedAt
              : this.createdAt
            : this.createdAt
          : void 0,
        finalKeyframe: n,
        ...r,
        keyframes: e,
      },
      d =
        !u && Ph(h)
          ? new xh({ ...h, element: h.motionValue.owner.current })
          : new Wr(h);
    d.finished.then(() => this.notifyFinished()).catch(mt),
      this.pendingTimeline &&
        ((this.stopTimeline = d.attachTimeline(this.pendingTimeline)),
        (this.pendingTimeline = void 0)),
      (this._animation = d);
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, n) {
    return this.finished.finally(e).then(() => {});
  }
  get animation() {
    return (
      this._animation || (this.keyframeResolver?.resume(), dh()),
      this._animation
    );
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return (
      this._animation
        ? (this.stopTimeline = this.animation.attachTimeline(e))
        : (this.pendingTimeline = e),
      () => this.stop()
    );
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
class Vh {
  constructor(e) {
    (this.stop = () => this.runAll("stop")),
      (this.animations = e.filter(Boolean));
  }
  get finished() {
    return Promise.all(this.animations.map((e) => e.finished));
  }
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let r = 0; r < this.animations.length; r++) this.animations[r][e] = n;
  }
  attachTimeline(e) {
    const n = this.animations.map((r) => r.attachTimeline(e));
    return () => {
      n.forEach((r, i) => {
        r && r(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get state() {
    return this.getAll("state");
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    return Hi(this.animations, "duration");
  }
  get iterationDuration() {
    return Hi(this.animations, "iterationDuration");
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
function Hi(t, e) {
  let n = 0;
  for (let r = 0; r < t.length; r++) {
    const i = t[r][e];
    i !== null && i > n && (n = i);
  }
  return n;
}
class kh extends Vh {
  then(e, n) {
    return this.finished.finally(e).then(() => {});
  }
}
const $h = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function Rh(t) {
  const e = $h.exec(t);
  if (!e) return [,];
  const [, n, r, i] = e;
  return [`--${n ?? r}`, i];
}
function ha(t, e, n = 1) {
  const [r, i] = Rh(t);
  if (!r) return;
  const s = window.getComputedStyle(e).getPropertyValue(r);
  if (s) {
    const o = s.trim();
    return Mo(o) ? parseFloat(o) : o;
  }
  return Ir(i) ? ha(i, e, n + 1) : i;
}
function da(t, e) {
  return t?.[e] ?? t?.default ?? t;
}
const pa = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...Ht,
  ]),
  Fh = { test: (t) => t === "auto", parse: (t) => t },
  ma = (t) => (e) => e.test(t),
  ga = [Bt, E, kt, lt, Mf, Pf, Fh],
  Ui = (t) => ga.find(ma(t));
function Ih(t) {
  return typeof t == "number"
    ? t === 0
    : t !== null
    ? t === "none" || t === "0" || Vo(t)
    : !0;
}
const Lh = new Set(["brightness", "contrast", "saturate", "opacity"]);
function Dh(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow") return t;
  const [r] = n.match(Lr) || [];
  if (!r) return t;
  const i = n.replace(r, "");
  let s = Lh.has(e) ? 1 : 0;
  return r !== n && (s *= 100), e + "(" + s + i + ")";
}
const Nh = /\b([a-z-]*)\(.*?\)/gu,
  er = {
    ...jt,
    getAnimatableNone: (t) => {
      const e = t.match(Nh);
      return e ? e.map(Dh).join(" ") : t;
    },
  },
  Wi = { ...Bt, transform: Math.round },
  Bh = {
    rotate: lt,
    rotateX: lt,
    rotateY: lt,
    rotateZ: lt,
    scale: $e,
    scaleX: $e,
    scaleY: $e,
    scaleZ: $e,
    skew: lt,
    skewX: lt,
    skewY: lt,
    distance: E,
    translateX: E,
    translateY: E,
    translateZ: E,
    x: E,
    y: E,
    z: E,
    perspective: E,
    transformPerspective: E,
    opacity: ae,
    originX: Oi,
    originY: Oi,
    originZ: E,
  },
  zr = {
    borderWidth: E,
    borderTopWidth: E,
    borderRightWidth: E,
    borderBottomWidth: E,
    borderLeftWidth: E,
    borderRadius: E,
    radius: E,
    borderTopLeftRadius: E,
    borderTopRightRadius: E,
    borderBottomRightRadius: E,
    borderBottomLeftRadius: E,
    width: E,
    maxWidth: E,
    height: E,
    maxHeight: E,
    top: E,
    right: E,
    bottom: E,
    left: E,
    padding: E,
    paddingTop: E,
    paddingRight: E,
    paddingBottom: E,
    paddingLeft: E,
    margin: E,
    marginTop: E,
    marginRight: E,
    marginBottom: E,
    marginLeft: E,
    backgroundPositionX: E,
    backgroundPositionY: E,
    ...Bh,
    zIndex: Wi,
    fillOpacity: ae,
    strokeOpacity: ae,
    numOctaves: Wi,
  },
  jh = {
    ...zr,
    color: R,
    backgroundColor: R,
    outlineColor: R,
    fill: R,
    stroke: R,
    borderColor: R,
    borderTopColor: R,
    borderRightColor: R,
    borderBottomColor: R,
    borderLeftColor: R,
    filter: er,
    WebkitFilter: er,
  },
  ya = (t) => jh[t];
function va(t, e) {
  let n = ya(t);
  return (
    n !== er && (n = jt), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0
  );
}
const Hh = new Set(["auto", "none", "0"]);
function Uh(t, e, n) {
  let r = 0,
    i;
  for (; r < t.length && !i; ) {
    const s = t[r];
    typeof s == "string" && !Hh.has(s) && le(s).values.length && (i = t[r]),
      r++;
  }
  if (i && n) for (const s of e) t[s] = va(n, i);
}
class Wh extends Kr {
  constructor(e, n, r, i, s) {
    super(e, n, r, i, s, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: r } = this;
    if (!n || !n.current) return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let u = e[l];
      if (typeof u == "string" && ((u = u.trim()), Ir(u))) {
        const c = ha(u, n.current);
        c !== void 0 && (e[l] = c),
          l === e.length - 1 && (this.finalKeyframe = u);
      }
    }
    if ((this.resolveNoneKeyframes(), !pa.has(r) || e.length !== 2)) return;
    const [i, s] = e,
      o = Ui(i),
      a = Ui(s);
    if (o !== a)
      if (Di(o) && Di(a))
        for (let l = 0; l < e.length; l++) {
          const u = e[l];
          typeof u == "string" && (e[l] = parseFloat(u));
        }
      else At[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this,
      r = [];
    for (let i = 0; i < e.length; i++) (e[i] === null || Ih(e[i])) && r.push(i);
    r.length && Uh(e, r, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: r } = this;
    if (!e || !e.current) return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset),
      (this.measuredOrigin = At[r](
        e.measureViewportBox(),
        window.getComputedStyle(e.current)
      )),
      (n[0] = this.measuredOrigin);
    const i = n[n.length - 1];
    i !== void 0 && e.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    const { element: e, name: n, unresolvedKeyframes: r } = this;
    if (!e || !e.current) return;
    const i = e.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const s = r.length - 1,
      o = r[s];
    (r[s] = At[n](e.measureViewportBox(), window.getComputedStyle(e.current))),
      o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o),
      this.removedTransforms?.length &&
        this.removedTransforms.forEach(([a, l]) => {
          e.getValue(a).set(l);
        }),
      this.resolveNoneKeyframes();
  }
}
function wa(t, e, n) {
  if (t instanceof EventTarget) return [t];
  if (typeof t == "string") {
    let r = document;
    const i = n?.[t] ?? r.querySelectorAll(t);
    return i ? Array.from(i) : [];
  }
  return Array.from(t);
}
const ba = (t, e) => (e && typeof t == "number" ? e.transform(t) : t);
function Kh(t) {
  return Oo(t) && "offsetHeight" in t;
}
const Ki = 30,
  qh = (t) => !isNaN(parseFloat(t));
class zh {
  constructor(e, n = {}) {
    (this.canTrackVelocity = null),
      (this.events = {}),
      (this.updateAndNotify = (r) => {
        const i = W.now();
        if (
          (this.updatedAt !== i && this.setPrevFrameValue(),
          (this.prev = this.current),
          this.setCurrent(r),
          this.current !== this.prev &&
            (this.events.change?.notify(this.current), this.dependents))
        )
          for (const s of this.dependents) s.dirty();
      }),
      (this.hasAnimated = !1),
      this.setCurrent(e),
      (this.owner = n.owner);
  }
  setCurrent(e) {
    (this.current = e),
      (this.updatedAt = W.now()),
      this.canTrackVelocity === null &&
        e !== void 0 &&
        (this.canTrackVelocity = qh(this.current));
  }
  setPrevFrameValue(e = this.current) {
    (this.prevFrameValue = e), (this.prevUpdatedAt = this.updatedAt);
  }
  onChange(e) {
    return this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new ko());
    const r = this.events[e].add(n);
    return e === "change"
      ? () => {
          r(),
            j.read(() => {
              this.events.change.getSize() || this.stop();
            });
        }
      : r;
  }
  clearListeners() {
    for (const e in this.events) this.events[e].clear();
  }
  attach(e, n) {
    (this.passiveEffect = e), (this.stopPassiveEffect = n);
  }
  set(e) {
    this.passiveEffect
      ? this.passiveEffect(e, this.updateAndNotify)
      : this.updateAndNotify(e);
  }
  setWithVelocity(e, n, r) {
    this.set(n),
      (this.prev = void 0),
      (this.prevFrameValue = e),
      (this.prevUpdatedAt = this.updatedAt - r);
  }
  jump(e, n = !0) {
    this.updateAndNotify(e),
      (this.prev = e),
      (this.prevUpdatedAt = this.prevFrameValue = void 0),
      n && this.stop(),
      this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  get() {
    return this.current;
  }
  getPrevious() {
    return this.prev;
  }
  getVelocity() {
    const e = W.now();
    if (
      !this.canTrackVelocity ||
      this.prevFrameValue === void 0 ||
      e - this.updatedAt > Ki
    )
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Ki);
    return $r(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  start(e) {
    return (
      this.stop(),
      new Promise((n) => {
        (this.hasAnimated = !0),
          (this.animation = e(n)),
          this.events.animationStart && this.events.animationStart.notify();
      }).then(() => {
        this.events.animationComplete && this.events.animationComplete.notify(),
          this.clearAnimation();
      })
    );
  }
  stop() {
    this.animation &&
      (this.animation.stop(),
      this.events.animationCancel && this.events.animationCancel.notify()),
      this.clearAnimation();
  }
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  destroy() {
    this.dependents?.clear(),
      this.events.destroy?.notify(),
      this.clearListeners(),
      this.stop(),
      this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function ue(t, e) {
  return new zh(t, e);
}
const { schedule: Gh } = Wo(queueMicrotask, !1);
function Gr(t) {
  return Oo(t) && "ownerSVGElement" in t;
}
const De = new WeakMap();
let Ne;
const Sa = (t, e, n) => (r, i) =>
    i && i[0]
      ? i[0][t + "Size"]
      : Gr(r) && "getBBox" in r
      ? r.getBBox()[e]
      : r[n],
  Yh = Sa("inline", "width", "offsetWidth"),
  Xh = Sa("block", "height", "offsetHeight");
function Zh({ target: t, borderBoxSize: e }) {
  De.get(t)?.forEach((n) => {
    n(t, {
      get width() {
        return Yh(t, e);
      },
      get height() {
        return Xh(t, e);
      },
    });
  });
}
function Jh(t) {
  t.forEach(Zh);
}
function Qh() {
  typeof ResizeObserver > "u" || (Ne = new ResizeObserver(Jh));
}
function td(t, e) {
  Ne || Qh();
  const n = wa(t);
  return (
    n.forEach((r) => {
      let i = De.get(r);
      i || ((i = new Set()), De.set(r, i)), i.add(e), Ne?.observe(r);
    }),
    () => {
      n.forEach((r) => {
        const i = De.get(r);
        i?.delete(e), i?.size || Ne?.unobserve(r);
      });
    }
  );
}
const Be = new Set();
let Vt;
function ed() {
  (Vt = () => {
    const t = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      },
    };
    Be.forEach((e) => e(t));
  }),
    window.addEventListener("resize", Vt);
}
function nd(t) {
  return (
    Be.add(t),
    Vt || ed(),
    () => {
      Be.delete(t),
        !Be.size &&
          typeof Vt == "function" &&
          (window.removeEventListener("resize", Vt), (Vt = void 0));
    }
  );
}
function rd(t, e) {
  return typeof t == "function" ? nd(t) : td(t, e);
}
function _a(t, e) {
  let n;
  const r = () => {
    const { currentTime: i } = e,
      o = (i === null ? 0 : i.value) / 100;
    n !== o && t(o), (n = o);
  };
  return j.preUpdate(r, !0), () => se(r);
}
function id(t) {
  return Gr(t) && t.tagName === "svg";
}
const D = (t) => !!(t && t.getVelocity),
  sd = [...ga, R, jt],
  od = (t) => sd.find(ma(t));
function Yr(t) {
  return typeof t == "object" && !Array.isArray(t);
}
function xa(t, e, n, r) {
  return typeof t == "string" && Yr(e)
    ? wa(t, n, r)
    : t instanceof NodeList
    ? Array.from(t)
    : Array.isArray(t)
    ? t
    : [t];
}
function ad(t, e, n) {
  return t * (e + 1);
}
function qi(t, e, n, r) {
  return typeof e == "number"
    ? e
    : e.startsWith("-") || e.startsWith("+")
    ? Math.max(0, t + parseFloat(e))
    : e === "<"
    ? n
    : e.startsWith("<")
    ? Math.max(0, n + parseFloat(e.slice(1)))
    : r.get(e) ?? t;
}
function ld(t, e, n) {
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    i.at > e && i.at < n && (Po(t, i), r--);
  }
}
function cd(t, e, n, r, i, s) {
  ld(t, i, s);
  for (let o = 0; o < e.length; o++)
    t.push({ value: e[o], at: ve(i, s, r[o]), easing: Ho(n, o) });
}
function ud(t, e) {
  for (let n = 0; n < t.length; n++) t[n] = t[n] / (e + 1);
}
function fd(t, e) {
  return t.at === e.at
    ? t.value === null
      ? 1
      : e.value === null
      ? -1
      : 0
    : t.at - e.at;
}
const hd = "easeInOut";
function dd(t, { defaultTransition: e = {}, ...n } = {}, r, i) {
  const s = e.duration || 0.3,
    o = new Map(),
    a = new Map(),
    l = {},
    u = new Map();
  let c = 0,
    f = 0,
    h = 0;
  for (let d = 0; d < t.length; d++) {
    const m = t[d];
    if (typeof m == "string") {
      u.set(m, f);
      continue;
    } else if (!Array.isArray(m)) {
      u.set(m.name, qi(f, m.at, c, u));
      continue;
    }
    let [y, p, g = {}] = m;
    g.at !== void 0 && (f = qi(f, g.at, c, u));
    let v = 0;
    const b = (w, S, A, C = 0, T = 0) => {
      const x = pd(w),
        {
          delay: _ = 0,
          times: V = jr(x),
          type: X = "keyframes",
          repeat: nt,
          repeatType: Da,
          repeatDelay: Na = 0,
          ...rn
        } = S;
      let { ease: B = e.ease || "easeOut", duration: H } = S;
      const Wt = typeof _ == "function" ? _(C, T) : _,
        we = x.length,
        be = qr(X) ? X : i?.[X || "keyframes"];
      if (we <= 2 && be) {
        let gt = 100;
        if (we === 2 && yd(x)) {
          const st = x[1] - x[0];
          gt = Math.abs(st);
        }
        const rt = { ...rn };
        H !== void 0 && (rt.duration = J(H));
        const it = ea(rt, gt, be);
        (B = it.ease), (H = it.duration);
      }
      H ?? (H = s);
      const K = f + Wt;
      V.length === 1 && V[0] === 0 && (V[1] = 1);
      const q = V.length - x.length;
      if ((q > 0 && ia(V, q), x.length === 1 && x.unshift(null), nt)) {
        H = ad(H, nt);
        const gt = [...x],
          rt = [...V];
        B = Array.isArray(B) ? [...B] : [B];
        const it = [...B];
        for (let st = 0; st < nt; st++) {
          x.push(...gt);
          for (let ot = 0; ot < gt.length; ot++)
            V.push(rt[ot] + (st + 1)),
              B.push(ot === 0 ? "linear" : Ho(it, ot - 1));
        }
        ud(V, nt);
      }
      const Se = K + H;
      cd(A, x, B, V, K, Se), (v = Math.max(Wt + H, v)), (h = Math.max(Se, h));
    };
    if (D(y)) {
      const w = zi(y, a);
      b(p, g, Gi("default", w));
    } else {
      const w = xa(y, p, r, l),
        S = w.length;
      for (let A = 0; A < S; A++) {
        (p = p), (g = g);
        const C = w[A],
          T = zi(C, a);
        for (const x in p) b(p[x], md(g, x), Gi(x, T), A, S);
      }
    }
    (c = f), (f += v);
  }
  return (
    a.forEach((d, m) => {
      for (const y in d) {
        const p = d[y];
        p.sort(fd);
        const g = [],
          v = [],
          b = [];
        for (let S = 0; S < p.length; S++) {
          const { at: A, value: C, easing: T } = p[S];
          g.push(C), v.push(nn(0, h, A)), b.push(T || "easeOut");
        }
        v[0] !== 0 && (v.unshift(0), g.unshift(g[0]), b.unshift(hd)),
          v[v.length - 1] !== 1 && (v.push(1), g.push(null)),
          o.has(m) || o.set(m, { keyframes: {}, transition: {} });
        const w = o.get(m);
        (w.keyframes[y] = g),
          (w.transition[y] = { ...e, duration: h, ease: b, times: v, ...n });
      }
    }),
    o
  );
}
function zi(t, e) {
  return !e.has(t) && e.set(t, {}), e.get(t);
}
function Gi(t, e) {
  return e[t] || (e[t] = []), e[t];
}
function pd(t) {
  return Array.isArray(t) ? t : [t];
}
function md(t, e) {
  return t && t[e] ? { ...t, ...t[e] } : { ...t };
}
const gd = (t) => typeof t == "number",
  yd = (t) => t.every(gd),
  fe = new WeakMap(),
  vd = (t) => Array.isArray(t);
function Yi(t) {
  const e = [{}, {}];
  return (
    t?.values.forEach((n, r) => {
      (e[0][r] = n.get()), (e[1][r] = n.getVelocity());
    }),
    e
  );
}
function Ta(t, e, n, r) {
  if (typeof e == "function") {
    const [i, s] = Yi(r);
    e = e(n !== void 0 ? n : t.custom, i, s);
  }
  if (
    (typeof e == "string" && (e = t.variants && t.variants[e]),
    typeof e == "function")
  ) {
    const [i, s] = Yi(r);
    e = e(n !== void 0 ? n : t.custom, i, s);
  }
  return e;
}
function wd(t, e, n) {
  const r = t.getProps();
  return Ta(r, e, r.custom, t);
}
function bd(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, ue(n));
}
function Sd(t) {
  return vd(t) ? t[t.length - 1] || 0 : t;
}
function _d(t, e) {
  const n = wd(t, e);
  let { transitionEnd: r = {}, transition: i = {}, ...s } = n || {};
  s = { ...s, ...r };
  for (const o in s) {
    const a = Sd(s[o]);
    bd(t, o, a);
  }
}
function xd(t) {
  return !!(D(t) && t.add);
}
function Td(t, e) {
  const n = t.getValue("willChange");
  if (xd(n)) return n.add(e);
  if (!n && tt.WillChange) {
    const r = new tt.WillChange("auto");
    t.addValue("willChange", r), r.add(e);
  }
}
const Xr = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(),
  Ad = "framerAppearId",
  Ed = "data-" + Xr(Ad);
function Cd(t) {
  return t.props[Ed];
}
const Pd = (t) => t !== null;
function Md(t, { repeat: e, repeatType: n = "loop" }, r) {
  const i = t.filter(Pd),
    s = e && n !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return i[s];
}
const Od = { type: "spring", stiffness: 500, damping: 25, restSpeed: 10 },
  Vd = (t) => ({
    type: "spring",
    stiffness: 550,
    damping: t === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
  }),
  kd = { type: "keyframes", duration: 0.8 },
  $d = { type: "keyframes", ease: [0.25, 0.1, 0.35, 1], duration: 0.3 },
  Rd = (t, { keyframes: e }) =>
    e.length > 2
      ? kd
      : Ut.has(t)
      ? t.startsWith("scale")
        ? Vd(e[1])
        : Od
      : $d;
function Fd({
  when: t,
  delay: e,
  delayChildren: n,
  staggerChildren: r,
  staggerDirection: i,
  repeat: s,
  repeatType: o,
  repeatDelay: a,
  from: l,
  elapsed: u,
  ...c
}) {
  return !!Object.keys(c).length;
}
const Aa =
  (t, e, n, r = {}, i, s) =>
  (o) => {
    const a = da(r, t) || {},
      l = a.delay || r.delay || 0;
    let { elapsed: u = 0 } = r;
    u = u - J(l);
    const c = {
      keyframes: Array.isArray(n) ? n : [null, n],
      ease: "easeOut",
      velocity: e.getVelocity(),
      ...a,
      delay: -u,
      onUpdate: (h) => {
        e.set(h), a.onUpdate && a.onUpdate(h);
      },
      onComplete: () => {
        o(), a.onComplete && a.onComplete();
      },
      name: t,
      motionValue: e,
      element: s ? void 0 : i,
    };
    Fd(a) || Object.assign(c, Rd(t, c)),
      c.duration && (c.duration = J(c.duration)),
      c.repeatDelay && (c.repeatDelay = J(c.repeatDelay)),
      c.from !== void 0 && (c.keyframes[0] = c.from);
    let f = !1;
    if (
      ((c.type === !1 || (c.duration === 0 && !c.repeatDelay)) &&
        (tr(c), c.delay === 0 && (f = !0)),
      (tt.instantAnimations || tt.skipAnimations) &&
        ((f = !0), tr(c), (c.delay = 0)),
      (c.allowFlatten = !a.type && !a.ease),
      f && !s && e.get() !== void 0)
    ) {
      const h = Md(c.keyframes, a);
      if (h !== void 0) {
        j.update(() => {
          c.onUpdate(h), c.onComplete();
        });
        return;
      }
    }
    return a.isSync ? new Wr(c) : new Oh(c);
  };
function Id({ protectedKeys: t, needsAnimating: e }, n) {
  const r = t.hasOwnProperty(n) && e[n] !== !0;
  return (e[n] = !1), r;
}
function Ld(t, e, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  let { transition: s = t.getDefaultTransition(), transitionEnd: o, ...a } = e;
  r && (s = r);
  const l = [],
    u = i && t.animationState && t.animationState.getState()[i];
  for (const c in a) {
    const f = t.getValue(c, t.latestValues[c] ?? null),
      h = a[c];
    if (h === void 0 || (u && Id(u, c))) continue;
    const d = { delay: n, ...da(s || {}, c) },
      m = f.get();
    if (
      m !== void 0 &&
      !f.isAnimating &&
      !Array.isArray(h) &&
      h === m &&
      !d.velocity
    )
      continue;
    let y = !1;
    if (window.MotionHandoffAnimation) {
      const g = Cd(t);
      if (g) {
        const v = window.MotionHandoffAnimation(g, c, j);
        v !== null && ((d.startTime = v), (y = !0));
      }
    }
    Td(t, c),
      f.start(
        Aa(c, f, h, t.shouldReduceMotion && pa.has(c) ? { type: !1 } : d, t, y)
      );
    const p = f.animation;
    p && l.push(p);
  }
  return (
    o &&
      Promise.all(l).then(() => {
        j.update(() => {
          o && _d(t, o);
        });
      }),
    l
  );
}
function Dd({ top: t, left: e, right: n, bottom: r }) {
  return { x: { min: e, max: n }, y: { min: t, max: r } };
}
function Nd(t, e) {
  if (!e) return t;
  const n = e({ x: t.left, y: t.top }),
    r = e({ x: t.right, y: t.bottom });
  return { top: n.y, left: n.x, bottom: r.y, right: r.x };
}
function Bd(t, e) {
  return Dd(Nd(t.getBoundingClientRect(), e));
}
const Xi = {
    animation: [
      "animate",
      "variants",
      "whileHover",
      "whileTap",
      "exit",
      "whileInView",
      "whileFocus",
      "whileDrag",
    ],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"],
  },
  nr = {};
for (const t in Xi) nr[t] = { isEnabled: (e) => Xi[t].some((n) => !!e[n]) };
const Zi = () => ({ min: 0, max: 0 }),
  Zr = () => ({ x: Zi(), y: Zi() }),
  jd = typeof window < "u",
  rr = { current: null },
  Ea = { current: !1 };
function Hd() {
  if (((Ea.current = !0), !!jd))
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"),
        e = () => (rr.current = t.matches);
      t.addEventListener("change", e), e();
    } else rr.current = !1;
}
function Ud(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function Wd(t) {
  return typeof t == "string" || Array.isArray(t);
}
const Kd = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit",
  ],
  qd = ["initial", ...Kd];
function Ca(t) {
  return Ud(t.animate) || qd.some((e) => Wd(t[e]));
}
function zd(t) {
  return !!(Ca(t) || t.variants);
}
function Gd(t, e, n) {
  for (const r in e) {
    const i = e[r],
      s = n[r];
    if (D(i)) t.addValue(r, i);
    else if (D(s)) t.addValue(r, ue(i, { owner: t }));
    else if (s !== i)
      if (t.hasValue(r)) {
        const o = t.getValue(r);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = t.getStaticValue(r);
        t.addValue(r, ue(o !== void 0 ? o : i, { owner: t }));
      }
  }
  for (const r in n) e[r] === void 0 && t.removeValue(r);
  return e;
}
const Ji = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete",
];
class Pa {
  scrapeMotionValuesFromProps(e, n, r) {
    return {};
  }
  constructor(
    {
      parent: e,
      props: n,
      presenceContext: r,
      reducedMotionConfig: i,
      blockInitialAnimation: s,
      visualState: o,
    },
    a = {}
  ) {
    (this.current = null),
      (this.children = new Set()),
      (this.isVariantNode = !1),
      (this.isControllingVariants = !1),
      (this.shouldReduceMotion = null),
      (this.values = new Map()),
      (this.KeyframeResolver = Kr),
      (this.features = {}),
      (this.valueSubscriptions = new Map()),
      (this.prevMotionValues = {}),
      (this.events = {}),
      (this.propEventSubscriptions = {}),
      (this.notifyUpdate = () => this.notify("Update", this.latestValues)),
      (this.render = () => {
        this.current &&
          (this.triggerBuild(),
          this.renderInstance(
            this.current,
            this.renderState,
            this.props.style,
            this.projection
          ));
      }),
      (this.renderScheduledAt = 0),
      (this.scheduleRender = () => {
        const h = W.now();
        this.renderScheduledAt < h &&
          ((this.renderScheduledAt = h), j.render(this.render, !1, !0));
      });
    const { latestValues: l, renderState: u } = o;
    (this.latestValues = l),
      (this.baseTarget = { ...l }),
      (this.initialValues = n.initial ? { ...l } : {}),
      (this.renderState = u),
      (this.parent = e),
      (this.props = n),
      (this.presenceContext = r),
      (this.depth = e ? e.depth + 1 : 0),
      (this.reducedMotionConfig = i),
      (this.options = a),
      (this.blockInitialAnimation = !!s),
      (this.isControllingVariants = Ca(n)),
      (this.isVariantNode = zd(n)),
      this.isVariantNode && (this.variantChildren = new Set()),
      (this.manuallyAnimateOnMount = !!(e && e.current));
    const { willChange: c, ...f } = this.scrapeMotionValuesFromProps(
      n,
      {},
      this
    );
    for (const h in f) {
      const d = f[h];
      l[h] !== void 0 && D(d) && d.set(l[h]);
    }
  }
  mount(e) {
    (this.current = e),
      fe.set(e, this),
      this.projection && !this.projection.instance && this.projection.mount(e),
      this.parent &&
        this.isVariantNode &&
        !this.isControllingVariants &&
        (this.removeFromVariantTree = this.parent.addVariantChild(this)),
      this.values.forEach((n, r) => this.bindToMotionValue(r, n)),
      Ea.current || Hd(),
      (this.shouldReduceMotion =
        this.reducedMotionConfig === "never"
          ? !1
          : this.reducedMotionConfig === "always"
          ? !0
          : rr.current),
      this.parent?.addChild(this),
      this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(),
      se(this.notifyUpdate),
      se(this.render),
      this.valueSubscriptions.forEach((e) => e()),
      this.valueSubscriptions.clear(),
      this.removeFromVariantTree && this.removeFromVariantTree(),
      this.parent?.removeChild(this);
    for (const e in this.events) this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), (n.isMounted = !1));
    }
    this.current = null;
  }
  addChild(e) {
    this.children.add(e),
      this.enteringChildren ?? (this.enteringChildren = new Set()),
      this.enteringChildren.add(e);
  }
  removeChild(e) {
    this.children.delete(e),
      this.enteringChildren && this.enteringChildren.delete(e);
  }
  bindToMotionValue(e, n) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const r = Ut.has(e);
    r && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (o) => {
      (this.latestValues[e] = o),
        this.props.onUpdate && j.preRender(this.notifyUpdate),
        r && this.projection && (this.projection.isTransformDirty = !0),
        this.scheduleRender();
    });
    let s;
    window.MotionCheckAppearSync &&
      (s = window.MotionCheckAppearSync(this, e, n)),
      this.valueSubscriptions.set(e, () => {
        i(), s && s(), n.owner && n.stop();
      });
  }
  sortNodePosition(e) {
    return !this.current ||
      !this.sortInstanceNodePosition ||
      this.type !== e.type
      ? 0
      : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in nr) {
      const n = nr[e];
      if (!n) continue;
      const { isEnabled: r, Feature: i } = n;
      if (
        (!this.features[e] &&
          i &&
          r(this.props) &&
          (this.features[e] = new i(this)),
        this.features[e])
      ) {
        const s = this.features[e];
        s.isMounted ? s.update() : (s.mount(), (s.isMounted = !0));
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  measureViewportBox() {
    return this.current
      ? this.measureInstanceViewportBox(this.current, this.props)
      : Zr();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) &&
      this.scheduleRender(),
      (this.prevProps = this.props),
      (this.props = e),
      (this.prevPresenceContext = this.presenceContext),
      (this.presenceContext = n);
    for (let r = 0; r < Ji.length; r++) {
      const i = Ji[r];
      this.propEventSubscriptions[i] &&
        (this.propEventSubscriptions[i](),
        delete this.propEventSubscriptions[i]);
      const s = "on" + i,
        o = e[s];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    (this.prevMotionValues = Gd(
      this,
      this.scrapeMotionValuesFromProps(e, this.prevProps, this),
      this.prevMotionValues
    )),
      this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode
      ? this
      : this.parent
      ? this.parent.getClosestVariantNode()
      : void 0;
  }
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return (
        n.variantChildren && n.variantChildren.add(e),
        () => n.variantChildren.delete(e)
      );
  }
  addValue(e, n) {
    const r = this.values.get(e);
    n !== r &&
      (r && this.removeValue(e),
      this.bindToMotionValue(e, n),
      this.values.set(e, n),
      (this.latestValues[e] = n.get()));
  }
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)),
      delete this.latestValues[e],
      this.removeValueFromRenderState(e, this.renderState);
  }
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e]) return this.props.values[e];
    let r = this.values.get(e);
    return (
      r === void 0 &&
        n !== void 0 &&
        ((r = ue(n === null ? void 0 : n, { owner: this })),
        this.addValue(e, r)),
      r
    );
  }
  readValue(e, n) {
    let r =
      this.latestValues[e] !== void 0 || !this.current
        ? this.latestValues[e]
        : this.getBaseTargetFromProps(this.props, e) ??
          this.readValueFromInstance(this.current, e, this.options);
    return (
      r != null &&
        (typeof r == "string" && (Mo(r) || Vo(r))
          ? (r = parseFloat(r))
          : !od(r) && jt.test(n) && (r = va(e, n)),
        this.setBaseTarget(e, D(r) ? r.get() : r)),
      D(r) ? r.get() : r
    );
  }
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  getBaseTarget(e) {
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const s = Ta(this.props, n, this.presenceContext?.custom);
      s && (r = s[e]);
    }
    if (n && r !== void 0) return r;
    const i = this.getBaseTargetFromProps(this.props, e);
    return i !== void 0 && !D(i)
      ? i
      : this.initialValues[e] !== void 0 && r === void 0
      ? void 0
      : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new ko()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
  scheduleRenderMicrotask() {
    Gh.render(this.render);
  }
}
class Ma extends Pa {
  constructor() {
    super(...arguments), (this.KeyframeResolver = Wh);
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: r }) {
    delete n[e], delete r[e];
  }
  handleChildMotionValue() {
    this.childSubscription &&
      (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    D(e) &&
      (this.childSubscription = e.on("change", (n) => {
        this.current && (this.current.textContent = `${n}`);
      }));
  }
}
const Yd = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
  },
  Xd = Ht.length;
function Zd(t, e, n) {
  let r = "",
    i = !0;
  for (let s = 0; s < Xd; s++) {
    const o = Ht[s],
      a = t[o];
    if (a === void 0) continue;
    let l = !0;
    if (
      (typeof a == "number"
        ? (l = a === (o.startsWith("scale") ? 1 : 0))
        : (l = parseFloat(a) === 0),
      !l || n)
    ) {
      const u = ba(a, zr[o]);
      if (!l) {
        i = !1;
        const c = Yd[o] || o;
        r += `${c}(${u}) `;
      }
      n && (e[o] = u);
    }
  }
  return (r = r.trim()), n ? (r = n(e, i ? "" : r)) : i && (r = "none"), r;
}
function Oa(t, e, n) {
  const { style: r, vars: i, transformOrigin: s } = t;
  let o = !1,
    a = !1;
  for (const l in e) {
    const u = e[l];
    if (Ut.has(l)) {
      o = !0;
      continue;
    } else if (qo(l)) {
      i[l] = u;
      continue;
    } else {
      const c = ba(u, zr[l]);
      l.startsWith("origin") ? ((a = !0), (s[l] = c)) : (r[l] = c);
    }
  }
  if (
    (e.transform ||
      (o || n
        ? (r.transform = Zd(e, t.transform, n))
        : r.transform && (r.transform = "none")),
    a)
  ) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = s;
    r.transformOrigin = `${l} ${u} ${c}`;
  }
}
function Va(t, { style: e, vars: n }, r, i) {
  const s = t.style;
  let o;
  for (o in e) s[o] = e[o];
  i?.applyProjectionStyles(s, r);
  for (o in n) s.setProperty(o, n[o]);
}
const Jd = {};
function Qd(t, { layout: e, layoutId: n }) {
  return (
    Ut.has(t) ||
    t.startsWith("origin") ||
    ((e || n !== void 0) && (!!Jd[t] || t === "opacity"))
  );
}
function ka(t, e, n) {
  const { style: r } = t,
    i = {};
  for (const s in r)
    (D(r[s]) ||
      (e.style && D(e.style[s])) ||
      Qd(s, t) ||
      n?.getValue(s)?.liveStyle !== void 0) &&
      (i[s] = r[s]);
  return i;
}
function tp(t) {
  return window.getComputedStyle(t);
}
class ep extends Ma {
  constructor() {
    super(...arguments), (this.type = "html"), (this.renderInstance = Va);
  }
  readValueFromInstance(e, n) {
    if (Ut.has(n)) return this.projection?.isProjecting ? Yn(n) : lh(e, n);
    {
      const r = tp(e),
        i = (qo(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return Bd(e, n);
  }
  build(e, n, r) {
    Oa(e, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, r) {
    return ka(e, n, r);
  }
}
function np(t, e) {
  return t in e;
}
class rp extends Pa {
  constructor() {
    super(...arguments), (this.type = "object");
  }
  readValueFromInstance(e, n) {
    if (np(n, e)) {
      const r = e[n];
      if (typeof r == "string" || typeof r == "number") return r;
    }
  }
  getBaseTargetFromProps() {}
  removeValueFromRenderState(e, n) {
    delete n.output[e];
  }
  measureInstanceViewportBox() {
    return Zr();
  }
  build(e, n) {
    Object.assign(e.output, n);
  }
  renderInstance(e, { output: n }) {
    Object.assign(e, n);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
const ip = { offset: "stroke-dashoffset", array: "stroke-dasharray" },
  sp = { offset: "strokeDashoffset", array: "strokeDasharray" };
function op(t, e, n = 1, r = 0, i = !0) {
  t.pathLength = 1;
  const s = i ? ip : sp;
  t[s.offset] = E.transform(-r);
  const o = E.transform(e),
    a = E.transform(n);
  t[s.array] = `${o} ${a}`;
}
function ap(
  t,
  {
    attrX: e,
    attrY: n,
    attrScale: r,
    pathLength: i,
    pathSpacing: s = 1,
    pathOffset: o = 0,
    ...a
  },
  l,
  u,
  c
) {
  if ((Oa(t, a, u), l)) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  (t.attrs = t.style), (t.style = {});
  const { attrs: f, style: h } = t;
  f.transform && ((h.transform = f.transform), delete f.transform),
    (h.transform || f.transformOrigin) &&
      ((h.transformOrigin = f.transformOrigin ?? "50% 50%"),
      delete f.transformOrigin),
    h.transform &&
      ((h.transformBox = c?.transformBox ?? "fill-box"), delete f.transformBox),
    e !== void 0 && (f.x = e),
    n !== void 0 && (f.y = n),
    r !== void 0 && (f.scale = r),
    i !== void 0 && op(f, i, s, o, !1);
}
const $a = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
  ]),
  lp = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function cp(t, e, n, r) {
  Va(t, e, void 0, r);
  for (const i in e.attrs) t.setAttribute($a.has(i) ? i : Xr(i), e.attrs[i]);
}
function up(t, e, n) {
  const r = ka(t, e, n);
  for (const i in t)
    if (D(t[i]) || D(e[i])) {
      const s =
        Ht.indexOf(i) !== -1
          ? "attr" + i.charAt(0).toUpperCase() + i.substring(1)
          : i;
      r[s] = t[i];
    }
  return r;
}
class fp extends Ma {
  constructor() {
    super(...arguments),
      (this.type = "svg"),
      (this.isSVGTag = !1),
      (this.measureInstanceViewportBox = Zr);
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (Ut.has(n)) {
      const r = ya(n);
      return (r && r.default) || 0;
    }
    return (n = $a.has(n) ? n : Xr(n)), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, r) {
    return up(e, n, r);
  }
  build(e, n, r) {
    ap(e, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(e, n, r, i) {
    cp(e, n, r, i);
  }
  mount(e) {
    (this.isSVGTag = lp(e.tagName)), super.mount(e);
  }
}
function hp(t) {
  const e = {
      presenceContext: null,
      props: {},
      visualState: {
        renderState: {
          transform: {},
          transformOrigin: {},
          style: {},
          vars: {},
          attrs: {},
        },
        latestValues: {},
      },
    },
    n = Gr(t) && !id(t) ? new fp(e) : new ep(e);
  n.mount(t), fe.set(t, n);
}
function dp(t) {
  const e = {
      presenceContext: null,
      props: {},
      visualState: { renderState: { output: {} }, latestValues: {} },
    },
    n = new rp(e);
  n.mount(t), fe.set(t, n);
}
function pp(t, e, n) {
  const r = D(t) ? t : ue(t);
  return r.start(Aa("", r, e, n)), r.animation;
}
function mp(t, e) {
  return D(t) || typeof t == "number" || (typeof t == "string" && !Yr(e));
}
function Ra(t, e, n, r) {
  const i = [];
  if (mp(t, e)) i.push(pp(t, (Yr(e) && e.default) || e, n && (n.default || n)));
  else {
    const s = xa(t, e, r),
      o = s.length;
    for (let a = 0; a < o; a++) {
      const l = s[a],
        u = l instanceof Element ? hp : dp;
      fe.has(l) || u(l);
      const c = fe.get(l),
        f = { ...n };
      "delay" in f && typeof f.delay == "function" && (f.delay = f.delay(a, o)),
        i.push(...Ld(c, { ...e, transition: f }, {}));
    }
  }
  return i;
}
function gp(t, e, n) {
  const r = [];
  return (
    dd(t, e, n, { spring: ce }).forEach(
      ({ keyframes: s, transition: o }, a) => {
        r.push(...Ra(a, s, o));
      }
    ),
    r
  );
}
function yp(t) {
  return Array.isArray(t) && t.some(Array.isArray);
}
function vp(t) {
  function e(n, r, i) {
    let s = [],
      o;
    if (yp(n)) s = gp(n, r, t);
    else {
      const { onComplete: l, ...u } = i || {};
      typeof l == "function" && (o = l), (s = Ra(n, r, u, t));
    }
    const a = new kh(s);
    return o && a.finished.then(o), a;
  }
  return e;
}
const wp = vp(),
  bp = 50,
  Qi = () => ({
    current: 0,
    offset: [],
    progress: 0,
    scrollLength: 0,
    targetOffset: 0,
    targetLength: 0,
    containerLength: 0,
    velocity: 0,
  }),
  Sp = () => ({ time: 0, x: Qi(), y: Qi() }),
  _p = {
    x: { length: "Width", position: "Left" },
    y: { length: "Height", position: "Top" },
  };
function ts(t, e, n, r) {
  const i = n[e],
    { length: s, position: o } = _p[e],
    a = i.current,
    l = n.time;
  (i.current = t[`scroll${o}`]),
    (i.scrollLength = t[`scroll${s}`] - t[`client${s}`]),
    (i.offset.length = 0),
    (i.offset[0] = 0),
    (i.offset[1] = i.scrollLength),
    (i.progress = nn(0, i.scrollLength, i.current));
  const u = r - l;
  i.velocity = u > bp ? 0 : $r(i.current - a, u);
}
function xp(t, e, n) {
  ts(t, "x", e, n), ts(t, "y", e, n), (e.time = n);
}
function Tp(t, e) {
  const n = { x: 0, y: 0 };
  let r = t;
  for (; r && r !== e; )
    if (Kh(r))
      (n.x += r.offsetLeft), (n.y += r.offsetTop), (r = r.offsetParent);
    else if (r.tagName === "svg") {
      const i = r.getBoundingClientRect();
      r = r.parentElement;
      const s = r.getBoundingClientRect();
      (n.x += i.left - s.left), (n.y += i.top - s.top);
    } else if (r instanceof SVGGraphicsElement) {
      const { x: i, y: s } = r.getBBox();
      (n.x += i), (n.y += s);
      let o = null,
        a = r.parentNode;
      for (; !o; ) a.tagName === "svg" && (o = a), (a = r.parentNode);
      r = o;
    } else break;
  return n;
}
const ir = { start: 0, center: 0.5, end: 1 };
function es(t, e, n = 0) {
  let r = 0;
  if ((t in ir && (t = ir[t]), typeof t == "string")) {
    const i = parseFloat(t);
    t.endsWith("px")
      ? (r = i)
      : t.endsWith("%")
      ? (t = i / 100)
      : t.endsWith("vw")
      ? (r = (i / 100) * document.documentElement.clientWidth)
      : t.endsWith("vh")
      ? (r = (i / 100) * document.documentElement.clientHeight)
      : (t = i);
  }
  return typeof t == "number" && (r = e * t), n + r;
}
const Ap = [0, 0];
function Ep(t, e, n, r) {
  let i = Array.isArray(t) ? t : Ap,
    s = 0,
    o = 0;
  return (
    typeof t == "number"
      ? (i = [t, t])
      : typeof t == "string" &&
        ((t = t.trim()),
        t.includes(" ") ? (i = t.split(" ")) : (i = [t, ir[t] ? t : "0"])),
    (s = es(i[0], n, r)),
    (o = es(i[1], e)),
    s - o
  );
}
const Cp = {
    All: [
      [0, 0],
      [1, 1],
    ],
  },
  Pp = { x: 0, y: 0 };
function Mp(t) {
  return "getBBox" in t && t.tagName !== "svg"
    ? t.getBBox()
    : { width: t.clientWidth, height: t.clientHeight };
}
function Op(t, e, n) {
  const { offset: r = Cp.All } = n,
    { target: i = t, axis: s = "y" } = n,
    o = s === "y" ? "height" : "width",
    a = i !== t ? Tp(i, t) : Pp,
    l = i === t ? { width: t.scrollWidth, height: t.scrollHeight } : Mp(i),
    u = { width: t.clientWidth, height: t.clientHeight };
  e[s].offset.length = 0;
  let c = !e[s].interpolate;
  const f = r.length;
  for (let h = 0; h < f; h++) {
    const d = Ep(r[h], u[o], l[o], a[s]);
    !c && d !== e[s].interpolatorOffsets[h] && (c = !0), (e[s].offset[h] = d);
  }
  c &&
    ((e[s].interpolate = ra(e[s].offset, jr(r), { clamp: !1 })),
    (e[s].interpolatorOffsets = [...e[s].offset])),
    (e[s].progress = dt(0, 1, e[s].interpolate(e[s].current)));
}
function Vp(t, e = t, n) {
  if (((n.x.targetOffset = 0), (n.y.targetOffset = 0), e !== t)) {
    let r = e;
    for (; r && r !== t; )
      (n.x.targetOffset += r.offsetLeft),
        (n.y.targetOffset += r.offsetTop),
        (r = r.offsetParent);
  }
  (n.x.targetLength = e === t ? e.scrollWidth : e.clientWidth),
    (n.y.targetLength = e === t ? e.scrollHeight : e.clientHeight),
    (n.x.containerLength = t.clientWidth),
    (n.y.containerLength = t.clientHeight);
}
function kp(t, e, n, r = {}) {
  return {
    measure: (i) => {
      Vp(t, r.target, n), xp(t, n, i), (r.offset || r.target) && Op(t, n, r);
    },
    notify: () => e(n),
  };
}
const Gt = new WeakMap(),
  ns = new WeakMap(),
  wn = new WeakMap(),
  rs = (t) => (t === document.scrollingElement ? window : t);
function Fa(t, { container: e = document.scrollingElement, ...n } = {}) {
  if (!e) return mt;
  let r = wn.get(e);
  r || ((r = new Set()), wn.set(e, r));
  const i = Sp(),
    s = kp(e, t, i, n);
  if ((r.add(s), !Gt.has(e))) {
    const a = () => {
        for (const f of r) f.measure(oe.timestamp);
        j.preUpdate(l);
      },
      l = () => {
        for (const f of r) f.notify();
      },
      u = () => j.read(a);
    Gt.set(e, u);
    const c = rs(e);
    window.addEventListener("resize", u, { passive: !0 }),
      e !== document.documentElement && ns.set(e, rd(e, u)),
      c.addEventListener("scroll", u, { passive: !0 }),
      u();
  }
  const o = Gt.get(e);
  return (
    j.read(o, !1, !0),
    () => {
      se(o);
      const a = wn.get(e);
      if (!a || (a.delete(s), a.size)) return;
      const l = Gt.get(e);
      Gt.delete(e),
        l &&
          (rs(e).removeEventListener("scroll", l),
          ns.get(e)?.(),
          window.removeEventListener("resize", l));
    }
  );
}
const is = new Map();
function $p(t) {
  const e = { value: 0 },
    n = Fa((r) => {
      e.value = r[t.axis].progress * 100;
    }, t);
  return { currentTime: e, cancel: n };
}
function Ia({ source: t, container: e, ...n }) {
  const { axis: r } = n;
  t && (e = t);
  const i = is.get(e) ?? new Map();
  is.set(e, i);
  const s = n.target ?? "self",
    o = i.get(s) ?? {},
    a = r + (n.offset ?? []).join(",");
  return (
    o[a] ||
      (o[a] =
        !n.target && la()
          ? new ScrollTimeline({ source: e, axis: r })
          : $p({ container: e, ...n })),
    o[a]
  );
}
function Rp(t, e) {
  const n = Ia(e);
  return t.attachTimeline({
    timeline: e.target ? void 0 : n,
    observe: (r) => (
      r.pause(),
      _a((i) => {
        r.time = r.iterationDuration * i;
      }, n)
    ),
  });
}
function Fp(t) {
  return t.length === 2;
}
function Ip(t, e) {
  return Fp(t)
    ? Fa((n) => {
        t(n[e.axis].progress, n);
      }, e)
    : _a(t, Ia(e));
}
function Lp(
  t,
  { axis: e = "y", container: n = document.scrollingElement, ...r } = {}
) {
  if (!n) return mt;
  const i = { axis: e, container: n, ...r };
  return typeof t == "function" ? Ip(t, i) : Rp(t, i);
}
const Dp = () => ({
    bgColor: "#6b4d1e",
    cancelScrollFunctions: [],
    init() {
      this.$nextTick(() => {
        this.setupScrollTracking();
      });
    },
    setupScrollTracking() {
      const t = document.querySelectorAll("[data-color]");
      t.length !== 0 &&
        (this.cleanup(),
        t.forEach((e) => {
          const n = e.getAttribute("data-color");
          if (!n) return;
          const r = Lp(
            (i) => {
              i > 0.3 && i < 0.7 && (this.bgColor = n);
            },
            { target: e, offset: ["start end", "end start"] }
          );
          this.cancelScrollFunctions.push(r);
        }));
    },
    cleanup() {
      this.cancelScrollFunctions.forEach((t) => t()),
        (this.cancelScrollFunctions = []);
    },
    destroy() {
      this.cleanup();
    },
  }),
  Np = (t = null) => ({
    subscriberCount: 0,
    goal: 0,
    progress: 0,
    amountRaised: 0,
    percentageFormatted: "0%",
    loading: !1,
    error: null,
    visible: !1,
    customGoal: t,
    async init() {
      await this.fetchFundraisingData();
    },
async fetchFundraisingData() {
  try {
    (this.loading = !0), (this.error = null);
    let e = "https://zaiie.netlify.app/api/fundraising";
    this.customGoal && (e += `?goal=${this.customGoal}`);
    const n = await fetch(e);
    if (!n.ok) throw new Error(`HTTP error! status: ${n.status}`);
    const r = await n.json();
    (this.subscriberCount = r.subscriberCount || 0),
      (this.goal = r.goal || 0),
      (this.progress = r.progress || 0),
      (this.amountRaised = r.amountRaised || 0);

    // ✔ NEW: integer percent conversion
    let pct = r.progress || 0;

    // If backend uses 0–1 scale, convert it
    if (pct <= 1) {
      pct = pct * 100;
    }

    pct = Math.round(pct);  

    // Clamp
    if (pct < 0) pct = 0;
    if (pct > 100) pct = 100;

    this.percentageFormatted = pct + "%";

  } catch (e) {
    console.error("Error fetching fundraising data:", e),
      (this.error = e.message || "Failed to fetch fundraising data");
  } finally {
    this.loading = !1;
  }
},
  });
  
function Bp(goalFromLiquid) {
  return {
    goal: goalFromLiquid || 5000,
    // From API
    subscriberCount: 0,
    progress: 0,

    // Visual grid
    filledItems: 0,
    totalItems: 90,
    animationDelay: 125,
    visible: false,

   // Squares grow fill order
    fillOrder: [
      0,1,2,5,13,12,24,23,22,33,32,31,40,39,45,34,35,41,42,
      49,50,51,43,36,26,25,15,16,17,14,6,7,8,9,4,3,47,46,53,
      59,58,57,52,44,37,38,30,29,28,27,19,20,18,21,10,11,54,
      48,55,61,56,62,67,63,68,64,69,76,60,66,65,73,72,79,78,
      71,74,83,80,75,81,85,86,84,87,82,77,70,88,89
    ],

  // Quick lookup map: data-item -> position in order
    orderIndex: {},

    async init() {
      // build index map once
      this.fillOrder.forEach((id, i) => {
        this.orderIndex[id] = i;
      });

      await this.fetchProgress();

      this.$watch("visible", (isVisible) => {
        if (isVisible) {
          this.filledItems = 0;
          this.updateFilledItems();
        }
      });

      this.$watch("subscriberCount", () => {
        if (this.visible) {
          this.updateFilledItems();
        }
      });
    },

async fetchProgress() {
  try {
    let url = "https://zaiie.netlify.app/api/fundraising";
    if (this.goal) {
      url += `?goal=${this.goal}`;
    }

    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    // Values from API
    this.subscriberCount = data.subscriberCount || 0;
    this.goal = data.goal || this.goal;
    this.progress = data.progress || 0;

    // // ----- DEV set Submission value in URL example: '?fakeSubs=3500' -----
    // const params = new URLSearchParams(window.location.search);
    // const fake = params.get("fakeSubs");
    // if (fake !== null) {
    //   this.subscriberCount = parseInt(fake, 10) || 0;
    //   console.log("[DEV] Faking subscriberCount =", this.subscriberCount);
    // }

        // Normalize progress if the API sends 0-100 instead of 0-1
        if (this.progress > 1 && this.progress <= 100) {
          this.progress = this.progress / 100;
        }

        // Clamp progress
        if (this.progress < 0) this.progress = 0;
        if (this.progress > 1) this.progress = 1;
      } catch (err) {
        console.error("Error fetching progress:", err);
      }
    },

    // Maps subscriberCount to how many squares should be filled
computeTargetFilledItems() {
  const count = this.subscriberCount || 0;
  if (count <= 0) return 0;

  // Last square only at full goal
  if (count >= this.goal) return this.totalItems;

  const maxBeforeLast = this.totalItems - 1; // 89 squares max before goal

  // Each of the first 89 squares represents 55 subscribers
  const perSquare = 55;

  // Ceil makes:
  // 1..55  => 1
  // 56..110 => 2
  // 111..165 => 3
  let target = Math.ceil(count / perSquare);

  // Cap so last square only fills on 5000 submissions
  if (target > maxBeforeLast) target = maxBeforeLast;

  return target;
},

    updateFilledItems() {
      const target = this.computeTargetFilledItems();

      // Only animate forwards
      if (target > this.filledItems) {
        this.animateFill(target);
      }
    },

    animateFill(target) {
      const start = this.filledItems;

      for (let i = start; i < target; i++) {
        setTimeout(() => {
          this.filledItems = i + 1;
        }, (i - start) * this.animationDelay);
      }
    },

    isItemFilled(dataItemId) {
      const pos = this.orderIndex[dataItemId];
      return pos !== undefined && pos < this.filledItems;
    },

    getItemFill(dataItemId) {
      if (this.isItemFilled(dataItemId)) return "#cbdb2c";
      return "#79904B";
    },

    getFillFromElement(el) {
      const id = parseInt(el.getAttribute("data-item") || "0", 10);
      return this.getItemFill(id);
    }
  };
}

new Mu({
  containers: ["#swup"],
  plugins: [
    new Vu(),
    new Yu(),
    new $u({ preloadVisibleLinks: !0 }),
    new qu(),
    new Iu(),
    new zu(),
  ],
});
function jp(t) {
  return t === 0 || t === 1
    ? t
    : t < 0.5
    ? 0.5 * Math.pow(2, 20 * t - 10)
    : -0.5 * Math.pow(2, 10 - t * 20) + 1;
}
function La(t) {
  const e = document.getElementById(t.replace("#", ""));
  if (e) {
    const n = t === "main" ? 0 : 65,
      r = e.offsetTop - n;
    wp(window.scrollY, r, {
      duration: 1.2,
      ease: jp,
      onUpdate: (i) => window.scrollTo(0, i),
    });
  }
}
document.addEventListener("click", (t) => {
  const e = t.target.closest("a");
  if (!e) return;
  const n = e.getAttribute("href");
  !n || !n.startsWith("#") || (t.preventDefault(), La(n));
});
et.magic("anchor", () => (t) => La(t));
et.data("newsletter", of);
et.data("shareLinks", af);
et.data("landing", Dp);
et.data("fundraising", Np);
et.data("progress", Bp);
et.plugin(nf);
et.plugin(tf);
et.start();
